/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
//     SourceSHA: 
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { AppRoutes, buildUrl } from "@app/components/React/AppRoutes";
import toast from "react-hot-toast";
import { trackPromise } from 'react-promise-tracker';

export class BaseClient {
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    transformOptions(options: RequestInit): Promise<RequestInit> {
        // var csrfToken = this.getCookie("bp.antiforgery");
        var csrfToken = (document.getElementById('RequestVerificationToken') as any)?.value ?? '';
        // options.redirect = 'manual';
        options.headers = {
            ...options.headers,
            'X-Requested-With': 'XMLHttpRequest',
            'RequestVerificationToken': csrfToken ?? ''
            // 'RequestVerificationToken': (document.getElementById('RequestVerificationToken') as any)?.value ?? ''
        };

        return Promise.resolve<RequestInit>(options);
    }

    transformResult(url: string, response: Response, processor: (response: Response) => Promise<any>): Promise<any> {
        // if (response.status === 302) {
        //     // window.location.assign(response.url);
        //     return Promise.resolve(null);
        // }
        if (response.status === 401 && AppRoutes.publicRoutes().every(route => !window.location.href.toLowerCase().includes(route.toLowerCase()))) {
            location.href = buildUrl(AppRoutes.Login, { returnUrl: window.location.pathname + window.location.search });
            return Promise.resolve(null);
        }
        // if (response.status === 401 || response.status === 403) {
        //     toast.error("Unauthorized.", { duration: 4000, position: 'top-center' });
        //     // Optionally, you could redirect to a login page here
        //     // return Promise.reject(new Error("Unauthorized"));
        //     return processor(response).catch(err => {
        //         console.error(`Error processing response from ${url}:`, err);
        //         // toast.error(`Error processing response from ${url}: ${err.message}`);
        //         // return Promise.reject(err);
        //     });

        //     // Handle unauthorized access
        // }
        return processor(response);
    }
}

export class AccountClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    login(request: LoginRequest): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogin(_response));
        })
    ) // trackPromise end
    }

    protected processLogin(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(null as any);
    }

    loginWith2fa(request: Login2faRequest): Promise<Login2faResponse> {
        let url_ = this.baseUrl + "/api/account/login-2fa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoginWith2fa(_response));
        })
    ) // trackPromise end
    }

    protected processLoginWith2fa(response: Response): Promise<Login2faResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Login2faResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Login2faResponse>(null as any);
    }

    loginWithRecoveryCode(request: LoginRecoveryRequest): Promise<LoginRecoveryResponse> {
        let url_ = this.baseUrl + "/api/account/login-recovery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoginWithRecoveryCode(_response));
        })
    ) // trackPromise end
    }

    protected processLoginWithRecoveryCode(response: Response): Promise<LoginRecoveryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginRecoveryResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginRecoveryResponse>(null as any);
    }

    register(request: RegisterRequest): Promise<RegisterResponse> {
        let url_ = this.baseUrl + "/api/account/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRegister(_response));
        })
    ) // trackPromise end
    }

    protected processRegister(response: Response): Promise<RegisterResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegisterResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterResponse>(null as any);
    }

    logout(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogout(_response));
        })
    ) // trackPromise end
    }

    protected processLogout(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    forgotPassword(request: ForgotPasswordRequest): Promise<ForgotPasswordResponse> {
        let url_ = this.baseUrl + "/api/account/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForgotPassword(_response));
        })
    ) // trackPromise end
    }

    protected processForgotPassword(response: Response): Promise<ForgotPasswordResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForgotPasswordResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForgotPasswordResponse>(null as any);
    }

    resetPassword(request: ResetPasswordRequest): Promise<ResetPasswordResponse> {
        let url_ = this.baseUrl + "/api/account/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetPassword(_response));
        })
    ) // trackPromise end
    }

    protected processResetPassword(response: Response): Promise<ResetPasswordResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResetPasswordResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResetPasswordResponse>(null as any);
    }

    getCurrentUser(): Promise<CurrentUserResponse> {
        let url_ = this.baseUrl + "/api/account/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCurrentUser(_response));
        })
    ) // trackPromise end
    }

    protected processGetCurrentUser(response: Response): Promise<CurrentUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrentUserResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentUserResponse>(null as any);
    }

    resendEmailConfirmation(request: ResendEmailConfirmationRequest): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/account/resend-email-confirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResendEmailConfirmation(_response));
        })
    ) // trackPromise end
    }

    protected processResendEmailConfirmation(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    getAppInfo(): Promise<AppInfoResponse> {
        let url_ = this.baseUrl + "/api/account/app-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAppInfo(_response));
        })
    ) // trackPromise end
    }

    protected processGetAppInfo(response: Response): Promise<AppInfoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppInfoResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppInfoResponse>(null as any);
    }
}

export class AccountManageClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProfile(): Promise<UserProfileResponse> {
        let url_ = this.baseUrl + "/api/account/manage/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProfile(_response));
        })
    ) // trackPromise end
    }

    protected processGetProfile(response: Response): Promise<UserProfileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfileResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileResponse>(null as any);
    }

    updateProfile(request: UserProfileUpdateRequest): Promise<UserProfileUpdateResponse> {
        let url_ = this.baseUrl + "/api/account/manage/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateProfile(_response));
        })
    ) // trackPromise end
    }

    protected processUpdateProfile(response: Response): Promise<UserProfileUpdateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfileUpdateResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileUpdateResponse>(null as any);
    }

    changePassword(request: ChangePasswordRequest): Promise<ChangePasswordResponse> {
        let url_ = this.baseUrl + "/api/account/manage/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangePassword(_response));
        })
    ) // trackPromise end
    }

    protected processChangePassword(response: Response): Promise<ChangePasswordResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangePasswordResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangePasswordResponse>(null as any);
    }

    setPassword(request: SetPasswordRequest): Promise<SetPasswordResponse> {
        let url_ = this.baseUrl + "/api/account/manage/set-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetPassword(_response));
        })
    ) // trackPromise end
    }

    protected processSetPassword(response: Response): Promise<SetPasswordResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetPasswordResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetPasswordResponse>(null as any);
    }

    getEmail(): Promise<UserEmailResponse> {
        let url_ = this.baseUrl + "/api/account/manage/email";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmail(_response));
        })
    ) // trackPromise end
    }

    protected processGetEmail(response: Response): Promise<UserEmailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserEmailResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserEmailResponse>(null as any);
    }

    changeEmail(request: ChangeEmailRequest): Promise<ChangeEmailResponse> {
        let url_ = this.baseUrl + "/api/account/manage/change-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangeEmail(_response));
        })
    ) // trackPromise end
    }

    protected processChangeEmail(response: Response): Promise<ChangeEmailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangeEmailResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeEmailResponse>(null as any);
    }

    getTwoFactorInfo(): Promise<TwoFactorResponse> {
        let url_ = this.baseUrl + "/api/account/manage/two-factor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTwoFactorInfo(_response));
        })
    ) // trackPromise end
    }

    protected processGetTwoFactorInfo(response: Response): Promise<TwoFactorResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TwoFactorResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TwoFactorResponse>(null as any);
    }

    disable2fa(): Promise<Disable2faResponse> {
        let url_ = this.baseUrl + "/api/account/manage/disable-2fa";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDisable2fa(_response));
        })
    ) // trackPromise end
    }

    protected processDisable2fa(response: Response): Promise<Disable2faResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Disable2faResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Disable2faResponse>(null as any);
    }

    forgetBrowser(): Promise<TwoFactorResponse> {
        let url_ = this.baseUrl + "/api/account/manage/forget-browser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForgetBrowser(_response));
        })
    ) // trackPromise end
    }

    protected processForgetBrowser(response: Response): Promise<TwoFactorResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TwoFactorResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TwoFactorResponse>(null as any);
    }

    getAuthenticatorSetup(): Promise<AuthenticatorSetupResponse> {
        let url_ = this.baseUrl + "/api/account/manage/authenticator-setup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAuthenticatorSetup(_response));
        })
    ) // trackPromise end
    }

    protected processGetAuthenticatorSetup(response: Response): Promise<AuthenticatorSetupResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthenticatorSetupResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticatorSetupResponse>(null as any);
    }

    enableAuthenticator(request: EnableAuthenticatorRequest): Promise<EnableAuthenticatorResponse> {
        let url_ = this.baseUrl + "/api/account/manage/enable-authenticator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEnableAuthenticator(_response));
        })
    ) // trackPromise end
    }

    protected processEnableAuthenticator(response: Response): Promise<EnableAuthenticatorResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnableAuthenticatorResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnableAuthenticatorResponse>(null as any);
    }

    resetAuthenticator(): Promise<ResetAuthenticatorResponse> {
        let url_ = this.baseUrl + "/api/account/manage/reset-authenticator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetAuthenticator(_response));
        })
    ) // trackPromise end
    }

    protected processResetAuthenticator(response: Response): Promise<ResetAuthenticatorResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResetAuthenticatorResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResetAuthenticatorResponse>(null as any);
    }

    generateRecoveryCodes(): Promise<GenerateRecoveryCodesResponse> {
        let url_ = this.baseUrl + "/api/account/manage/generate-recovery-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateRecoveryCodes(_response));
        })
    ) // trackPromise end
    }

    protected processGenerateRecoveryCodes(response: Response): Promise<GenerateRecoveryCodesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenerateRecoveryCodesResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateRecoveryCodesResponse>(null as any);
    }

    getPersonalData(): Promise<PersonalDataResponse> {
        let url_ = this.baseUrl + "/api/account/manage/personal-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonalData(_response));
        })
    ) // trackPromise end
    }

    protected processGetPersonalData(response: Response): Promise<PersonalDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonalDataResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonalDataResponse>(null as any);
    }

    downloadPersonalData(): Promise<DownloadPersonalDataResponse> {
        let url_ = this.baseUrl + "/api/account/manage/download-personal-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadPersonalData(_response));
        })
    ) // trackPromise end
    }

    protected processDownloadPersonalData(response: Response): Promise<DownloadPersonalDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadPersonalDataResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadPersonalDataResponse>(null as any);
    }

    deletePersonalData(request: DeletePersonalDataRequest): Promise<DeletePersonalDataResponse> {
        let url_ = this.baseUrl + "/api/account/manage/delete-personal-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePersonalData(_response));
        })
    ) // trackPromise end
    }

    protected processDeletePersonalData(response: Response): Promise<DeletePersonalDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeletePersonalDataResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeletePersonalDataResponse>(null as any);
    }
}

export class BrutusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    calcBrutus(brutusJob: BrutusJob): Promise<BrutusJobResponse> {
        let url_ = this.baseUrl + "/api/b43r45/brutus/calculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(brutusJob);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCalcBrutus(_response));
        })
    ) // trackPromise end
    }

    protected processCalcBrutus(response: Response): Promise<BrutusJobResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrutusJobResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrutusJobResponse>(null as any);
    }

    calcFamilialSearch(brutusJob: FamilialSearchJob): Promise<FamilialSearchJobResponse> {
        let url_ = this.baseUrl + "/api/b43r45/brutus/familial-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(brutusJob);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCalcFamilialSearch(_response));
        })
    ) // trackPromise end
    }

    protected processCalcFamilialSearch(response: Response): Promise<FamilialSearchJobResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FamilialSearchJobResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FamilialSearchJobResponse>(null as any);
    }
}

export class CaseClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(labId: number): Promise<CaseGetAllResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        })
    ) // trackPromise end
    }

    protected processGetAll(response: Response): Promise<CaseGetAllResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseGetAllResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseGetAllResponse>(null as any);
    }

    create(labId: number, model: CaseCreateModel): Promise<CaseCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        })
    ) // trackPromise end
    }

    protected processCreate(response: Response): Promise<CaseCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseCreateResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BPBadRequestResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseCreateResponseModel>(null as any);
    }

    getAllQualityControlCases(labId: number): Promise<CaseGetAllQualityCheckResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/qual-control-cases";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllQualityControlCases(_response));
        })
    ) // trackPromise end
    }

    protected processGetAllQualityControlCases(response: Response): Promise<CaseGetAllQualityCheckResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseGetAllQualityCheckResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseGetAllQualityCheckResponse>(null as any);
    }

    getCaseBasicInfo(labId: number, caseId: number): Promise<CaseBasicInfoModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/basic";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCaseBasicInfo(_response));
        })
    ) // trackPromise end
    }

    protected processGetCaseBasicInfo(response: Response): Promise<CaseBasicInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseBasicInfoModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseBasicInfoModel>(null as any);
    }

    updateBasicInfo(labId: number, caseId: number, model: CaseUpdateBasicInfoModel): Promise<void> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/basic";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateBasicInfo(_response));
        })
    ) // trackPromise end
    }

    protected processUpdateBasicInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BPBadRequestResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCaseDetail(labId: number, caseId: number): Promise<CaseDetailModelWithUrls> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCaseDetail(_response));
        })
    ) // trackPromise end
    }

    protected processGetCaseDetail(response: Response): Promise<CaseDetailModelWithUrls> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDetailModelWithUrls;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseDetailModelWithUrls>(null as any);
    }

    delete(labId: number, caseId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        })
    ) // trackPromise end
    }

    protected processDelete(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createDaily(labId: number): Promise<CaseCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/daily";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDaily(_response));
        })
    ) // trackPromise end
    }

    protected processCreateDaily(response: Response): Promise<CaseCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseCreateResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BPBadRequestResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseCreateResponseModel>(null as any);
    }

    getKitMarkers(labId: number, caseId: number): Promise<EvidenceKitMarkerModel[]> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/kit-markers";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKitMarkers(_response));
        })
    ) // trackPromise end
    }

    protected processGetKitMarkers(response: Response): Promise<EvidenceKitMarkerModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceKitMarkerModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceKitMarkerModel[]>(null as any);
    }

    createCustomPanel(request: PopulationCreateCustomRequest, labId: string, caseId: string): Promise<PopulationCreateCustomResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/custom-panels";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCustomPanel(_response));
        })
    ) // trackPromise end
    }

    protected processCreateCustomPanel(response: Response): Promise<PopulationCreateCustomResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulationCreateCustomResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BPBadRequestResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PopulationCreateCustomResponse>(null as any);
    }

    updateCustomPanel(request: PopulationUpdateCustomRequest, labId: string, caseId: string, panelId: string): Promise<PopulationUpdateCustomResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/custom-panels/{panelId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (panelId === undefined || panelId === null)
            throw new globalThis.Error("The parameter 'panelId' must be defined.");
        url_ = url_.replace("{panelId}", encodeURIComponent("" + panelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCustomPanel(_response));
        })
    ) // trackPromise end
    }

    protected processUpdateCustomPanel(response: Response): Promise<PopulationUpdateCustomResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulationUpdateCustomResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BPBadRequestResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PopulationUpdateCustomResponse>(null as any);
    }

    getCaseKits(labId: number, caseId: number): Promise<KitModel[]> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/kits";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCaseKits(_response));
        })
    ) // trackPromise end
    }

    protected processGetCaseKits(response: Response): Promise<KitModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitModel[]>(null as any);
    }
}

export class CaseRunClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createBrutus(labId: number, caseId: number, model: BrutusCaseRunCreateModel): Promise<CaseRunCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/create/brutus";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateBrutus(_response));
        })
    ) // trackPromise end
    }

    protected processCreateBrutus(response: Response): Promise<CaseRunCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCreateResponseModel>(null as any);
    }

    cloneBrutus(labId: number, caseId: number, caseRunId: number): Promise<BrutusCaseRunCreateModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/clone-brutus";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloneBrutus(_response));
        })
    ) // trackPromise end
    }

    protected processCloneBrutus(response: Response): Promise<BrutusCaseRunCreateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrutusCaseRunCreateModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrutusCaseRunCreateModel>(null as any);
    }

    getBrutusRuns(labId: number, caseId: number, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchText: string | null | undefined): Promise<DataTableResultOfBrutusCaseRunModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/brutus?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBrutusRuns(_response));
        })
    ) // trackPromise end
    }

    protected processGetBrutusRuns(response: Response): Promise<DataTableResultOfBrutusCaseRunModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfBrutusCaseRunModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfBrutusCaseRunModel>(null as any);
    }

    createCalculate(labId: number, caseId: number, caseRunId: number, runType: string, model: CaseRunCalculateModel): Promise<CaseRunCalculateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/calculate/{runType}/create";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (runType === undefined || runType === null)
            throw new globalThis.Error("The parameter 'runType' must be defined.");
        url_ = url_.replace("{runType}", encodeURIComponent("" + runType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCalculate(_response));
        })
    ) // trackPromise end
    }

    protected processCreateCalculate(response: Response): Promise<CaseRunCalculateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCalculateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCalculateResponseModel>(null as any);
    }

    getEmptyCalculate(labId: number, caseId: number, caseRunId: number, runType: string): Promise<CaseRunCalculateModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/calculate/{runType}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (runType === undefined || runType === null)
            throw new globalThis.Error("The parameter 'runType' must be defined.");
        url_ = url_.replace("{runType}", encodeURIComponent("" + runType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmptyCalculate(_response));
        })
    ) // trackPromise end
    }

    protected processGetEmptyCalculate(response: Response): Promise<CaseRunCalculateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCalculateModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCalculateModel>(null as any);
    }

    getCalculationDetails(labId: number, caseId: number, caseRunId: number, calculationId: number): Promise<CaseRunCalculateDetailModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/calculation/{calculationId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (calculationId === undefined || calculationId === null)
            throw new globalThis.Error("The parameter 'calculationId' must be defined.");
        url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCalculationDetails(_response));
        })
    ) // trackPromise end
    }

    protected processGetCalculationDetails(response: Response): Promise<CaseRunCalculateDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCalculateDetailModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCalculateDetailModel>(null as any);
    }

    deleteCalculation(labId: number, caseId: number, caseRunId: number, calculationId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/calculation/{calculationId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (calculationId === undefined || calculationId === null)
            throw new globalThis.Error("The parameter 'calculationId' must be defined.");
        url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteCalculation(_response));
        })
    ) // trackPromise end
    }

    protected processDeleteCalculation(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    restoreCalculation(labId: number, caseId: number, caseRunId: number, calculationId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/calculation/{calculationId}/restore";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (calculationId === undefined || calculationId === null)
            throw new globalThis.Error("The parameter 'calculationId' must be defined.");
        url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestoreCalculation(_response));
        })
    ) // trackPromise end
    }

    protected processRestoreCalculation(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getCalculations(labId: number, caseId: number, caseRunId: number, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, showInactive: boolean | undefined): Promise<DataTableResultOfCalculateInfoModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/calculations?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (showInactive === null)
            throw new globalThis.Error("The parameter 'showInactive' cannot be null.");
        else if (showInactive !== undefined)
            url_ += "showInactive=" + encodeURIComponent("" + showInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCalculations(_response));
        })
    ) // trackPromise end
    }

    protected processGetCalculations(response: Response): Promise<DataTableResultOfCalculateInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfCalculateInfoModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfCalculateInfoModel>(null as any);
    }

    createDeconvMain(labId: number, caseId: number, model: DeconvMainCaseRunCreateModel): Promise<CaseRunCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/create/deconv_main";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDeconvMain(_response));
        })
    ) // trackPromise end
    }

    protected processCreateDeconvMain(response: Response): Promise<CaseRunCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCreateResponseModel>(null as any);
    }

    createMaxlrAic(labId: number, caseId: number, model: CaseRunCreateModel): Promise<CaseRunCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/create/maxlr_aic";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMaxlrAic(_response));
        })
    ) // trackPromise end
    }

    protected processCreateMaxlrAic(response: Response): Promise<CaseRunCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCreateResponseModel>(null as any);
    }

    createNonContrAnalysis(labId: number, caseId: number, model: CaseRunCreateModelBase): Promise<CaseRunCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/create/non_contr_analysis";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateNonContrAnalysis(_response));
        })
    ) // trackPromise end
    }

    protected processCreateNonContrAnalysis(response: Response): Promise<CaseRunCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCreateResponseModel>(null as any);
    }

    createGenerateSample(labId: number, caseId: number, model: GenerateSampleCaseRunCreateModel): Promise<CaseRunCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/create/gen_sample";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateGenerateSample(_response));
        })
    ) // trackPromise end
    }

    protected processCreateGenerateSample(response: Response): Promise<CaseRunCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCreateResponseModel>(null as any);
    }

    updateNotes(labId: number, caseId: number, caseRunId: number, model: CaseRunNotesUpdateModel): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/description";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateNotes(_response));
        })
    ) // trackPromise end
    }

    protected processUpdateNotes(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    detail(labId: number, caseId: number, caseRunId: number): Promise<CaseRunDetailResponseWithUrls> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/detail";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetail(_response));
        })
    ) // trackPromise end
    }

    protected processDetail(response: Response): Promise<CaseRunDetailResponseWithUrls> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunDetailResponseWithUrls;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunDetailResponseWithUrls>(null as any);
    }

    results(labId: number, caseId: number, caseRunId: number): Promise<CaseRunDetailResponseWithUrls> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/results";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResults(_response));
        })
    ) // trackPromise end
    }

    protected processResults(response: Response): Promise<CaseRunDetailResponseWithUrls> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunDetailResponseWithUrls;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunDetailResponseWithUrls>(null as any);
    }

    reportTexts(labId: number, caseId: number, caseRunId: number, reportType: LabReportsTextsType | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/results/report-texts?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (reportType === null)
            throw new globalThis.Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReportTexts(_response));
        })
    ) // trackPromise end
    }

    protected processReportTexts(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    delete(labId: number, caseId: number, caseRunId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        })
    ) // trackPromise end
    }

    protected processDelete(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    cloneAicData(labId: number, caseId: number, caseRunId: number): Promise<MaxLrCaseRunCreateModelBase> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/clone/aic";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloneAicData(_response));
        })
    ) // trackPromise end
    }

    protected processCloneAicData(response: Response): Promise<MaxLrCaseRunCreateModelBase> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaxLrCaseRunCreateModelBase;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaxLrCaseRunCreateModelBase>(null as any);
    }

    cloneData(labId: number, caseId: number, caseRunId: number): Promise<MaxLrCaseRunCreateModelBase> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/clone";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloneData(_response));
        })
    ) // trackPromise end
    }

    protected processCloneData(response: Response): Promise<MaxLrCaseRunCreateModelBase> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaxLrCaseRunCreateModelBase;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaxLrCaseRunCreateModelBase>(null as any);
    }

    new(labId: number, caseId: number, runType: string, evidenceId: number | null | undefined, ednaTestId: number | null | undefined): Promise<CaseRunCreateModelBase> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/new/{runType}?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (runType === undefined || runType === null)
            throw new globalThis.Error("The parameter 'runType' must be defined.");
        url_ = url_.replace("{runType}", encodeURIComponent("" + runType));
        if (evidenceId !== undefined && evidenceId !== null)
            url_ += "evidenceId=" + encodeURIComponent("" + evidenceId) + "&";
        if (ednaTestId !== undefined && ednaTestId !== null)
            url_ += "ednaTestId=" + encodeURIComponent("" + ednaTestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNew(_response));
        })
    ) // trackPromise end
    }

    protected processNew(response: Response): Promise<CaseRunCreateModelBase> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCreateModelBase;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCreateModelBase>(null as any);
    }

    getDeconvolutionTable(labId: number, caseId: number, caseRunId: number, format: string): Promise<ProfileSummaryTableModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/deconvolution/pst-{format}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDeconvolutionTable(_response));
        })
    ) // trackPromise end
    }

    protected processGetDeconvolutionTable(response: Response): Promise<ProfileSummaryTableModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileSummaryTableModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileSummaryTableModel>(null as any);
    }

    getMaxLrAicCalculations(labId: number, caseId: number, caseRunId: number, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Promise<DataTableResultOfMaxLrAicCaseRunModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/maxlr_aic_calculations?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMaxLrAicCalculations(_response));
        })
    ) // trackPromise end
    }

    protected processGetMaxLrAicCalculations(response: Response): Promise<DataTableResultOfMaxLrAicCaseRunModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfMaxLrAicCaseRunModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfMaxLrAicCaseRunModel>(null as any);
    }

    getOldAicCalculations(labId: number, caseId: number, caseRunId: number, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Promise<DataTableResultOfAicCaseRunModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/old_aic_calculations?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOldAicCalculations(_response));
        })
    ) // trackPromise end
    }

    protected processGetOldAicCalculations(response: Response): Promise<DataTableResultOfAicCaseRunModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfAicCaseRunModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfAicCaseRunModel>(null as any);
    }

    getPrintDetails(labId: number, caseId: number, caseRunId: number): Promise<CaseRunDetailReadModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/print";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPrintDetails(_response));
        })
    ) // trackPromise end
    }

    protected processGetPrintDetails(response: Response): Promise<CaseRunDetailReadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunDetailReadModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunDetailReadModel>(null as any);
    }

    createFamilialSearch(labId: number, caseId: number, model: FamilialSearchCaseRunCreateModel): Promise<CaseRunCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/create/familial_search";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateFamilialSearch(_response));
        })
    ) // trackPromise end
    }

    protected processCreateFamilialSearch(response: Response): Promise<CaseRunCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCreateResponseModel>(null as any);
    }

    cloneFamilialSearch(labId: number, caseId: number, caseRunId: number): Promise<FamilialSearchCaseRunCreateModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/clone-familial-search";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloneFamilialSearch(_response));
        })
    ) // trackPromise end
    }

    protected processCloneFamilialSearch(response: Response): Promise<FamilialSearchCaseRunCreateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FamilialSearchCaseRunCreateModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FamilialSearchCaseRunCreateModel>(null as any);
    }

    getFamilialSearchResults(labId: number, caseId: number, caseRunId: number, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Promise<DataTableResultOfFamilialSearchResultItemModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/familial_search/pagedata?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFamilialSearchResults(_response));
        })
    ) // trackPromise end
    }

    protected processGetFamilialSearchResults(response: Response): Promise<DataTableResultOfFamilialSearchResultItemModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfFamilialSearchResultItemModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfFamilialSearchResultItemModel>(null as any);
    }

    getFamilialSearchResultDetail(labId: number, caseId: number, caseRunId: number, resultId: string | null | undefined): Promise<FSSystemModel[]> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/familial_search/match-details?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (resultId !== undefined && resultId !== null)
            url_ += "resultId=" + encodeURIComponent("" + resultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFamilialSearchResultDetail(_response));
        })
    ) // trackPromise end
    }

    protected processGetFamilialSearchResultDetail(response: Response): Promise<FSSystemModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FSSystemModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FSSystemModel[]>(null as any);
    }

    getFamilialSearchCaseRuns(labId: number, caseId: number, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchText: string | null | undefined): Promise<DataTableResultOfFamilialSearchCaseRunModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/familial-search?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFamilialSearchCaseRuns(_response));
        })
    ) // trackPromise end
    }

    protected processGetFamilialSearchCaseRuns(response: Response): Promise<DataTableResultOfFamilialSearchCaseRunModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfFamilialSearchCaseRunModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfFamilialSearchCaseRunModel>(null as any);
    }

    getGenSampleResults(labId: number, caseId: number, caseRunId: number): Promise<GenerateSampleJobResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/gen_sample/results";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetGenSampleResults(_response));
        })
    ) // trackPromise end
    }

    protected processGetGenSampleResults(response: Response): Promise<GenerateSampleJobResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenerateSampleJobResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateSampleJobResponse>(null as any);
    }

    getMaxLrCaseRuns(labId: number, caseId: number, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchText: string | null | undefined, runType: string | null | undefined): Promise<DataTableResultOfCaseRunModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/maxlr?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (runType !== undefined && runType !== null)
            url_ += "runType=" + encodeURIComponent("" + runType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMaxLrCaseRuns(_response));
        })
    ) // trackPromise end
    }

    protected processGetMaxLrCaseRuns(response: Response): Promise<DataTableResultOfCaseRunModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfCaseRunModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfCaseRunModel>(null as any);
    }

    createMaxlr(labId: number, caseId: number, model: CaseRunCreateModel): Promise<CaseRunCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/create/maxlr";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMaxlr(_response));
        })
    ) // trackPromise end
    }

    protected processCreateMaxlr(response: Response): Promise<CaseRunCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCreateResponseModel>(null as any);
    }

    createSentry(labId: number, caseId: number, model: DnaMatchCaseRunCreateModel): Promise<CaseRunCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/create/sentry";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSentry(_response));
        })
    ) // trackPromise end
    }

    protected processCreateSentry(response: Response): Promise<CaseRunCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseRunCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseRunCreateResponseModel>(null as any);
    }

    cloneSentry(labId: number, caseId: number, caseRunId: number): Promise<DnaMatchCaseRunCreateModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/clone-sentry";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloneSentry(_response));
        })
    ) // trackPromise end
    }

    protected processCloneSentry(response: Response): Promise<DnaMatchCaseRunCreateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DnaMatchCaseRunCreateModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DnaMatchCaseRunCreateModel>(null as any);
    }

    getSentryResults(labId: number, caseId: number, caseRunId: number, hideInterSampleDeduction: boolean | undefined, deductionCountHomozygOnce: boolean | undefined, showSuspiciousOnly: boolean | undefined, filterBy2P: boolean | undefined, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Promise<DataTableResultOfDnaMatchResultItemModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/sentry/pagedata?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (hideInterSampleDeduction === null)
            throw new globalThis.Error("The parameter 'hideInterSampleDeduction' cannot be null.");
        else if (hideInterSampleDeduction !== undefined)
            url_ += "hideInterSampleDeduction=" + encodeURIComponent("" + hideInterSampleDeduction) + "&";
        if (deductionCountHomozygOnce === null)
            throw new globalThis.Error("The parameter 'deductionCountHomozygOnce' cannot be null.");
        else if (deductionCountHomozygOnce !== undefined)
            url_ += "deductionCountHomozygOnce=" + encodeURIComponent("" + deductionCountHomozygOnce) + "&";
        if (showSuspiciousOnly === null)
            throw new globalThis.Error("The parameter 'showSuspiciousOnly' cannot be null.");
        else if (showSuspiciousOnly !== undefined)
            url_ += "showSuspiciousOnly=" + encodeURIComponent("" + showSuspiciousOnly) + "&";
        if (filterBy2P === null)
            throw new globalThis.Error("The parameter 'filterBy2P' cannot be null.");
        else if (filterBy2P !== undefined)
            url_ += "filterBy2P=" + encodeURIComponent("" + filterBy2P) + "&";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSentryResults(_response));
        })
    ) // trackPromise end
    }

    protected processGetSentryResults(response: Response): Promise<DataTableResultOfDnaMatchResultItemModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfDnaMatchResultItemModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfDnaMatchResultItemModel>(null as any);
    }

    getSentryResultDetail(labId: number, caseId: number, caseRunId: number, resultId: string | null | undefined): Promise<ResultRow[]> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/sentry/match-details?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (resultId !== undefined && resultId !== null)
            url_ += "resultId=" + encodeURIComponent("" + resultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSentryResultDetail(_response));
        })
    ) // trackPromise end
    }

    protected processGetSentryResultDetail(response: Response): Promise<ResultRow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultRow[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultRow[]>(null as any);
    }

    getSentryResultDetailExcel(caseRunId: number, resultId: string | null | undefined, labId: string, caseId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/{caseRunId}/sentry/match-details/excel?";
        if (caseRunId === undefined || caseRunId === null)
            throw new globalThis.Error("The parameter 'caseRunId' must be defined.");
        url_ = url_.replace("{caseRunId}", encodeURIComponent("" + caseRunId));
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (resultId !== undefined && resultId !== null)
            url_ += "resultId=" + encodeURIComponent("" + resultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSentryResultDetailExcel(_response));
        })
    ) // trackPromise end
    }

    protected processGetSentryResultDetailExcel(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSentries(labId: number, caseId: number, referenceId: number | null | undefined, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchText: string | null | undefined): Promise<DataTableResultOfSentryCaseRunModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/run/sentries?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (referenceId !== undefined && referenceId !== null)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSentries(_response));
        })
    ) // trackPromise end
    }

    protected processGetSentries(response: Response): Promise<DataTableResultOfSentryCaseRunModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfSentryCaseRunModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfSentryCaseRunModel>(null as any);
    }
}

export class ConfigClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getEmailSettings(): Promise<EmailSettingsModel> {
        let url_ = this.baseUrl + "/api/config/email";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmailSettings(_response));
        })
    ) // trackPromise end
    }

    protected processGetEmailSettings(response: Response): Promise<EmailSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSettingsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailSettingsModel>(null as any);
    }

    setEmailSettings(model: EmailSettingsModel): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/config/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetEmailSettings(_response));
        })
    ) // trackPromise end
    }

    protected processSetEmailSettings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    sendTestMessage(model: EmailSettingsModel, destEmail: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/config/email/test?";
        if (destEmail !== undefined && destEmail !== null)
            url_ += "destEmail=" + encodeURIComponent("" + destEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendTestMessage(_response));
        })
    ) // trackPromise end
    }

    protected processSendTestMessage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAuditLogs(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchText: string | null | undefined): Promise<DataTableResultOfAuditLogDto> {
        let url_ = this.baseUrl + "/api/config/logs?";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAuditLogs(_response));
        })
    ) // trackPromise end
    }

    protected processGetAuditLogs(response: Response): Promise<DataTableResultOfAuditLogDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfAuditLogDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfAuditLogDto>(null as any);
    }
}

export class EdnaClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createBrutusCaseRun(model: BrutusCaseRunCreateFromEdnaModel): Promise<EdnaResult2> {
        let url_ = this.baseUrl + "/api/Edna/create-brutus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateBrutusCaseRun(_response));
        })
    ) // trackPromise end
    }

    protected processCreateBrutusCaseRun(response: Response): Promise<EdnaResult2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EdnaResult2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EdnaResult2>(null as any);
    }

    getBrutusEdnaPayload(ednaTestId: number): Promise<EdnaPayload> {
        let url_ = this.baseUrl + "/api/Edna/brutus-edna-result/{ednaTestId}";
        if (ednaTestId === undefined || ednaTestId === null)
            throw new globalThis.Error("The parameter 'ednaTestId' must be defined.");
        url_ = url_.replace("{ednaTestId}", encodeURIComponent("" + ednaTestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBrutusEdnaPayload(_response));
        })
    ) // trackPromise end
    }

    protected processGetBrutusEdnaPayload(response: Response): Promise<EdnaPayload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EdnaPayload;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EdnaPayload>(null as any);
    }
}

export class EvidenceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(labId: number, caseId: number): Promise<EvidenceGetAllResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        })
    ) // trackPromise end
    }

    protected processGetAll(response: Response): Promise<EvidenceGetAllResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceGetAllResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceGetAllResponse>(null as any);
    }

    create(labId: number, caseId: number, model: EvidenceCreateModel): Promise<EvidenceCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        })
    ) // trackPromise end
    }

    protected processCreate(response: Response): Promise<EvidenceCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceCreateResponseModel>(null as any);
    }

    getById(labId: number, caseId: number, evidenceId: number): Promise<EvidenceGetByIdResponseWithUrls> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence/{evidenceId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (evidenceId === undefined || evidenceId === null)
            throw new globalThis.Error("The parameter 'evidenceId' must be defined.");
        url_ = url_.replace("{evidenceId}", encodeURIComponent("" + evidenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        })
    ) // trackPromise end
    }

    protected processGetById(response: Response): Promise<EvidenceGetByIdResponseWithUrls> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceGetByIdResponseWithUrls;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceGetByIdResponseWithUrls>(null as any);
    }

    update(labId: number, caseId: number, evidenceId: number, model: EvidenceUpdateModel): Promise<EvidenceUpdatedModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence/{evidenceId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (evidenceId === undefined || evidenceId === null)
            throw new globalThis.Error("The parameter 'evidenceId' must be defined.");
        url_ = url_.replace("{evidenceId}", encodeURIComponent("" + evidenceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        })
    ) // trackPromise end
    }

    protected processUpdate(response: Response): Promise<EvidenceUpdatedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceUpdatedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceUpdatedModel>(null as any);
    }

    createFromExisting(labId: number, caseId: number, evidenceId: number, model: EvidenceCreateFromExistingModel): Promise<EvidenceCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence/{evidenceId}/create-from";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (evidenceId === undefined || evidenceId === null)
            throw new globalThis.Error("The parameter 'evidenceId' must be defined.");
        url_ = url_.replace("{evidenceId}", encodeURIComponent("" + evidenceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateFromExisting(_response));
        })
    ) // trackPromise end
    }

    protected processCreateFromExisting(response: Response): Promise<EvidenceCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceCreateResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BPBadRequestResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceCreateResponseModel>(null as any);
    }

    preview(labId: number, caseId: number, model: EvidenceCreateModel): Promise<EvidenceCreateResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence/preview";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreview(_response));
        })
    ) // trackPromise end
    }

    protected processPreview(response: Response): Promise<EvidenceCreateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceCreateResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceCreateResponse>(null as any);
    }

    delete(labId: number, caseId: number, evidenceId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence/{evidenceId}/delete";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (evidenceId === undefined || evidenceId === null)
            throw new globalThis.Error("The parameter 'evidenceId' must be defined.");
        url_ = url_.replace("{evidenceId}", encodeURIComponent("" + evidenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        })
    ) // trackPromise end
    }

    protected processDelete(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDetails(labId: number, caseId: number, evidenceId: number): Promise<EvidenceDetailsResponseWithUrls> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence/{evidenceId}/detail";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (evidenceId === undefined || evidenceId === null)
            throw new globalThis.Error("The parameter 'evidenceId' must be defined.");
        url_ = url_.replace("{evidenceId}", encodeURIComponent("" + evidenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDetails(_response));
        })
    ) // trackPromise end
    }

    protected processGetDetails(response: Response): Promise<EvidenceDetailsResponseWithUrls> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceDetailsResponseWithUrls;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceDetailsResponseWithUrls>(null as any);
    }

    getForUpload(labId: number, caseId: number): Promise<EvidenceUploadModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence/upload";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetForUpload(_response));
        })
    ) // trackPromise end
    }

    protected processGetForUpload(response: Response): Promise<EvidenceUploadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceUploadModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceUploadModel>(null as any);
    }

    download(labId: number, caseId: number, evidenceId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence/{evidenceId}/download";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (evidenceId === undefined || evidenceId === null)
            throw new globalThis.Error("The parameter 'evidenceId' must be defined.");
        url_ = url_.replace("{evidenceId}", encodeURIComponent("" + evidenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        })
    ) // trackPromise end
    }

    protected processDownload(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getKitMarkers(labId: number, caseId: number, evidenceId: number): Promise<EvidenceKitMarkerModel[]> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence/{evidenceId}/kit-markers";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (evidenceId === undefined || evidenceId === null)
            throw new globalThis.Error("The parameter 'evidenceId' must be defined.");
        url_ = url_.replace("{evidenceId}", encodeURIComponent("" + evidenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKitMarkers(_response));
        })
    ) // trackPromise end
    }

    protected processGetKitMarkers(response: Response): Promise<EvidenceKitMarkerModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceKitMarkerModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceKitMarkerModel[]>(null as any);
    }

    import(labId: number, caseId: number, model: EvidenceImportRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/evidence/import";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        })
    ) // trackPromise end
    }

    protected processImport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class KitClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchValue: string | null | undefined): Promise<DataTableResultOfKitModel> {
        let url_ = this.baseUrl + "/api/kits?";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        })
    ) // trackPromise end
    }

    protected processGetAll(response: Response): Promise<DataTableResultOfKitModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfKitModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfKitModel>(null as any);
    }

    get(id: number): Promise<KitDetailModel> {
        let url_ = this.baseUrl + "/api/kits/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        })
    ) // trackPromise end
    }

    protected processGet(response: Response): Promise<KitDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitDetailModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitDetailModel>(null as any);
    }

    updateKit(id: number, model: KitEditModel): Promise<KitEditModel> {
        let url_ = this.baseUrl + "/api/kits/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateKit(_response));
        })
    ) // trackPromise end
    }

    protected processUpdateKit(response: Response): Promise<KitEditModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitEditModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitEditModel>(null as any);
    }

    getKitMarkers(kitId: number): Promise<EvidenceKitMarkerModel[]> {
        let url_ = this.baseUrl + "/api/kits/{kitId}/kit-markers";
        if (kitId === undefined || kitId === null)
            throw new globalThis.Error("The parameter 'kitId' must be defined.");
        url_ = url_.replace("{kitId}", encodeURIComponent("" + kitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKitMarkers(_response));
        })
    ) // trackPromise end
    }

    protected processGetKitMarkers(response: Response): Promise<EvidenceKitMarkerModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceKitMarkerModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceKitMarkerModel[]>(null as any);
    }
}

export class KitPopulationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllForCase(labId: number, caseId: number): Promise<KitPopulationModel2[]> {
        let url_ = this.baseUrl + "/api/population/lab/{labId}/case/{caseId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllForCase(_response));
        })
    ) // trackPromise end
    }

    protected processGetAllForCase(response: Response): Promise<KitPopulationModel2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitPopulationModel2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitPopulationModel2[]>(null as any);
    }

    getAllForLab(labId: number): Promise<KitPopulationModel2[]> {
        let url_ = this.baseUrl + "/api/population/lab/{labId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllForLab(_response));
        })
    ) // trackPromise end
    }

    protected processGetAllForLab(response: Response): Promise<KitPopulationModel2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitPopulationModel2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitPopulationModel2[]>(null as any);
    }

    get(populationId: number): Promise<PopulationGetByIdResponse> {
        let url_ = this.baseUrl + "/api/population/{populationId}";
        if (populationId === undefined || populationId === null)
            throw new globalThis.Error("The parameter 'populationId' must be defined.");
        url_ = url_.replace("{populationId}", encodeURIComponent("" + populationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        })
    ) // trackPromise end
    }

    protected processGet(response: Response): Promise<PopulationGetByIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulationGetByIdResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PopulationGetByIdResponse>(null as any);
    }

    getPopulationDetails(populationId: number): Promise<GetPopulationDetailsResponse> {
        let url_ = this.baseUrl + "/api/population/{populationId}/details";
        if (populationId === undefined || populationId === null)
            throw new globalThis.Error("The parameter 'populationId' must be defined.");
        url_ = url_.replace("{populationId}", encodeURIComponent("" + populationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPopulationDetails(_response));
        })
    ) // trackPromise end
    }

    protected processGetPopulationDetails(response: Response): Promise<GetPopulationDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPopulationDetailsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPopulationDetailsResponse>(null as any);
    }

    create(model: KitPopulationCreateModel): Promise<KitPopulationCreateResponseModel> {
        let url_ = this.baseUrl + "/api/population";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        })
    ) // trackPromise end
    }

    protected processCreate(response: Response): Promise<KitPopulationCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitPopulationCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitPopulationCreateResponseModel>(null as any);
    }

    update(id: number, model: KitPopulationEditModel): Promise<PopulationUpdateResponse> {
        let url_ = this.baseUrl + "/api/population/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        })
    ) // trackPromise end
    }

    protected processUpdate(response: Response): Promise<PopulationUpdateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulationUpdateResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PopulationUpdateResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/population/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        })
    ) // trackPromise end
    }

    protected processDelete(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createLocal(request: PopulationCreateLocalRequest): Promise<KitPopulationCreateResponseModel> {
        let url_ = this.baseUrl + "/api/population/create-local";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateLocal(_response));
        })
    ) // trackPromise end
    }

    protected processCreateLocal(response: Response): Promise<KitPopulationCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitPopulationCreateResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitPopulationCreateResponseModel>(null as any);
    }

    restore(kitPopulationId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/population/{kitPopulationId}/restore";
        if (kitPopulationId === undefined || kitPopulationId === null)
            throw new globalThis.Error("The parameter 'kitPopulationId' must be defined.");
        url_ = url_.replace("{kitPopulationId}", encodeURIComponent("" + kitPopulationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestore(_response));
        })
    ) // trackPromise end
    }

    protected processRestore(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    download(kitPopulationId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/population/{kitPopulationId}/download";
        if (kitPopulationId === undefined || kitPopulationId === null)
            throw new globalThis.Error("The parameter 'kitPopulationId' must be defined.");
        url_ = url_.replace("{kitPopulationId}", encodeURIComponent("" + kitPopulationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        })
    ) // trackPromise end
    }

    protected processDownload(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    pageData(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchValue: string | null | undefined, showInactive: boolean | undefined): Promise<DataTableResultOfPopulationSearchResultModel> {
        let url_ = this.baseUrl + "/api/population/pagedata?";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (showInactive === null)
            throw new globalThis.Error("The parameter 'showInactive' cannot be null.");
        else if (showInactive !== undefined)
            url_ += "showInactive=" + encodeURIComponent("" + showInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPageData(_response));
        })
    ) // trackPromise end
    }

    protected processPageData(response: Response): Promise<DataTableResultOfPopulationSearchResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfPopulationSearchResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfPopulationSearchResultModel>(null as any);
    }
}

export class LabClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUsageByDay(labId: number, dateRange: NamedDateRange, from: Date | null | undefined, to: Date | null | undefined): Promise<LabUsageModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/usage/{dateRange}?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (dateRange === undefined || dateRange === null)
            throw new globalThis.Error("The parameter 'dateRange' must be defined.");
        url_ = url_.replace("{dateRange}", encodeURIComponent("" + dateRange));
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsageByDay(_response));
        })
    ) // trackPromise end
    }

    protected processGetUsageByDay(response: Response): Promise<LabUsageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabUsageModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabUsageModel>(null as any);
    }

    update(labId: number, model: LabEditFullModel): Promise<LabEditResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        })
    ) // trackPromise end
    }

    protected processUpdate(response: Response): Promise<LabEditResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabEditResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabEditResponseModel>(null as any);
    }

    get(labId: number): Promise<LabEditFullModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        })
    ) // trackPromise end
    }

    protected processGet(response: Response): Promise<LabEditFullModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabEditFullModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabEditFullModel>(null as any);
    }

    create(model: LabCreateModel): Promise<LabCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        })
    ) // trackPromise end
    }

    protected processCreate(response: Response): Promise<LabCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabCreateResponseModel>(null as any);
    }

    getAll(): Promise<LabGetAllResponse> {
        let url_ = this.baseUrl + "/api/lab";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        })
    ) // trackPromise end
    }

    protected processGetAll(response: Response): Promise<LabGetAllResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabGetAllResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabGetAllResponse>(null as any);
    }

    getLabAgencies(labId: number, showInactive: boolean | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Promise<AgenciesGetAllResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/agencies?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (showInactive === null)
            throw new globalThis.Error("The parameter 'showInactive' cannot be null.");
        else if (showInactive !== undefined)
            url_ += "showInactive=" + encodeURIComponent("" + showInactive) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLabAgencies(_response));
        })
    ) // trackPromise end
    }

    protected processGetLabAgencies(response: Response): Promise<AgenciesGetAllResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgenciesGetAllResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgenciesGetAllResponse>(null as any);
    }

    createLabAgency(labId: number, agency: AgencyCreateModel): Promise<LabAgencyCreateResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/agencies";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agency);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateLabAgency(_response));
        })
    ) // trackPromise end
    }

    protected processCreateLabAgency(response: Response): Promise<LabAgencyCreateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabAgencyCreateResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabAgencyCreateResponse>(null as any);
    }

    updateLabAgency(labId: number, agencyId: number, agency: AgencyCreateModel): Promise<LabAgencyCreateResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/agencies/{agencyId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (agencyId === undefined || agencyId === null)
            throw new globalThis.Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agency);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateLabAgency(_response));
        })
    ) // trackPromise end
    }

    protected processUpdateLabAgency(response: Response): Promise<LabAgencyCreateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabAgencyCreateResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabAgencyCreateResponse>(null as any);
    }

    getLabAgency(labId: number, agencyId: number): Promise<AgencyGetByIdResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/agencies/{agencyId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (agencyId === undefined || agencyId === null)
            throw new globalThis.Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLabAgency(_response));
        })
    ) // trackPromise end
    }

    protected processGetLabAgency(response: Response): Promise<AgencyGetByIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgencyGetByIdResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgencyGetByIdResponse>(null as any);
    }

    activateLabAgency(labId: number, agencyId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/lab/{labId}/agencies/{agencyId}/active";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (agencyId === undefined || agencyId === null)
            throw new globalThis.Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivateLabAgency(_response));
        })
    ) // trackPromise end
    }

    protected processActivateLabAgency(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    inactivateLabAgency(labId: number, agencyId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/lab/{labId}/agencies/{agencyId}/inactive";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (agencyId === undefined || agencyId === null)
            throw new globalThis.Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInactivateLabAgency(_response));
        })
    ) // trackPromise end
    }

    protected processInactivateLabAgency(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeLabAgencyData(labId: number, agencyId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/lab/{labId}/agencies/{agencyId}/data";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (agencyId === undefined || agencyId === null)
            throw new globalThis.Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveLabAgencyData(_response));
        })
    ) // trackPromise end
    }

    protected processRemoveLabAgencyData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadLabDropInData(labId: number, file: FileModel): Promise<void> {
        let url_ = this.baseUrl + "/api/lab/{labId}/drop-in-data";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadLabDropInData(_response));
        })
    ) // trackPromise end
    }

    protected processUploadLabDropInData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteLabDropInData(labId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/lab/{labId}/drop-in-data";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteLabDropInData(_response));
        })
    ) // trackPromise end
    }

    protected processDeleteLabDropInData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLabDropInData(labId: number): Promise<DropInDataViewModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/drop-in-data";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLabDropInData(_response));
        })
    ) // trackPromise end
    }

    protected processGetLabDropInData(response: Response): Promise<DropInDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DropInDataViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropInDataViewModel>(null as any);
    }

    calculateDropIn(labId: number, detectionThreshold: number): Promise<CalculateLambdaResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/drop-in-data/calc-delta";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(detectionThreshold);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCalculateDropIn(_response));
        })
    ) // trackPromise end
    }

    protected processCalculateDropIn(response: Response): Promise<CalculateLambdaResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalculateLambdaResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateLambdaResponse>(null as any);
    }

    uploadReportTemplate(labId: number, file: FileModel): Promise<void> {
        let url_ = this.baseUrl + "/api/lab/{labId}/report-template";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadReportTemplate(_response));
        })
    ) // trackPromise end
    }

    protected processUploadReportTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteReportTemplate(labId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/lab/{labId}/report-template";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteReportTemplate(_response));
        })
    ) // trackPromise end
    }

    protected processDeleteReportTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getReportTemplate(labId: number): Promise<ReportTemplateResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/report-template";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReportTemplate(_response));
        })
    ) // trackPromise end
    }

    protected processGetReportTemplate(response: Response): Promise<ReportTemplateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportTemplateResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportTemplateResponse>(null as any);
    }

    getReportTextsTemplate(labId: number): Promise<GetLabReportTextsTemplateResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/report-texts-template";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReportTextsTemplate(_response));
        })
    ) // trackPromise end
    }

    protected processGetReportTextsTemplate(response: Response): Promise<GetLabReportTextsTemplateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLabReportTextsTemplateResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLabReportTextsTemplateResponse>(null as any);
    }

    getReportTextsTemplatePreview(labId: number, template: string | null | undefined, reportType: LabReportsTextsType | undefined): Promise<GetLabReportTextsTemplatePreviewResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/report-texts-template-preview?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (template !== undefined && template !== null)
            url_ += "template=" + encodeURIComponent("" + template) + "&";
        if (reportType === null)
            throw new globalThis.Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReportTextsTemplatePreview(_response));
        })
    ) // trackPromise end
    }

    protected processGetReportTextsTemplatePreview(response: Response): Promise<GetLabReportTextsTemplatePreviewResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLabReportTextsTemplatePreviewResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLabReportTextsTemplatePreviewResponse>(null as any);
    }

    getPrintingOptions(labId: number): Promise<LabCaseRunPrintOptionsModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/printing-options";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPrintingOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetPrintingOptions(response: Response): Promise<LabCaseRunPrintOptionsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabCaseRunPrintOptionsModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabCaseRunPrintOptionsModel>(null as any);
    }

    disable(labId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/disable";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDisable(_response));
        })
    ) // trackPromise end
    }

    protected processDisable(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    enable(labId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/enable";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEnable(_response));
        })
    ) // trackPromise end
    }

    protected processEnable(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    pageData(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, showInactive: boolean | undefined, searchValue: string | null | undefined): Promise<DataTableResultOfLabModel> {
        let url_ = this.baseUrl + "/api/lab/pagedata?";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (showInactive === null)
            throw new globalThis.Error("The parameter 'showInactive' cannot be null.");
        else if (showInactive !== undefined)
            url_ += "showInactive=" + encodeURIComponent("" + showInactive) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPageData(_response));
        })
    ) // trackPromise end
    }

    protected processPageData(response: Response): Promise<DataTableResultOfLabModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfLabModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfLabModel>(null as any);
    }

    getAlleleFormats(labId: number): Promise<AlleleFormat[]> {
        let url_ = this.baseUrl + "/api/lab/{labId}/allele-formats";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAlleleFormats(_response));
        })
    ) // trackPromise end
    }

    protected processGetAlleleFormats(response: Response): Promise<AlleleFormat[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlleleFormat[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlleleFormat[]>(null as any);
    }

    getKitMarkerSettings(labId: number, kitId: number): Promise<LabMarkerSettingsModel[]> {
        let url_ = this.baseUrl + "/api/lab/{labId}/kit/{kitId}/defaults";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (kitId === undefined || kitId === null)
            throw new globalThis.Error("The parameter 'kitId' must be defined.");
        url_ = url_.replace("{kitId}", encodeURIComponent("" + kitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKitMarkerSettings(_response));
        })
    ) // trackPromise end
    }

    protected processGetKitMarkerSettings(response: Response): Promise<LabMarkerSettingsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabMarkerSettingsModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabMarkerSettingsModel[]>(null as any);
    }

    setKitMarkerSettings(labId: number, kitId: number, markers: LabMarkerSettingsSaveModel[]): Promise<void> {
        let url_ = this.baseUrl + "/api/lab/{labId}/kit/{kitId}/defaults";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (kitId === undefined || kitId === null)
            throw new globalThis.Error("The parameter 'kitId' must be defined.");
        url_ = url_.replace("{kitId}", encodeURIComponent("" + kitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(markers);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetKitMarkerSettings(_response));
        })
    ) // trackPromise end
    }

    protected processSetKitMarkerSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllImportableSamples(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchValue: string | null | undefined, labId: number): Promise<DataTableResultOfSampleReadModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/importable-samples?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllImportableSamples(_response));
        })
    ) // trackPromise end
    }

    protected processGetAllImportableSamples(response: Response): Promise<DataTableResultOfSampleReadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfSampleReadModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfSampleReadModel>(null as any);
    }

    getAllImportableEvidence(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchValue: string | null | undefined, labId: number): Promise<DataTableResultOfEvidenceReadModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/importable-evidence?";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllImportableEvidence(_response));
        })
    ) // trackPromise end
    }

    protected processGetAllImportableEvidence(response: Response): Promise<DataTableResultOfEvidenceReadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfEvidenceReadModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfEvidenceReadModel>(null as any);
    }
}

export class LabJobClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getById(labJobId: string): Promise<LabJobReadModel> {
        let url_ = this.baseUrl + "/api/labjob/{labJobId}";
        if (labJobId === undefined || labJobId === null)
            throw new globalThis.Error("The parameter 'labJobId' must be defined.");
        url_ = url_.replace("{labJobId}", encodeURIComponent("" + labJobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        })
    ) // trackPromise end
    }

    protected processGetById(response: Response): Promise<LabJobReadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabJobReadModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabJobReadModel>(null as any);
    }

    setJobStatus(status: JobStatus): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/labjob/job-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(status);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetJobStatus(_response));
        })
    ) // trackPromise end
    }

    protected processSetJobStatus(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getJob(jobId: string): Promise<LabJobDownloadModel> {
        let url_ = this.baseUrl + "/api/labjob/external/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJob(_response));
        })
    ) // trackPromise end
    }

    protected processGetJob(response: Response): Promise<LabJobDownloadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabJobDownloadModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabJobDownloadModel>(null as any);
    }

    taskStarted(labJobId: string, phase: string, model: TaskStartedRequestModel): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/labjob/{labJobId}/tasks/{phase}/started";
        if (labJobId === undefined || labJobId === null)
            throw new globalThis.Error("The parameter 'labJobId' must be defined.");
        url_ = url_.replace("{labJobId}", encodeURIComponent("" + labJobId));
        if (phase === undefined || phase === null)
            throw new globalThis.Error("The parameter 'phase' must be defined.");
        url_ = url_.replace("{phase}", encodeURIComponent("" + phase));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskStarted(_response));
        })
    ) // trackPromise end
    }

    protected processTaskStarted(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    taskFailed(labJobId: string, phase: string, model: TaskFailedRequestModel): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/labjob/{labJobId}/tasks/{phase}/failed";
        if (labJobId === undefined || labJobId === null)
            throw new globalThis.Error("The parameter 'labJobId' must be defined.");
        url_ = url_.replace("{labJobId}", encodeURIComponent("" + labJobId));
        if (phase === undefined || phase === null)
            throw new globalThis.Error("The parameter 'phase' must be defined.");
        url_ = url_.replace("{phase}", encodeURIComponent("" + phase));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskFailed(_response));
        })
    ) // trackPromise end
    }

    protected processTaskFailed(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    taskCompleted(labJobId: string, taskId: string, model: LabJobTaskCompletedRequestModel): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/labjob/{labJobId}/tasks/{taskId}/completed";
        if (labJobId === undefined || labJobId === null)
            throw new globalThis.Error("The parameter 'labJobId' must be defined.");
        url_ = url_.replace("{labJobId}", encodeURIComponent("" + labJobId));
        if (taskId === undefined || taskId === null)
            throw new globalThis.Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskCompleted(_response));
        })
    ) // trackPromise end
    }

    protected processTaskCompleted(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    addLogsToTask(labJobId: string, taskId: string, model: LabJobTaskAddLogsRequestModel): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/labjob/{labJobId}/tasks/{taskId}/logs";
        if (labJobId === undefined || labJobId === null)
            throw new globalThis.Error("The parameter 'labJobId' must be defined.");
        url_ = url_.replace("{labJobId}", encodeURIComponent("" + labJobId));
        if (taskId === undefined || taskId === null)
            throw new globalThis.Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddLogsToTask(_response));
        })
    ) // trackPromise end
    }

    protected processAddLogsToTask(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    markQueued(labJobId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/labjob/{labJobId}/queued";
        if (labJobId === undefined || labJobId === null)
            throw new globalThis.Error("The parameter 'labJobId' must be defined.");
        url_ = url_.replace("{labJobId}", encodeURIComponent("" + labJobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMarkQueued(_response));
        })
    ) // trackPromise end
    }

    protected processMarkQueued(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    cancel(labJobId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/labjob/{labJobId}/cancel";
        if (labJobId === undefined || labJobId === null)
            throw new globalThis.Error("The parameter 'labJobId' must be defined.");
        url_ = url_.replace("{labJobId}", encodeURIComponent("" + labJobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancel(_response));
        })
    ) // trackPromise end
    }

    protected processCancel(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    finalize(labJobId: string, payload: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/labjob/{labJobId}/finalize";
        if (labJobId === undefined || labJobId === null)
            throw new globalThis.Error("The parameter 'labJobId' must be defined.");
        url_ = url_.replace("{labJobId}", encodeURIComponent("" + labJobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFinalize(_response));
        })
    ) // trackPromise end
    }

    protected processFinalize(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class LabKitClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(labId: number): Promise<KitModel[]> {
        let url_ = this.baseUrl + "/api/lab/{labId}/kit";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        })
    ) // trackPromise end
    }

    protected processGetAll(response: Response): Promise<KitModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitModel[]>(null as any);
    }

    post(model: KitCreateModel, labId: string): Promise<KitEditModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/kit";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        })
    ) // trackPromise end
    }

    protected processPost(response: Response): Promise<KitEditModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitEditModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitEditModel>(null as any);
    }

    get(id: number, labId: string): Promise<KitEditModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/kit/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        })
    ) // trackPromise end
    }

    protected processGet(response: Response): Promise<KitEditModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitEditModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitEditModel>(null as any);
    }

    put(id: number, model: KitEditModel, labId: string): Promise<KitEditModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/kit/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        })
    ) // trackPromise end
    }

    protected processPut(response: Response): Promise<KitEditModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitEditModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitEditModel>(null as any);
    }

    delete(id: number, labId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/kit/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        })
    ) // trackPromise end
    }

    protected processDelete(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSystems(kitId: number, labId: number): Promise<KitSystemsModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/kit/{kitId}/systems";
        if (kitId === undefined || kitId === null)
            throw new globalThis.Error("The parameter 'kitId' must be defined.");
        url_ = url_.replace("{kitId}", encodeURIComponent("" + kitId));
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSystems(_response));
        })
    ) // trackPromise end
    }

    protected processGetSystems(response: Response): Promise<KitSystemsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitSystemsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitSystemsModel>(null as any);
    }
}

export class LocalStorageClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(path: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/local-storage/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        })
    ) // trackPromise end
    }

    protected processGet(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class NSwagGenerDummyClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    index(): Promise<RunTypeParametersModel> {
        let url_ = this.baseUrl + "/api/NSwagGenerDummy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIndex(_response));
        })
    ) // trackPromise end
    }

    protected processIndex(response: Response): Promise<RunTypeParametersModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RunTypeParametersModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RunTypeParametersModel>(null as any);
    }

    constants(): Promise<ConstantsModel> {
        let url_ = this.baseUrl + "/api/NSwagGenerDummy/constants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConstants(_response));
        })
    ) // trackPromise end
    }

    protected processConstants(response: Response): Promise<ConstantsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConstantsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConstantsModel>(null as any);
    }
}

export class ProfilesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllSamples(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchValue: string | null | undefined, labId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined): Promise<DataTableResultOfSampleReadModel> {
        let url_ = this.baseUrl + "/api/profiles/samples?";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (labId !== undefined && labId !== null)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllSamples(_response));
        })
    ) // trackPromise end
    }

    protected processGetAllSamples(response: Response): Promise<DataTableResultOfSampleReadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfSampleReadModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfSampleReadModel>(null as any);
    }

    createSample(labId: number | undefined, caseId: number | null | undefined, model: SampleCreateModel): Promise<SampleCreateResponseModel> {
        let url_ = this.baseUrl + "/api/profiles/samples?";
        if (labId === null)
            throw new globalThis.Error("The parameter 'labId' cannot be null.");
        else if (labId !== undefined)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSample(_response));
        })
    ) // trackPromise end
    }

    protected processCreateSample(response: Response): Promise<SampleCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleCreateResponseModel>(null as any);
    }

    getAllEvidence(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchValue: string | null | undefined, labId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined): Promise<DataTableResultOfEvidenceReadModel> {
        let url_ = this.baseUrl + "/api/profiles/evidence?";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (labId !== undefined && labId !== null)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllEvidence(_response));
        })
    ) // trackPromise end
    }

    protected processGetAllEvidence(response: Response): Promise<DataTableResultOfEvidenceReadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfEvidenceReadModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfEvidenceReadModel>(null as any);
    }

    createEvidence(labId: number | undefined, caseId: number | null | undefined, model: EvidenceCreateModel): Promise<EvidenceCreateResponseModel> {
        let url_ = this.baseUrl + "/api/profiles/evidence?";
        if (labId === null)
            throw new globalThis.Error("The parameter 'labId' cannot be null.");
        else if (labId !== undefined)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateEvidence(_response));
        })
    ) // trackPromise end
    }

    protected processCreateEvidence(response: Response): Promise<EvidenceCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceCreateResponseModel>(null as any);
    }

    getAllProfiles(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchValue: string | null | undefined, labId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, hideEvid: boolean | null | undefined, hideRef: boolean | null | undefined): Promise<DataTableResultOfProfileReadModel> {
        let url_ = this.baseUrl + "/api/profiles/combined?";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (labId !== undefined && labId !== null)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (hideEvid !== undefined && hideEvid !== null)
            url_ += "hideEvid=" + encodeURIComponent("" + hideEvid) + "&";
        if (hideRef !== undefined && hideRef !== null)
            url_ += "hideRef=" + encodeURIComponent("" + hideRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllProfiles(_response));
        })
    ) // trackPromise end
    }

    protected processGetAllProfiles(response: Response): Promise<DataTableResultOfProfileReadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfProfileReadModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfProfileReadModel>(null as any);
    }

    previewSample(labId: number | undefined, model: SampleCreateModel): Promise<SampleCreateResponse> {
        let url_ = this.baseUrl + "/api/profiles/samples/preview?";
        if (labId === null)
            throw new globalThis.Error("The parameter 'labId' cannot be null.");
        else if (labId !== undefined)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreviewSample(_response));
        })
    ) // trackPromise end
    }

    protected processPreviewSample(response: Response): Promise<SampleCreateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleCreateResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleCreateResponse>(null as any);
    }

    parse(model: SampleCreateModel): Promise<SampleParseResponse> {
        let url_ = this.baseUrl + "/api/profiles/parse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processParse(_response));
        })
    ) // trackPromise end
    }

    protected processParse(response: Response): Promise<SampleParseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleParseResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleParseResponse>(null as any);
    }

    calculateSampleRMP(sampleId: number, request: CalcRMPRequest): Promise<CalcRMPResponse> {
        let url_ = this.baseUrl + "/api/profiles/samples/{sampleId}/calc-rmp";
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCalculateSampleRMP(_response));
        })
    ) // trackPromise end
    }

    protected processCalculateSampleRMP(response: Response): Promise<CalcRMPResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalcRMPResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalcRMPResponse>(null as any);
    }

    previewEvidence(labId: number | undefined, model: EvidenceCreateModel): Promise<EvidenceCreateResponse> {
        let url_ = this.baseUrl + "/api/profiles/evidence/preview?";
        if (labId === null)
            throw new globalThis.Error("The parameter 'labId' cannot be null.");
        else if (labId !== undefined)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreviewEvidence(_response));
        })
    ) // trackPromise end
    }

    protected processPreviewEvidence(response: Response): Promise<EvidenceCreateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvidenceCreateResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvidenceCreateResponse>(null as any);
    }
}

export class QueriesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCases(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchValue: string | null | undefined, sampleSearch: boolean | undefined, withQualityCheck: boolean | undefined, labId: number | null | undefined): Promise<DataTableResultOfCaseModel> {
        let url_ = this.baseUrl + "/api/queries/cases?";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (sampleSearch === null)
            throw new globalThis.Error("The parameter 'sampleSearch' cannot be null.");
        else if (sampleSearch !== undefined)
            url_ += "sampleSearch=" + encodeURIComponent("" + sampleSearch) + "&";
        if (withQualityCheck === null)
            throw new globalThis.Error("The parameter 'withQualityCheck' cannot be null.");
        else if (withQualityCheck !== undefined)
            url_ += "withQualityCheck=" + encodeURIComponent("" + withQualityCheck) + "&";
        if (labId !== undefined && labId !== null)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCases(_response));
        })
    ) // trackPromise end
    }

    protected processGetCases(response: Response): Promise<DataTableResultOfCaseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfCaseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfCaseModel>(null as any);
    }

    getUserRecentCasesAndRuns(): Promise<GetUserRecentCasesAndRunsResponse> {
        let url_ = this.baseUrl + "/api/queries/recent-cases-runs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserRecentCasesAndRuns(_response));
        })
    ) // trackPromise end
    }

    protected processGetUserRecentCasesAndRuns(response: Response): Promise<GetUserRecentCasesAndRunsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetUserRecentCasesAndRunsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUserRecentCasesAndRunsResponse>(null as any);
    }

    getSettings(): Promise<SettingsModel> {
        let url_ = this.baseUrl + "/api/queries/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSettings(_response));
        })
    ) // trackPromise end
    }

    protected processGetSettings(response: Response): Promise<SettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SettingsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingsModel>(null as any);
    }

    getFamilialSearchRuns(labId: number | null | undefined, caseId: number | null | undefined, referenceId: number | null | undefined, dailyOnly: boolean | null | undefined, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchText: string | null | undefined): Promise<DataTableResultOfFamilialSearchCaseRunModel> {
        let url_ = this.baseUrl + "/api/queries/familial-search-runs?";
        if (labId !== undefined && labId !== null)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (referenceId !== undefined && referenceId !== null)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (dailyOnly !== undefined && dailyOnly !== null)
            url_ += "dailyOnly=" + encodeURIComponent("" + dailyOnly) + "&";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFamilialSearchRuns(_response));
        })
    ) // trackPromise end
    }

    protected processGetFamilialSearchRuns(response: Response): Promise<DataTableResultOfFamilialSearchCaseRunModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfFamilialSearchCaseRunModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfFamilialSearchCaseRunModel>(null as any);
    }

    getSentrySearchRuns(labId: number | null | undefined, caseId: number | null | undefined, referenceId: number | null | undefined, dailyOnly: boolean | null | undefined, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchText: string | null | undefined): Promise<DataTableResultOfSentryCaseRunModel> {
        let url_ = this.baseUrl + "/api/queries/sentry-search-runs?";
        if (labId !== undefined && labId !== null)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (referenceId !== undefined && referenceId !== null)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (dailyOnly !== undefined && dailyOnly !== null)
            url_ += "dailyOnly=" + encodeURIComponent("" + dailyOnly) + "&";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSentrySearchRuns(_response));
        })
    ) // trackPromise end
    }

    protected processGetSentrySearchRuns(response: Response): Promise<DataTableResultOfSentryCaseRunModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfSentryCaseRunModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfSentryCaseRunModel>(null as any);
    }

    getAllLabs(): Promise<LabGetAllResponse> {
        let url_ = this.baseUrl + "/api/queries/labs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllLabs(_response));
        })
    ) // trackPromise end
    }

    protected processGetAllLabs(response: Response): Promise<LabGetAllResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabGetAllResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabGetAllResponse>(null as any);
    }

    getKits(): Promise<KitModel[]> {
        let url_ = this.baseUrl + "/api/queries/kits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKits(_response));
        })
    ) // trackPromise end
    }

    protected processGetKits(response: Response): Promise<KitModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitModel[]>(null as any);
    }

    getKitMarkers(kitId: number): Promise<KitSystemsModel> {
        let url_ = this.baseUrl + "/api/queries/kits/{kitId}/markers";
        if (kitId === undefined || kitId === null)
            throw new globalThis.Error("The parameter 'kitId' must be defined.");
        url_ = url_.replace("{kitId}", encodeURIComponent("" + kitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKitMarkers(_response));
        })
    ) // trackPromise end
    }

    protected processGetKitMarkers(response: Response): Promise<KitSystemsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KitSystemsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KitSystemsModel>(null as any);
    }

    getDistinctMarkers(): Promise<DistinctMarkersModel> {
        let url_ = this.baseUrl + "/api/queries/distinct-markers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDistinctMarkers(_response));
        })
    ) // trackPromise end
    }

    protected processGetDistinctMarkers(response: Response): Promise<DistinctMarkersModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DistinctMarkersModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DistinctMarkersModel>(null as any);
    }

    getAlleleFormats(labId: number): Promise<AlleleFormat[]> {
        let url_ = this.baseUrl + "/api/queries/labs/{labId}/allele-formats";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAlleleFormats(_response));
        })
    ) // trackPromise end
    }

    protected processGetAlleleFormats(response: Response): Promise<AlleleFormat[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlleleFormat[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlleleFormat[]>(null as any);
    }

    getEnabledAlleleFormats(): Promise<AlleleFormat[]> {
        let url_ = this.baseUrl + "/api/queries/enabled-allele-formats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEnabledAlleleFormats(_response));
        })
    ) // trackPromise end
    }

    protected processGetEnabledAlleleFormats(response: Response): Promise<AlleleFormat[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlleleFormat[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlleleFormat[]>(null as any);
    }

    getMe2(): Promise<MeModel> {
        let url_ = this.baseUrl + "/api/queries/me2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMe2(_response));
        })
    ) // trackPromise end
    }

    protected processGetMe2(response: Response): Promise<MeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MeModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeModel>(null as any);
    }
}

export class RoleClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Promise<RoleModel[]> {
        let url_ = this.baseUrl + "/api/role";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        })
    ) // trackPromise end
    }

    protected processGetAll(response: Response): Promise<RoleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModel[]>(null as any);
    }

    create(roleModel: RoleCreateModel): Promise<RoleModel> {
        let url_ = this.baseUrl + "/api/role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        })
    ) // trackPromise end
    }

    protected processCreate(response: Response): Promise<RoleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModel>(null as any);
    }

    getAllPermissions(): Promise<RolePermissionModel[]> {
        let url_ = this.baseUrl + "/api/role/all-permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllPermissions(_response));
        })
    ) // trackPromise end
    }

    protected processGetAllPermissions(response: Response): Promise<RolePermissionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolePermissionModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolePermissionModel[]>(null as any);
    }

    updatePermissions(roleId: string, permissions: string[]): Promise<RoleModel> {
        let url_ = this.baseUrl + "/api/role/{roleId}/permissions";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePermissions(_response));
        })
    ) // trackPromise end
    }

    protected processUpdatePermissions(response: Response): Promise<RoleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModel>(null as any);
    }

    delete(id: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/role/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        })
    ) // trackPromise end
    }

    protected processDelete(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class RunTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(includeDisabled: boolean | undefined): Promise<RunTypeGetAllResponse> {
        let url_ = this.baseUrl + "/api/run-type?";
        if (includeDisabled === null)
            throw new globalThis.Error("The parameter 'includeDisabled' cannot be null.");
        else if (includeDisabled !== undefined)
            url_ += "includeDisabled=" + encodeURIComponent("" + includeDisabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        })
    ) // trackPromise end
    }

    protected processGetAll(response: Response): Promise<RunTypeGetAllResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RunTypeGetAllResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RunTypeGetAllResponse>(null as any);
    }

    getChildren(runType: string): Promise<RunTypeGetChildrenResponse> {
        let url_ = this.baseUrl + "/api/run-type/{runType}/children";
        if (runType === undefined || runType === null)
            throw new globalThis.Error("The parameter 'runType' must be defined.");
        url_ = url_.replace("{runType}", encodeURIComponent("" + runType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChildren(_response));
        })
    ) // trackPromise end
    }

    protected processGetChildren(response: Response): Promise<RunTypeGetChildrenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RunTypeGetChildrenResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RunTypeGetChildrenResponse>(null as any);
    }
}

export class SampleClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getById(labId: number, caseId: number, sampleId: number): Promise<SampleGetByIdResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/sample/{sampleId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        })
    ) // trackPromise end
    }

    protected processGetById(response: Response): Promise<SampleGetByIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleGetByIdResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleGetByIdResponse>(null as any);
    }

    update(labId: number, caseId: number, sampleId: number, model: SampleUpdateRequest): Promise<SampleUpdatedModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/sample/{sampleId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        })
    ) // trackPromise end
    }

    protected processUpdate(response: Response): Promise<SampleUpdatedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleUpdatedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleUpdatedModel>(null as any);
    }

    create(labId: number, caseId: number, model: SampleCreateModel): Promise<SampleCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/sample";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        })
    ) // trackPromise end
    }

    protected processCreate(response: Response): Promise<SampleCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleCreateResponseModel>(null as any);
    }

    createKeyboard(labId: number, caseId: number, model: SampleCreateKeyboardModel): Promise<SampleCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/sample";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateKeyboard(_response));
        })
    ) // trackPromise end
    }

    protected processCreateKeyboard(response: Response): Promise<SampleCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleCreateResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleCreateResponseModel>(null as any);
    }

    preview(labId: number, caseId: number, model: SampleCreateModel): Promise<SampleCreateResponse> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/sample/preview";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreview(_response));
        })
    ) // trackPromise end
    }

    protected processPreview(response: Response): Promise<SampleCreateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleCreateResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleCreateResponse>(null as any);
    }

    createFromExisting(labId: number, caseId: number, sampleId: number, model: SampleCreateFromExistingModel): Promise<SampleCreateResponseModel> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/sample/{sampleId}/create-from";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateFromExisting(_response));
        })
    ) // trackPromise end
    }

    protected processCreateFromExisting(response: Response): Promise<SampleCreateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleCreateResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BPBadRequestResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleCreateResponseModel>(null as any);
    }

    download(labId: number, caseId: number, sampleId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/sample/{sampleId}/download";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        })
    ) // trackPromise end
    }

    protected processDownload(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDetails(labId: number, caseId: number, sampleId: number): Promise<SampleDetailsResponseWithUrls> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/sample/{sampleId}/detail";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDetails(_response));
        })
    ) // trackPromise end
    }

    protected processGetDetails(response: Response): Promise<SampleDetailsResponseWithUrls> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDetailsResponseWithUrls;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDetailsResponseWithUrls>(null as any);
    }

    delete(labId: number, caseId: number, sampleId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/sample/{sampleId}/delete";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        })
    ) // trackPromise end
    }

    protected processDelete(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    restore(labId: number, caseId: number, sampleId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/sample/{sampleId}/restore";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestore(_response));
        })
    ) // trackPromise end
    }

    protected processRestore(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(labId: number, caseId: number, model: SampleImportRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/lab/{labId}/case/{caseId}/sample/import";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        })
    ) // trackPromise end
    }

    protected processImport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class TimeZonesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<TimeZoneGroup[]> {
        let url_ = this.baseUrl + "/api/timezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        })
    ) // trackPromise end
    }

    protected processGet(response: Response): Promise<TimeZoneGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimeZoneGroup[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeZoneGroup[]>(null as any);
    }

    getTimeZone(id: string): Promise<TimeZone> {
        let url_ = this.baseUrl + "/api/timezones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTimeZone(_response));
        })
    ) // trackPromise end
    }

    protected processGetTimeZone(response: Response): Promise<TimeZone> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimeZone;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeZone>(null as any);
    }
}

export class TranslationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    clear(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/translation/clear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClear(_response));
        })
    ) // trackPromise end
    }

    protected processClear(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getLocales(): Promise<SupportedLocale[]> {
        let url_ = this.baseUrl + "/api/translation/locales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLocales(_response));
        })
    ) // trackPromise end
    }

    protected processGetLocales(response: Response): Promise<SupportedLocale[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportedLocale[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportedLocale[]>(null as any);
    }

    getLocale(): Promise<CurrentLocale> {
        let url_ = this.baseUrl + "/api/translation/locale";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLocale(_response));
        })
    ) // trackPromise end
    }

    protected processGetLocale(response: Response): Promise<CurrentLocale> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrentLocale;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentLocale>(null as any);
    }

    getTranslation(locale: string | null | undefined): Promise<ClientResources> {
        let url_ = this.baseUrl + "/api/translation?";
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranslation(_response));
        })
    ) // trackPromise end
    }

    protected processGetTranslation(response: Response): Promise<ClientResources> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientResources;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientResources>(null as any);
    }
}

export class UserClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    search(term: string | null | undefined): Promise<UserSearchResponse> {
        let url_ = this.baseUrl + "/api/user/search?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        })
    ) // trackPromise end
    }

    protected processSearch(response: Response): Promise<UserSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSearchResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSearchResponse>(null as any);
    }

    get(id: string): Promise<UserDetailModel> {
        let url_ = this.baseUrl + "/api/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        })
    ) // trackPromise end
    }

    protected processGet(response: Response): Promise<UserDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDetailModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailModel>(null as any);
    }

    update(id: string, model: UserEditModel): Promise<UserEditResponseModel> {
        let url_ = this.baseUrl + "/api/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        })
    ) // trackPromise end
    }

    protected processUpdate(response: Response): Promise<UserEditResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserEditResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserEditResponseModel>(null as any);
    }

    disable2fa(id: string): Promise<Disable2faResponse> {
        let url_ = this.baseUrl + "/api/user/{id}/disable-2fa";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDisable2fa(_response));
        })
    ) // trackPromise end
    }

    protected processDisable2fa(response: Response): Promise<Disable2faResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Disable2faResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Disable2faResponse>(null as any);
    }

    create(model: CreateUserModel): Promise<CreateUserResponseModel> {
        let url_ = this.baseUrl + "/api/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        })
    ) // trackPromise end
    }

    protected processCreate(response: Response): Promise<CreateUserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateUserResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateUserResponseModel>(null as any);
    }

    pageData(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, inactive: boolean | undefined, searchValue: string | null | undefined, labId: number | null | undefined): Promise<DataTableResultOfUserGridModel> {
        let url_ = this.baseUrl + "/api/user/pagedata?";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (inactive === null)
            throw new globalThis.Error("The parameter 'inactive' cannot be null.");
        else if (inactive !== undefined)
            url_ += "inactive=" + encodeURIComponent("" + inactive) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (labId !== undefined && labId !== null)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPageData(_response));
        })
    ) // trackPromise end
    }

    protected processPageData(response: Response): Promise<DataTableResultOfUserGridModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfUserGridModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfUserGridModel>(null as any);
    }

    resendEmail(userId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/user/{userId}/resend-email";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResendEmail(_response));
        })
    ) // trackPromise end
    }

    protected processResendEmail(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    disable(userId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/user/{userId}/disable";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDisable(_response));
        })
    ) // trackPromise end
    }

    protected processDisable(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    enable(userId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/user/{userId}/enable";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEnable(_response));
        })
    ) // trackPromise end
    }

    protected processEnable(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    changePassword(model: ChangePasswordModel): Promise<ChangePasswordResponseModel> {
        let url_ = this.baseUrl + "/api/user/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangePassword(_response));
        })
    ) // trackPromise end
    }

    protected processChangePassword(response: Response): Promise<ChangePasswordResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangePasswordResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BPBadRequestResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangePasswordResponseModel>(null as any);
    }

    getTwoFactorSharedKey(): Promise<TwoFactorSetupModel> {
        let url_ = this.baseUrl + "/api/user/twofactor-getsharedkey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTwoFactorSharedKey(_response));
        })
    ) // trackPromise end
    }

    protected processGetTwoFactorSharedKey(response: Response): Promise<TwoFactorSetupModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TwoFactorSetupModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TwoFactorSetupModel>(null as any);
    }
}

export class WorkQueueClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    heartbeat(worker: string, job: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/workqueue/{worker}/heartbeat/{job}";
        if (worker === undefined || worker === null)
            throw new globalThis.Error("The parameter 'worker' must be defined.");
        url_ = url_.replace("{worker}", encodeURIComponent("" + worker));
        if (job === undefined || job === null)
            throw new globalThis.Error("The parameter 'job' must be defined.");
        url_ = url_.replace("{job}", encodeURIComponent("" + job));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHeartbeat(_response));
        })
    ) // trackPromise end
    }

    protected processHeartbeat(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getNext(worker: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/workqueue/{worker}";
        if (worker === undefined || worker === null)
            throw new globalThis.Error("The parameter 'worker' must be defined.");
        url_ = url_.replace("{worker}", encodeURIComponent("" + worker));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNext(_response));
        })
    ) // trackPromise end
    }

    protected processGetNext(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    post(worker: string, response: JobResponse): Promise<void> {
        let url_ = this.baseUrl + "/api/workqueue/{worker}";
        if (worker === undefined || worker === null)
            throw new globalThis.Error("The parameter 'worker' must be defined.");
        url_ = url_.replace("{worker}", encodeURIComponent("" + worker));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(response);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        })
    ) // trackPromise end
    }

    protected processPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    detail(workQueueId: string): Promise<WorkQueueItemDetailModel> {
        let url_ = this.baseUrl + "/api/workqueue/{workQueueId}/detail";
        if (workQueueId === undefined || workQueueId === null)
            throw new globalThis.Error("The parameter 'workQueueId' must be defined.");
        url_ = url_.replace("{workQueueId}", encodeURIComponent("" + workQueueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetail(_response));
        })
    ) // trackPromise end
    }

    protected processDetail(response: Response): Promise<WorkQueueItemDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkQueueItemDetailModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkQueueItemDetailModel>(null as any);
    }

    page(labId: number | null | undefined, perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, runType: string | null | undefined, status: string | null | undefined, searchValue: string | null | undefined): Promise<DataTableResultOfWorkQueueItemModel> {
        let url_ = this.baseUrl + "/api/workqueue/page?";
        if (labId !== undefined && labId !== null)
            url_ += "labId=" + encodeURIComponent("" + labId) + "&";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (runType !== undefined && runType !== null)
            url_ += "runType=" + encodeURIComponent("" + runType) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPage(_response));
        })
    ) // trackPromise end
    }

    protected processPage(response: Response): Promise<DataTableResultOfWorkQueueItemModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfWorkQueueItemModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfWorkQueueItemModel>(null as any);
    }

    areWorkersEnabled(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/workqueue/workers-enabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAreWorkersEnabled(_response));
        })
    ) // trackPromise end
    }

    protected processAreWorkersEnabled(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getWorkers(): Promise<WorkersAndTasksModel> {
        let url_ = this.baseUrl + "/api/workqueue/workers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkers(_response));
        })
    ) // trackPromise end
    }

    protected processGetWorkers(response: Response): Promise<WorkersAndTasksModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkersAndTasksModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkersAndTasksModel>(null as any);
    }

    revokeTask(taskId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/workqueue/revoke-task/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new globalThis.Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRevokeTask(_response));
        })
    ) // trackPromise end
    }

    protected processRevokeTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getWorkerNodes(): Promise<NodeUsageSummary[]> {
        let url_ = this.baseUrl + "/api/workqueue/worker-nodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkerNodes(_response));
        })
    ) // trackPromise end
    }

    protected processGetWorkerNodes(response: Response): Promise<NodeUsageSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NodeUsageSummary[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NodeUsageSummary[]>(null as any);
    }

    restartWorker(workerName: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/workqueue/workers/{workerName}/restart";
        if (workerName === undefined || workerName === null)
            throw new globalThis.Error("The parameter 'workerName' must be defined.");
        url_ = url_.replace("{workerName}", encodeURIComponent("" + workerName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestartWorker(_response));
        })
    ) // trackPromise end
    }

    protected processRestartWorker(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class EnrollmentsLookupClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSexOptions(): Promise<SexDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/sex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSexOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetSexOptions(response: Response): Promise<SexDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SexDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SexDto[]>(null as any);
    }

    getEyeColorOptions(): Promise<EyeColorDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/eye-color";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEyeColorOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetEyeColorOptions(response: Response): Promise<EyeColorDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EyeColorDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EyeColorDto[]>(null as any);
    }

    getHairColorOptions(): Promise<HairColorDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/hair-color";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHairColorOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetHairColorOptions(response: Response): Promise<HairColorDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HairColorDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HairColorDto[]>(null as any);
    }

    getPhoneTypeOptions(): Promise<PhoneTypeDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/phone-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPhoneTypeOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetPhoneTypeOptions(response: Response): Promise<PhoneTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PhoneTypeDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhoneTypeDto[]>(null as any);
    }

    getIdTypeOptions(): Promise<IdTypeDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/id-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIdTypeOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetIdTypeOptions(response: Response): Promise<IdTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdTypeDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdTypeDto[]>(null as any);
    }

    getFeatureTypeOptions(): Promise<FeatureTypeDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/feature-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFeatureTypeOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetFeatureTypeOptions(response: Response): Promise<FeatureTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureTypeDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureTypeDto[]>(null as any);
    }

    getEnrollmentPurposeOptions(): Promise<EnrollmentPurposeDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/enrollment-purpose";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEnrollmentPurposeOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetEnrollmentPurposeOptions(response: Response): Promise<EnrollmentPurposeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnrollmentPurposeDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnrollmentPurposeDto[]>(null as any);
    }

    getEthnicityOptions(): Promise<EthnicityDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/ethnicity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEthnicityOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetEthnicityOptions(response: Response): Promise<EthnicityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EthnicityDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EthnicityDto[]>(null as any);
    }

    getCityOptions(countryId: number | null | undefined, stateId: number | null | undefined, nameStartsWith: string | null | undefined): Promise<CityDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/city?";
        if (countryId !== undefined && countryId !== null)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (stateId !== undefined && stateId !== null)
            url_ += "stateId=" + encodeURIComponent("" + stateId) + "&";
        if (nameStartsWith !== undefined && nameStartsWith !== null)
            url_ += "nameStartsWith=" + encodeURIComponent("" + nameStartsWith) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCityOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetCityOptions(response: Response): Promise<CityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CityDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityDto[]>(null as any);
    }

    getStateOptions(countryId: number | undefined): Promise<StateDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/state?";
        if (countryId === null)
            throw new globalThis.Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStateOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetStateOptions(response: Response): Promise<StateDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StateDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StateDto[]>(null as any);
    }

    getCountryOptions(): Promise<CountryDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/country";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCountryOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetCountryOptions(response: Response): Promise<CountryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDto[]>(null as any);
    }

    getAddressTypeOptions(): Promise<AddressTypeDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/addressType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAddressTypeOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetAddressTypeOptions(response: Response): Promise<AddressTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressTypeDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressTypeDto[]>(null as any);
    }

    getCollectorOptions(): Promise<PersonSampleCollectorDto[]> {
        let url_ = this.baseUrl + "/api/enrollment/lookup/collector";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCollectorOptions(_response));
        })
    ) // trackPromise end
    }

    protected processGetCollectorOptions(response: Response): Promise<PersonSampleCollectorDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSampleCollectorDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonSampleCollectorDto[]>(null as any);
    }
}

export class PersonClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(dto: PersonDto): Promise<PersonDto> {
        let url_ = this.baseUrl + "/api/enrollment/person";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        })
    ) // trackPromise end
    }

    protected processCreate(response: Response): Promise<PersonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BPBadRequestResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonDto>(null as any);
    }

    update(dto: PersonDto): Promise<PersonDto> {
        let url_ = this.baseUrl + "/api/enrollment/person";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        })
    ) // trackPromise end
    }

    protected processUpdate(response: Response): Promise<PersonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BPBadRequestResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonDto>(null as any);
    }

    getById(id: number): Promise<PersonDto> {
        let url_ = this.baseUrl + "/api/enrollment/person/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        })
    ) // trackPromise end
    }

    protected processGetById(response: Response): Promise<PersonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonDto>(null as any);
    }

    list(perPage: number | undefined, page: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, searchValue: string | null | undefined, dob: Date | null | undefined): Promise<DataTableResultOfPersonListDto> {
        let url_ = this.baseUrl + "/api/enrollment/person/list?";
        if (perPage === null)
            throw new globalThis.Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (dob !== undefined && dob !== null)
            url_ += "dob=" + encodeURIComponent(dob ? "" + dob.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        })
    ) // trackPromise end
    }

    protected processList(response: Response): Promise<DataTableResultOfPersonListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataTableResultOfPersonListDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataTableResultOfPersonListDto>(null as any);
    }
}

export class PersonSearchClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    searchByCriterias(criterias: SearchByCriterasDto): Promise<PersonSearchResponse> {
        let url_ = this.baseUrl + "/api/search/search-by-criterias";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criterias);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchByCriterias(_response));
        })
    ) // trackPromise end
    }

    protected processSearchByCriterias(response: Response): Promise<PersonSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSearchResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonSearchResponse>(null as any);
    }

    searchByQueryBuilder(queryBuilder: SearchByQueryBuilder): Promise<PersonSearchResponse> {
        let url_ = this.baseUrl + "/api/search/search-by-querybuilder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryBuilder);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return trackPromise(
        //return this.transformOptions(options_).then(transformedOptions_ => {
        this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchByQueryBuilder(_response));
        })
    ) // trackPromise end
    }

    protected processSearchByQueryBuilder(response: Response): Promise<PersonSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSearchResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonSearchResponse>(null as any);
    }
}

export interface LoginResponse {
    success: boolean;
    requiresTwoFactor: boolean;
    isLockedOut: boolean;
    errorMessage?: string | undefined;
}

export interface LoginRequest {
    email: string;
    password: string;
    rememberMe: boolean;
}

export interface Login2faResponse {
    success: boolean;
    isLockedOut: boolean;
    errorMessage?: string | undefined;
}

export interface Login2faRequest {
    twoFactorCode: string;
    rememberMachine: boolean;
    rememberMe: boolean;
}

export interface LoginRecoveryResponse {
    success: boolean;
    isLockedOut: boolean;
    errorMessage?: string | undefined;
}

export interface LoginRecoveryRequest {
    recoveryCode: string;
}

export interface RegisterResponse {
    success: boolean;
    errors?: string[] | undefined;
}

export interface RegisterRequest {
    email: string;
    password: string;
    confirmPassword?: string | undefined;
    name: string;
}

export interface ForgotPasswordResponse {
    success: boolean;
}

export interface ForgotPasswordRequest {
    email: string;
}

export interface ResetPasswordResponse {
    success: boolean;
    errors?: string[] | undefined;
}

export interface ResetPasswordRequest {
    email: string;
    password: string;
    confirmPassword?: string | undefined;
    code: string;
}

export interface CurrentUserResponse {
    isAuthenticated: boolean;
    email?: string | undefined;
    name?: string | undefined;
    id: string;
}

export interface ApiResponse {
    success: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
}

export interface ResendEmailConfirmationRequest {
    email: string;
}

export interface AppInfoResponse {
    credits?: string | undefined;
    requestAccessUrl?: string | undefined;
    buildString?: string | undefined;
}

export interface UserProfileResponse {
    username?: string | undefined;
    email?: string | undefined;
    isEmailConfirmed: boolean;
    phoneNumber?: string | undefined;
    name?: string | undefined;
    labs?: UserDetailLabModel[] | undefined;
    roles?: string[] | undefined;
}

export interface UserDetailLabModel {
    labId: number;
    name?: string | undefined;
}

export interface UserProfileUpdateResponse {
    success: boolean;
    errors?: string[] | undefined;
}

export interface UserProfileUpdateRequest {
    phoneNumber?: string | undefined;
}

export interface ChangePasswordResponse {
    success: boolean;
    errors?: string[] | undefined;
}

export interface ChangePasswordRequest {
    oldPassword: string;
    newPassword: string;
    confirmPassword?: string | undefined;
}

export interface SetPasswordResponse {
    success: boolean;
    errors?: string[] | undefined;
}

export interface SetPasswordRequest {
    newPassword: string;
    confirmPassword?: string | undefined;
}

export interface UserEmailResponse {
    email?: string | undefined;
    isEmailConfirmed: boolean;
}

export interface ChangeEmailResponse {
    success: boolean;
    requiresConfirmation: boolean;
    errors?: string[] | undefined;
}

export interface ChangeEmailRequest {
    newEmail: string;
}

export interface TwoFactorResponse {
    hasAuthenticator: boolean;
    is2faEnabled: boolean;
    isMachineRemembered: boolean;
    recoveryCodesLeft: number;
}

export interface Disable2faResponse {
    success: boolean;
    errors?: string[] | undefined;
}

export interface AuthenticatorSetupResponse {
    sharedKey?: string | undefined;
    authenticatorUri?: string | undefined;
}

export interface EnableAuthenticatorResponse {
    success: boolean;
    recoveryCodes?: string[] | undefined;
    errors?: string[] | undefined;
}

export interface EnableAuthenticatorRequest {
    code: string;
}

export interface ResetAuthenticatorResponse {
    success: boolean;
    errors?: string[] | undefined;
}

export interface GenerateRecoveryCodesResponse {
    success: boolean;
    recoveryCodes?: string[] | undefined;
    errors?: string[] | undefined;
}

export interface PersonalDataResponse {
    canDelete: boolean;
}

export interface DownloadPersonalDataResponse {
    success: boolean;
    personalData?: { [key: string]: string; } | undefined;
}

export interface DeletePersonalDataResponse {
    success: boolean;
    requirePassword: boolean;
    errors?: string[] | undefined;
}

export interface DeletePersonalDataRequest {
    password: string;
}

export interface BrutusJobResponse {
    H1?: BrutusHypothesisResult | undefined;
    H2?: BrutusHypothesisResult | undefined;
    result?: BrutusJobResult | undefined;
}

export interface BrutusHypothesisResult {
    systems?: BrutusHypothesisSystemResult[] | undefined;
    references?: BrutusResultReference[] | undefined;
    relations?: BrutusResultRelation[] | undefined;
}

export interface BrutusHypothesisSystemResult {
    systemName?: string | undefined;
    value: number;
    formula?: string | undefined;
    alleleToVarName?: BrutusFormulaVariable[] | undefined;
}

export interface BrutusFormulaVariable {
    varName?: string | undefined;
    allele?: string | undefined;
}

export interface BrutusResultReference {
    id?: string | undefined;
    sampleId: number;
    name?: string | undefined;
    gender: BrutusJobGender;
    isUntested: boolean;
}

export enum BrutusJobGender {
    Female = 0,
    Male = 1,
}

export interface BrutusResultRelation {
    ancestorId?: string | undefined;
    descendantId?: string | undefined;
}

export interface BrutusJobResult {
    systems?: BrutusJobSystemResult[] | undefined;
    H1Probability?: number | undefined;
    H2Probability?: number | undefined;
    totalProbability: number;
}

export interface BrutusJobSystemResult {
    systemName?: string | undefined;
    H1Probability?: number | undefined;
    H2Probability?: number | undefined;
    totalProbability: number;
    H1Formula?: string | undefined;
    H2Formula?: string | undefined;
    totalFormula?: string | undefined;
    variableMapping?: BrutusFormulaVariable[] | undefined;
}

export interface BrutusJob {
    caseRunId: number;
    parameters?: JobParameter[] | undefined;
    testType: BrutusJobTestType;
    frequencies?: SystemFrequencies[] | undefined;
    references?: BrutusReference[] | undefined;
    kitId: number;
    relations?: BrutusRelation[] | undefined;
    H1?: BrutusJobHypothesis | undefined;
    H2?: BrutusJobHypothesis | undefined;
}

export interface JobParameter {
    name?: string | undefined;
    value?: string | undefined;
    type?: string | undefined;
    hasValue: boolean;
}

export enum BrutusJobTestType {
    Kinship = 0,
    Freeform = 1,
    Uhr = 2,
}

export interface SystemFrequencies {
    name?: string | undefined;
    frequencies?: AlleleFrequency[] | undefined;
}

export interface AlleleFrequency {
    allele?: string | undefined;
    frequency: number;
}

export interface BrutusReference {
    sampleId: number;
    name?: string | undefined;
    gender: BrutusJobGender;
    isUntested: boolean;
    isMissing: boolean;
    systems?: SystemAlleles[] | undefined;
    uploadTime?: Date | undefined;
}

export interface SystemAlleles {
    systemName?: string | undefined;
    alleles?: Allele[] | undefined;
}

export interface Allele {
    value?: string | undefined;
    height: number;
    originalValue?: string | undefined;
}

export interface BrutusRelation {
    ancestorId: number;
    descendantId: number;
    isQuestioned: boolean;
}

export interface BrutusJobHypothesis {
    references?: BrutusReference[] | undefined;
    relations?: BrutusRelation[] | undefined;
}

export interface FamilialSearchJobResponse {
    matches?: FamilialSearchResultItem[] | undefined;
}

export interface FamilialSearchResultItem {
    uid1?: string | undefined;
    uid2?: string | undefined;
    uid1Name?: string | undefined;
    uid2Name?: string | undefined;
    commonLoci: number;
    matchingLoci: number;
    mac: number;
    relationship: KinshipRelationship;
    totalProb: number;
    resultId?: string | undefined;
    lrElapsedSeconds: number;
    parentChildProb: number;
    fullSiblingsProb: number;
    extFamilyProb: number;
    H1ParentChildProb?: number | undefined;
    H1FullSiblingsProb?: number | undefined;
    H1ExtFamilyProb?: number | undefined;
    H2ParentChildProb?: number | undefined;
    H2FullSiblingsProb?: number | undefined;
    H2ExtFamilyProb?: number | undefined;
    systems?: FamilialSearchSystemLr[] | undefined;
}

export enum KinshipRelationship {
    ParentChild = 0,
    FullSiblings = 1,
    ExtFamily = 2,
}

export interface FamilialSearchSystemLr {
    system?: string | undefined;
    relationships?: SystemRel[] | undefined;
}

export interface SystemRel {
    relationship: KinshipRelationship;
    H1Probability?: number | undefined;
    H2Probability?: number | undefined;
    totalProbability: number;
    H1Formula?: string | undefined;
    H2Formula?: string | undefined;
    totalFormula?: string | undefined;
    variableMapping?: BrutusFormulaVariable[] | undefined;
}

export interface FamilialSearchJob {
    caseRunId: number;
    parameters?: JobParameter[] | undefined;
    frequencies?: SystemFrequencies[] | undefined;
    samples?: FamilialSearchSample[] | undefined;
    kitId: number;
}

export interface FamilialSearchSample {
    uid?: string | undefined;
    name?: string | undefined;
    systems?: SystemAlleles[] | undefined;
    bpSampleId: number;
    bpCaseId: number;
    bpLabId: number;
    isFromDb: boolean;
    gender: BrutusJobGender;
    isFromDeconvolution: boolean;
    bpCaseRunId: number;
    bpEvidenceId: number;
}

export interface CaseGetAllResponse {
    cases?: CaseReadModel[] | undefined;
}

export interface CaseReadModel {
    caseId: number;
    labId: number;
    name?: string | undefined;
}

export interface CaseGetAllQualityCheckResponse {
    cases?: CaseReadModel[] | undefined;
}

export interface CaseBasicInfoModel {
    name?: string | undefined;
    agency?: number | undefined;
    agencyName?: string | undefined;
    hasQualityCheckProfiles: boolean;
    alleleFormat: AlleleFormat;
    labName?: string | undefined;
}

export enum AlleleFormat {
    CE_RU = 0,
    LUS = 1,
    LUSP = 2,
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export interface BPBadRequestResult extends ValidationProblemDetails {
    modelErrors?: any | undefined;

    [key: string]: any;
}

export interface CaseUpdateBasicInfoModel {
    name: string;
}

export interface CaseDetailModelWithUrls {
    model?: CaseDetailModel | undefined;
    caseEditUrl?: string | undefined;
    uploadEvidenceUrl?: string | undefined;
    uploadReferenceUrl?: string | undefined;
    uploadReferenceKeyboardUrl?: string | undefined;
    importReferenceUrl?: string | undefined;
    importEvidenceUrl?: string | undefined;
    referenceUrls?: { [key: string]: string; } | undefined;
    evidenceUrls?: { [key: string]: string; } | undefined;
    createRunUrls?: { [key: string]: string; } | undefined;
    canCreateRunTypes?: BpRunTypeModel[] | undefined;
    canViewRunTypes?: BpRunTypeModel[] | undefined;
}

export interface CaseDetailModel {
    labId: number;
    id: number;
    labName?: string | undefined;
    name?: string | undefined;
    isReadOnly: boolean;
    isActive: boolean;
    samples?: SampleListModel[] | undefined;
    evidence?: EvidenceListModel[] | undefined;
    populations?: KitPopulationModel[] | undefined;
    canCreateRunTypes?: BpRunTypeModel[] | undefined;
    canViewRunTypes?: BpRunTypeModel[] | undefined;
    hasQualityCheckProfiles: boolean;
    canCreateEvidence: boolean;
    canCreateReference: boolean;
    agencyName?: string | undefined;
}

export interface SampleListModel {
    id: number;
    name?: string | undefined;
    sex?: SampleSex | undefined;
}

export enum SampleSex {
    Female = 0,
    Male = 1,
}

export interface EvidenceListModel {
    id: number;
    name?: string | undefined;
}

export interface KitPopulationModel {
    id: number;
    active: boolean;
    name?: string | undefined;
    url?: string | undefined;
}

export interface BpRunTypeModel {
    runType?: string | undefined;
    runTypeId: number;
}

export interface CaseCreateResponseModel {
    caseId: number;
    url?: string | undefined;
    success: boolean;
    errors?: string[] | undefined;
}

export interface CaseCreateModel {
    name: string;
    labId: number;
    hasQualityCheckProfiles: boolean;
    agencyId?: number | undefined;
    alleleFormat?: AlleleFormat | undefined;
}

export interface EvidenceKitMarkerModel {
    name?: string | undefined;
    color?: string | undefined;
}

export interface PopulationCreateCustomResponse {
    success: boolean;
    error?: string | undefined;
    newPopulationId?: number | undefined;
    newKitId?: number | undefined;
}

export interface PopulationCreateCustomRequest {
    name: string;
    labId: number;
    caseId: number;
    systems: KitPopulationSystemModel[];
    ednaRaceId?: number | undefined;
}

export interface KitPopulationSystemModel {
    ednaChrId?: number | undefined;
    name: string;
    frequencies: KitPopulationFreqModel[];
}

export interface KitPopulationFreqModel {
    allele: string;
    frequency: number;
}

export interface PopulationUpdateCustomResponse {
    success: boolean;
    error?: string | undefined;
}

export interface PopulationUpdateCustomRequest {
    name: string;
    panelId: number;
    labId: number;
    caseId: number;
    systems: KitPopulationSystemModel[];
}

export interface KitModel {
    id: number;
    active: boolean;
    fullName?: string | undefined;
    shortName?: string | undefined;
    url?: string | undefined;
}

export interface ResponseModel {
    id: number;
    url?: string | undefined;
    success: boolean;
    errors?: string[] | undefined;
}

export interface CaseRunCreateResponseModel extends ResponseModel {
}

export interface CaseRunCreateModelBase {
    labId: number;
    caseName?: string | undefined;
    efmCaseId: number;
    oldRunId: number;
    runType?: string | undefined;
    createdFromPrevious: boolean;
    description?: string | undefined;
    populationId: number;
    ednaTestId?: number | undefined;
    parameters: RunParameterModel[];
    populations?: CaseRunCreatePopulationModel[] | undefined;
    discriminator: string;
}

export interface BrutusCaseRunCreateModel extends CaseRunCreateModelBase {
    references?: BrutusCaseRunCreateSampleModel[] | undefined;
    relations?: BrutusRelationModel[] | undefined;
    h1?: BrutusHypothesisModel | undefined;
    h2?: BrutusHypothesisModel | undefined;
    brutusTestType: BrutusTestType;
}

export interface CaseRunCreateSampleModel {
    id: number;
    name?: string | undefined;
    selected: boolean;
}

export interface BrutusCaseRunCreateSampleModel extends CaseRunCreateSampleModel {
    isMissingPerson: boolean;
    isUntested: boolean;
    isMale: boolean;
}

export interface BrutusRelationModel {
    ancestorId: number;
    descendantId: number;
    questioned: boolean;
}

export interface BrutusHypothesisModel {
    references?: BrutusCaseRunCreateSampleModel[] | undefined;
    relations?: BrutusRelationModel[] | undefined;
}

export enum BrutusTestType {
    Kinship = 1,
    Freeform = 2,
    UHR = 3,
}

export interface RunParameterModel {
    parameter: string;
    parameterType: ParameterTypes;
    defaultValue?: string | undefined;
    value?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    minValue: number;
    maxValue: number;
    required: boolean;
    order: number;
    aicEditable: boolean;
    userVisible: boolean;
    userEditable: boolean;
    copyFromParent: boolean;
    showIfChecked?: string | undefined;
    isSecondary: boolean;
}

export enum ParameterTypes {
    Number = 0,
    Integer = 1,
    Boolean = 2,
    String = 3,
    Json = 4,
}

export interface CaseRunCreatePopulationModel {
    id: number;
    name?: string | undefined;
    order: number;
}

export interface DnaMatchCaseRunCreateModel extends CaseRunCreateModelBase {
    references?: CaseRunCreateSampleModel[] | undefined;
    evidence?: CaseRunCreateEvidenceModel[] | undefined;
    qualityCheckCases?: CaseRunQualityCheckCaseModel[] | undefined;
}

export interface CaseRunCreateEvidenceModel {
    id: number;
    name?: string | undefined;
    selected: boolean;
}

export interface CaseRunQualityCheckCaseModel {
    caseId: number;
    name?: string | undefined;
    selected: boolean;
}

export interface MaxLrCaseRunCreateModelBase extends CaseRunCreateModelBase {
    aic: boolean;
    hd: CaseRunCreateSampleModel[];
    hp: CaseRunCreateSampleModel[];
    hasSelectedSystems: boolean;
    sampleSystems?: CaseRunCreateSampleModelWithSystems[] | undefined;
    evidenceSystems?: CaseRunCreateEvidenceModelWithSystems[] | undefined;
    hdUnknowns: number;
    hpUnknowns: number;
    hdKnownRelName?: string | undefined;
    hdKnownRelSampleId?: number | undefined;
    numberOfContributors?: string | undefined;
    hpNumberOfContributors?: string | undefined;
    hdNumberOfContributors?: string | undefined;
    evidence?: CaseRunCreateEvidenceModel[] | undefined;
    useHp: boolean;
    useHd: boolean;
}

export interface CaseRunCreateModel extends MaxLrCaseRunCreateModelBase {
}

export interface CaseRunCreateSampleModelWithSystems {
    id: number;
    systems?: SelectableSystem[] | undefined;
}

export interface SelectableSystem {
    name?: string | undefined;
    selected: boolean;
}

export interface CaseRunCreateEvidenceModelWithSystems {
    id: number;
    systems?: SelectableSystem[] | undefined;
}

export interface DeconvMainCaseRunCreateModel extends MaxLrCaseRunCreateModelBase {
}

export interface FamilialSearchCaseRunCreateModel extends CaseRunCreateModelBase {
    references?: CaseRunCreateSampleModel[] | undefined;
}

export interface GenerateSampleCaseRunCreateModel extends MaxLrCaseRunCreateModelBase {
}

export interface DataTableResultOfBrutusCaseRunModel {
    items?: BrutusCaseRunModel[] | undefined;
    totalRows: number;
}

export interface CaseRunModelBase {
    id: number;
    description?: string | undefined;
    populationName?: string | undefined;
    runType?: string | undefined;
    completed?: Date | undefined;
    created?: Date | undefined;
    status: CaseRunStatus;
    friendlyRunType?: string | undefined;
    caseId: number;
    caseName?: string | undefined;
    labId: number;
    labName?: string | undefined;
    likelihoodRatio?: number | undefined;
    likelihoodRatioLog10?: number | undefined;
    likelihoodRatioStr?: string | undefined;
}

export interface BrutusCaseRunModel extends CaseRunModelBase {
    brutusTestType?: BrutusTestType | undefined;
    brutusFeatureToUse?: string | undefined;
    brutusFeatureToUseEnum?: BrutusFeature | undefined;
}

export enum BrutusFeature {
    None = 0,
    Mutations = 1,
    SilentAllele = 2,
}

export enum CaseRunStatus {
    Queued = 0,
    Pending = 1,
    Running = 2,
    Successful = 3,
    Failed = 4,
}

export interface CaseRunCalculateResponseModel extends ResponseModel {
}

export interface CaseRunCalculateModel {
    labId: number;
    efmCaseId: number;
    caseRunId: number;
    caseName?: string | undefined;
    caseUrl?: string | undefined;
    caseRunUrl?: string | undefined;
    runType?: string | undefined;
    hd: CaseRunCreateSampleModel[];
    hp: CaseRunCreateSampleModel[];
    parameters: RunParameterModel[];
}

export interface CaseRunCalculateDetailModel {
    id: number;
    labId: number;
    efmCaseId: number;
    caseRunId: number;
    type?: string | undefined;
    fullTypeName?: string | undefined;
    caseName?: string | undefined;
    ncaGraphUrl?: string | undefined;
    mcmcTraceGraphUrl?: string | undefined;
    mcmcSensGraphUrl?: string | undefined;
    hpFittedModelGraphUrl?: string | undefined;
    hdFittedModelGraphUrl?: string | undefined;
    hpFittedModelPlotlyUrl?: string | undefined;
    hdFittedModelPlotlyUrl?: string | undefined;
    hpModelValidationGraphUrl?: string | undefined;
    hdModelValidationGraphUrl?: string | undefined;
    hd: ContributorReadModel[];
    hp: ContributorReadModel[];
    parameters: ParameterReadModel[];
    integralJobResponse?: IntegralJobResponse | undefined;
    mcmcSensitivityJobResponse?: McmcSensitivityJobResponse | undefined;
    tasks?: CaseRunTaskModel[] | undefined;
    createdBy?: string | undefined;
    isActive: boolean;
    ncaMax?: string | undefined;
    ncaLogMax?: string | undefined;
    ncaMeanLR?: string | undefined;
    ncaLRRM?: number[] | undefined;
}

export interface ContributorReadModel {
    id: number;
    name?: string | undefined;
    role?: string | undefined;
}

export interface ParameterReadModel {
    parameter: string;
    value?: string | undefined;
    parameterType: ParameterTypes;
    order: number;
    userVisible: boolean;
    showIfChecked?: string | undefined;
}

export interface IntegralJobResponse {
    calculationId: number;
    hp?: IntegralHypothesis | undefined;
    hd?: IntegralHypothesis | undefined;
    likelihoodRatio: number;
    likelihoodRatioLog10: number;
}

export interface IntegralHypothesis {
    likelihood: number;
    logLikelihood: number;
    evaluations: number;
}

export interface McmcSensitivityJobResponse {
    calculationId: number;
    sensitivity?: string | undefined;
    trace?: string | undefined;
    hp?: McmcSensitivityHypothesis | undefined;
    hd?: McmcSensitivityHypothesis | undefined;
    burnInResults?: BurnInResultItem[] | undefined;
    burnInResultsHd?: BurnInResultItem[] | undefined;
    likelihoods?: MaxLrLikelihood[] | undefined;
}

export interface McmcSensitivityHypothesis {
    acceptanceRate: number;
    mcmcParameterSvg?: string | undefined;
}

export interface BurnInResultItem {
    delta: number;
    niter: number;
    acceptanceRate: number;
}

export interface MaxLrLikelihood {
    type?: string | undefined;
    likelihoodRatio: number;
    likelihoodRatioLog10: number;
    hp: number;
    hd: number;
    hpLog10: number;
    hdLog10: number;
}

export interface CaseRunTaskModel {
    id: string;
    started?: Date | undefined;
    completed?: Date | undefined;
    failed?: Date | undefined;
    startedDisplay?: string | undefined;
    completedDisplay?: string | undefined;
    failedDisplay?: string | undefined;
    displayName?: string | undefined;
    phase?: string | undefined;
    displayOrder: number;
    timeTakenSeconds?: number | undefined;
}

export interface DataTableResultOfCalculateInfoModel {
    items?: CalculateInfoModel[] | undefined;
    totalRows: number;
}

export interface CalculateInfoModel {
    id: number;
    viewUrl?: string | undefined;
    runType?: string | undefined;
    created: Date;
    completed?: Date | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    timeTakenSeconds: number;
    successful: boolean;
    pending: boolean;
    status: CaseRunStatus;
    timeTakenMinutes: number;
    runTypeFriendly?: string | undefined;
    isActive: boolean;
}

export interface CaseRunNotesUpdateModel {
    notes?: string | undefined;
}

export interface CaseRunDetailResponse {
    detail?: CaseRunDetailReadModel | undefined;
}

export interface CaseRunDetailResponseWithUrls extends CaseRunDetailResponse {
    caseUrl?: string | undefined;
    populationUrl?: string | undefined;
    copiedFromUrl?: string | undefined;
    cloneUrl?: string | undefined;
    printUrl?: string | undefined;
    exportUrl?: string | undefined;
    deleteUrl?: string | undefined;
    referenceUrls?: { [key: string]: string; } | undefined;
    evidenceUrls?: { [key: string]: string; } | undefined;
    calculationUrls?: { [key: string]: string; } | undefined;
    resultsUrl?: string | undefined;
}

export interface CaseRunDetailReadModel {
    labId: number;
    efmCaseId: number;
    caseRunId: number;
    labName?: string | undefined;
    caseName?: string | undefined;
    kitId?: number | undefined;
    runType?: string | undefined;
    created?: Date | undefined;
    failed?: Date | undefined;
    completed?: Date | undefined;
    submitted?: Date | undefined;
    kitPopulationId: number;
    populationName?: string | undefined;
    description?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    parentRunId?: number | undefined;
    labJobId?: string | undefined;
    evidence?: EvidenceReadModel[] | undefined;
    contributors?: ContributorReadModel[] | undefined;
    hd: ContributorReadModel[];
    hp: ContributorReadModel[];
    parameters: ParameterReadModel[];
    tasks?: CaseRunTaskModel[] | undefined;
    computeTimeUsed: number;
    aic: boolean;
    isReadOnly: boolean;
    isCompleted: boolean;
    canCreateRunTypes?: BpRunTypeModel[] | undefined;
    caseRunPrintOptions?: LabCaseRunPrintOptionsModel | undefined;
    isDeleted: boolean;
    discriminator: string;
}

export interface EvidenceReadModel {
    id: number;
    name?: string | undefined;
}

export interface LabCaseRunPrintOptionsModel {
    caseRunDetails: boolean;
    caseRunNotes: boolean;
    aicRuns: boolean;
    resultsMlSystems: boolean;
    resultsWeightOfEvidence: boolean;
    resultsEpgOverlay: boolean;
    resultsSensitivityGraph: boolean;
    resultsBayesianNumericalParameters: boolean;
    resultsMcmcParameters: boolean;
    hpParameterEstimates: boolean;
    hpModelValidation: boolean;
    hpMcmcParameters: boolean;
    hpDeconvTopMarginal: boolean;
    hpFittedModel: boolean;
    hpDeconvAllJoint: boolean;
    hpDeconvAllMarginalGeno: boolean;
    hpDeconvAllMarginalAlleles: boolean;
    hdParameterEstimates: boolean;
    hdModelValidation: boolean;
    hdMcmcParameters: boolean;
    hdDeconvTopMarginal: boolean;
    hdDeconvAllJoint: boolean;
    hdDeconvAllMarginalGeno: boolean;
    hdDeconvAllMarginalAlleles: boolean;
    hdFittedModel: boolean;
    sentryResults: boolean;
}

export interface MaxLrCaseRunDetailReadModelBase extends CaseRunDetailReadModel {
    hdUnknowns: number;
    hpUnknowns: number;
    aic: boolean;
    useHp: boolean;
    useHd: boolean;
    hdKnownReferenceRelation?: string | undefined;
    hdKnownReferenceId?: number | undefined;
    hasSelectedSystems?: boolean | undefined;
}

export interface MaxLrCaseRunDetailReadModel extends MaxLrCaseRunDetailReadModelBase {
    results?: MaxlrResultReadModel | undefined;
}

export interface ResultReadModel {
    systems?: ResultSystemsReadModel[] | undefined;
    hypotheses?: ResultHypothesisReadModel[] | undefined;
    likelihoods?: ResultLikelihoodReadModel[] | undefined;
}

export interface MaxlrResultReadModelBase extends ResultReadModel {
    epgUrl?: string | undefined;
    epgPlotlyUrl?: string | undefined;
    sensitivityUrl?: string | undefined;
    mcmcTraceUrl?: string | undefined;
    ncaGraphUrl?: string | undefined;
    calculationResponses?: CalculationResultModel[] | undefined;
}

export interface MaxlrResultReadModel extends MaxlrResultReadModelBase {
}

export interface CalculationResultModel {
    calculationId: number;
    bayesianResult?: BayesianCalculationResultModel | undefined;
    nonContrResult?: NonContrResultModel | undefined;
}

export interface BayesianCalculationResultModel {
    hpEvaluations: number;
    hdEvaluations: number;
}

export interface NonContrResultModel {
    max: number;
    meanLR: number;
}

export interface ResultSystemsReadModel {
    system?: string | undefined;
    likelihoodRatio?: number | undefined;
}

export interface ResultHypothesisReadModel {
    likelihood?: number | undefined;
    likelihoodStr?: string | undefined;
    logLikelihood?: number | undefined;
    phExpectation: number;
    phExpectationError: number;
    phVariability: number;
    phVariabilityError: number;
    type: string;
    degradationSlope: number;
    degradationSlopeError: number;
    stutterProp: number;
    stutterPropError: number;
    fwStutterProp: number;
    fwStutterPropError: number;
    acceptanceRate?: number | undefined;
    fittedEpgUrl?: string | undefined;
    fittedEpgPlotlyUrl?: string | undefined;
    mleUrl?: string | undefined;
    mcmcSvg?: string | undefined;
    topMarginalSystems?: TopMarginalSystemReadModel[] | undefined;
    allJointSystems?: AllJointSystemReadModel[] | undefined;
    allMarginalContributors?: AllMarginalContributorReadModel[] | undefined;
    mixProps?: ResultMixPropReadModel[] | undefined;
}

export interface TopMarginalSystemReadModel {
    system?: string | undefined;
    contributors?: TopMarginalContributorReadModel[] | undefined;
}

export interface TopMarginalContributorReadModel {
    contributor?: string | undefined;
    sampleName?: string | undefined;
    genotype?: string | undefined;
    probability: number;
    ratioToNext?: number | undefined;
}

export interface AllJointSystemReadModel {
    system?: string | undefined;
    ranks?: AllJointRankReadModel[] | undefined;
}

export interface AllJointRankReadModel {
    rank: number;
    probability: number;
    contributors?: AllJointContributorReadModel[] | undefined;
}

export interface AllJointContributorReadModel {
    contributor?: string | undefined;
    sampleName?: string | undefined;
    genotype?: string | undefined;
}

export interface AllMarginalContributorReadModel {
    contributor: string;
    sampleName?: string | undefined;
    marginalType: string;
    systems?: AllMarginalSystemReadModel[] | undefined;
}

export interface AllMarginalSystemReadModel {
    system?: string | undefined;
    sampleName?: string | undefined;
    values?: AllMarginalValueReadModel[] | undefined;
}

export interface AllMarginalValueReadModel {
    probability: number;
    value?: string | undefined;
}

export interface ResultMixPropReadModel {
    mixProp: number;
    mixPropError: number;
    number: number;
    sampleId: number;
    sampleName?: string | undefined;
}

export interface ResultLikelihoodReadModel {
    hd?: number | undefined;
    hp?: number | undefined;
    likelihoodRatio?: number | undefined;
    likelihoodRatioLog10?: number | undefined;
    likelihoodType?: string | undefined;
    hdLog10?: number | undefined;
    hpLog10?: number | undefined;
    hdStr?: string | undefined;
    hpStr?: string | undefined;
    likelihoodRatioLog10Str?: string | undefined;
    likelihoodRatioStr?: string | undefined;
    calculationId?: number | undefined;
    calculation?: CalculationReadModel | undefined;
}

export interface CalculationReadModel {
    id: number;
    created?: Date | undefined;
    completed?: Date | undefined;
    submitted?: Date | undefined;
    runType?: string | undefined;
    parameters?: ParameterReadModel[] | undefined;
}

export interface MaxLrAicCaseRunDetailReadModel extends MaxLrCaseRunDetailReadModelBase {
    results?: MaxlrAicResultReadModel | undefined;
}

export interface MaxlrAicResultReadModel extends MaxlrResultReadModelBase {
}

export interface SentryCaseRunDetailReadModel extends CaseRunDetailReadModel {
    results?: SentryResultReadModel | undefined;
    qualityCheckCases?: SentryCaseRunQualityCheckCase[] | undefined;
}

export interface SentryResultReadModel extends ResultReadModel {
    hitsCount: number;
}

export interface SentryCaseRunQualityCheckCase {
    caseId: number;
    name?: string | undefined;
}

export interface DeconvMainCaseRunDetailReadModel extends MaxLrCaseRunDetailReadModelBase {
    results?: MaxlrResultReadModel | undefined;
}

export interface BrutusCaseRunDetailReadModel extends CaseRunDetailReadModel {
    references?: BrutusCaseRunReference[] | undefined;
    relations?: BrutusCaseRunRelation[] | undefined;
    results?: BrutusResultReadModel | undefined;
    h1?: BrutusCaseRunHypothesis | undefined;
    h2?: BrutusCaseRunHypothesis | undefined;
    testType: BrutusTestType;
    probabilityInPercent?: string | undefined;
    priorProbabilityInPercent?: string | undefined;
}

export interface BrutusCaseRunReference {
    sampleId: number;
    name?: string | undefined;
    gender: BrutusGender;
    isUntested: boolean;
    isMissing: boolean;
}

export enum BrutusGender {
    Female = 0,
    Male = 1,
}

export interface BrutusCaseRunRelation {
    ancestorId: number;
    descendantId: number;
    isQuestioned: boolean;
}

export interface BrutusResultReadModel extends ResultReadModel {
    h1?: BrutusHypothesisResult | undefined;
    h2?: BrutusHypothesisResult | undefined;
    references?: BrutusReference[] | undefined;
    frequencies?: SystemFrequencies[] | undefined;
    result?: BrutusJobResult | undefined;
}

export interface BrutusCaseRunHypothesis {
    references?: BrutusCaseRunReference[] | undefined;
    relations?: BrutusCaseRunRelation[] | undefined;
}

export interface FamilialSearchCaseRunDetailReadModel extends CaseRunDetailReadModel {
    results?: FamilialSearchResultReadModel | undefined;
}

export interface FamilialSearchResultReadModel extends ResultReadModel {
    hitsCount: number;
}

export interface GenerateSampleCaseRunDetailReadModel extends MaxLrCaseRunDetailReadModelBase {
    results?: GenerateSampleResultReadModel | undefined;
}

export interface GenerateSampleResultReadModel extends ResultReadModel {
}

export enum LabReportsTextsType {
    EFM = 0,
    Brutus = 1,
    SampleRMP = 2,
}

export interface ProfileSummaryTableModel {
    deconvSamples?: ProfileModel[] | undefined;
    evidence?: ProfileModel[] | undefined;
    contributors?: ProfileModel[] | undefined;
}

export interface ProfileModel {
    name?: string | undefined;
    systems?: ProfileSystemModel[] | undefined;
}

export interface ProfileSystemModel {
    name?: string | undefined;
    alleles?: ProfileAlleleModel[] | undefined;
    color?: string | undefined;
}

export interface ProfileAlleleModel {
    allele?: string | undefined;
    isAboveThreshold: boolean;
}

export interface DataTableResultOfMaxLrAicCaseRunModel {
    items?: MaxLrAicCaseRunModel[] | undefined;
    totalRows: number;
}

export interface MaxLrAicCaseRunModel {
    adjLogLik: number;
    adjLogLikHp: number;
    adjLogLikHd: number;
    logLik: number;
    noc: number;
    modelBWstutt: boolean;
    modelFWstutt: boolean;
    modelDegrad: boolean;
    signifHd: number;
    signifHp: number;
    log10LR: number;
    mxPOI: number;
    hp?: MaxLrResult | undefined;
    hd?: MaxLrResult | undefined;
}

export interface MaxLrResult {
    logLikelihood: number;
    likelihood: number;
    phExpectation: number;
    phVariability: number;
    phExpectationError: number;
    phVariabilityError: number;
    mleSvg?: string | undefined;
    deconvolution?: Deconvolution | undefined;
    mixProp?: MixPropResult[] | undefined;
    degradationSlope: number;
    degradationSlopeError: number;
    stutterProp: number;
    stutterPropError: number;
    fittedPhSvg?: string | undefined;
    acceptanceRate: number;
    mcmcParameterSvg?: string | undefined;
    fwStutterProp: number;
    fwStutterPropError: number;
    likelihoodStr?: string | undefined;
    fittedPhPlotly?: string | undefined;
}

export interface Deconvolution {
    allJoint?: AllJointDeconvolutionSystem[] | undefined;
    topMarginal?: TopMarginalDeconvolutionSystem[] | undefined;
    allMarginalGenotypes?: AllMarginalDeconvolutionContributor[] | undefined;
    allMarginalAlleles?: AllMarginalDeconvolutionContributor[] | undefined;
}

export interface AllJointDeconvolutionSystem {
    system?: string | undefined;
    ranks?: AllJointDeconvolutionSystemRank[] | undefined;
}

export interface AllJointDeconvolutionSystemRank {
    rank: number;
    probability: number;
    contributors?: AllJointDeconvolutionContributor[] | undefined;
}

export interface AllJointDeconvolutionContributor {
    contributor?: string | undefined;
    genotype?: string | undefined;
    bulletproofId: number;
}

export interface TopMarginalDeconvolutionSystem {
    system?: string | undefined;
    contributors?: TopMarginalDeconvolutionContributor[] | undefined;
}

export interface TopMarginalDeconvolutionContributor {
    contributor?: string | undefined;
    genotype?: string | undefined;
    probability: number;
    ratioToNextGenotype: number;
    ratioNa: boolean;
    bulletproofId: number;
}

export interface AllMarginalDeconvolutionContributor {
    contributor?: string | undefined;
    systems?: AllMarginalDeconvolutionSystem[] | undefined;
    bulletproofId: number;
}

export interface AllMarginalDeconvolutionSystem {
    system?: string | undefined;
    genotypes?: AllMarginalDeconvolutionGenotype[] | undefined;
    alleles?: AllMarginalDeconvolutionAllele[] | undefined;
}

export interface AllMarginalDeconvolutionGenotype {
    genotype?: string | undefined;
    probability: number;
}

export interface AllMarginalDeconvolutionAllele {
    allele?: string | undefined;
    probability: number;
}

export interface MixPropResult {
    number: number;
    mixProp: number;
    mixPropError: number;
    bulletproofId: number;
}

export interface DataTableResultOfAicCaseRunModel {
    items?: AicCaseRunModel[] | undefined;
    totalRows: number;
}

export interface AicCaseRunModel {
    id: number;
    labId: number;
    efmCaseId: number;
    parentRunId?: number | undefined;
    aic: boolean;
    hdUnknowns: number;
    hpUnknowns: number;
    name?: string | undefined;
    created: Date;
    completed?: Date | undefined;
    useDegradation: boolean;
    useStutter: boolean;
    likelihoodRatio?: number | undefined;
    likelihoodRatioLog10?: number | undefined;
    phVariability?: number | undefined;
    phVariabilityError?: number | undefined;
    likelihood?: number | undefined;
    logLikelihood?: number | undefined;
    aicLogLikelihood?: number | undefined;
    aicD?: number | undefined;
    status: CaseRunStatus;
    state?: string | undefined;
    viewUrl?: string | undefined;
}

export interface DataTableResultOfFamilialSearchResultItemModel {
    items?: FamilialSearchResultItemModel[] | undefined;
    totalRows: number;
}

export interface FamilialSearchResultItemModel {
    uid1?: string | undefined;
    uid2?: string | undefined;
    uid1Name?: string | undefined;
    uid2Name?: string | undefined;
    commonLoci: number;
    matchingLoci: number;
    mac: number;
    totalProb: number;
    resultId?: string | undefined;
    relationship: KinshipRelationship;
    uid2CaseName?: string | undefined;
    uid2CaseId: number;
    uid2CreatedAt?: Date | undefined;
    uid2CaseUrl?: string | undefined;
    uid1CaseId: number;
    uid1CaseName?: string | undefined;
    uid1CaseUrl?: string | undefined;
    uid1CreatedAt?: Date | undefined;
    otherCaseName?: string | undefined;
    otherCaseId: number;
    otherCaseDate?: Date | undefined;
    otherCaseUrl?: string | undefined;
    exportUrl?: string | undefined;
    uid1Url?: string | undefined;
    uid2Url?: string | undefined;
    parentChildProb?: number | undefined;
    fullSiblingsProb?: number | undefined;
    extFamilyProb?: number | undefined;
    h1ParentChildProb?: number | undefined;
    h1FullSiblingsProb?: number | undefined;
    h1ExtFamilyProb?: number | undefined;
    h2ParentChildProb?: number | undefined;
    h2FullSiblingsProb?: number | undefined;
    h2ExtFamilyProb?: number | undefined;
    uid1Sample?: SampleReadModel | undefined;
    uid2Sample?: SampleReadModel | undefined;
}

export interface SampleReadModel {
    id: number;
    name?: string | undefined;
    kitId: number;
    labId: number;
    labName?: string | undefined;
    warning?: string | undefined;
    error?: string | undefined;
    sex?: SampleSex | undefined;
    dateOfBirth?: Date | undefined;
    birthYear?: number | undefined;
    birthMonth?: number | undefined;
    birthDay?: number | undefined;
    ageYears?: number | undefined;
    ageMonths?: number | undefined;
    createdAt?: Date | undefined;
    cases?: IdNameModel[] | undefined;
}

export interface IdNameModel {
    id: number;
    name?: string | undefined;
}

export interface FSSystemModel {
    system?: string | undefined;
    relationships?: SystemRel[] | undefined;
    persons?: FSPersonModel[] | undefined;
}

export interface FSPersonModel {
    uid?: string | undefined;
    name?: string | undefined;
    alleles?: Allele[] | undefined;
}

export interface DataTableResultOfFamilialSearchCaseRunModel {
    items?: FamilialSearchCaseRunModel[] | undefined;
    totalRows: number;
}

export interface FamilialSearchCaseRunModel extends CaseRunModelBase {
    referenceList?: string | undefined;
    useExtendedSearch: boolean;
    hitsCount: number;
}

export interface GenerateSampleJobResponse {
    evidence?: Evidence[] | undefined;
    reference?: Sample[] | undefined;
    mx?: number[] | undefined;
    rho: number;
    tau: number;
    beta: number;
    xiBW: number;
    xiFW: number;
}

export interface Evidence {
    name?: string | undefined;
    systems?: SystemAlleles[] | undefined;
    bulletproofId: number;
}

export interface Sample {
    name?: string | undefined;
    systems?: SystemAlleles[] | undefined;
    bulletproofId: number;
}

export interface DataTableResultOfCaseRunModel {
    items?: CaseRunModel[] | undefined;
    totalRows: number;
}

export interface CaseRunModel extends CaseRunModelBase {
    hdUnknowns: number;
    hpUnknowns: number;
    evidenceList?: string | undefined;
    useDegradation?: boolean | undefined;
    useStutter?: boolean | undefined;
    useFwStutter?: boolean | undefined;
    hpContributorsList?: string | undefined;
    hdContributorsList?: string | undefined;
    calcAicIndependently?: boolean | undefined;
    isDeconvAIC?: boolean | undefined;
}

export interface DataTableResultOfDnaMatchResultItemModel {
    items?: DnaMatchResultItemModel[] | undefined;
    totalRows: number;
}

export interface DnaMatchResultItemModel {
    referenceId: number;
    evidenceId: number;
    referenceName?: string | undefined;
    evidenceName?: string | undefined;
    commonLoci: number;
    totalAlleleCount: number;
    mac: number;
    macHomozygOnce: number;
    nContr: number;
    lrQualLog10: number;
    lrQualLog10Display?: string | undefined;
    lrQualLog102P: number;
    resultId?: string | undefined;
    evidenceCaseName?: string | undefined;
    evidenceCaseId: number;
    evidenceCaseCreated?: Date | undefined;
    evidenceCaseUrl?: string | undefined;
    referenceCaseId: number;
    referenceCaseName?: string | undefined;
    referenceCaseUrl?: string | undefined;
    referenceCaseCreated?: Date | undefined;
    otherCaseName?: string | undefined;
    otherCaseId: number;
    otherCaseDate?: Date | undefined;
    otherCaseUrl?: string | undefined;
    exportUrl?: string | undefined;
    referenceUrl?: string | undefined;
    evidenceUrl?: string | undefined;
    referenceUid?: string | undefined;
    evidenceUid?: string | undefined;
}

export interface ResultRow {
    locus?: string | undefined;
    refAllele1?: string | undefined;
    refAllele2?: string | undefined;
    evAllele1?: string | undefined;
    evAllele2?: string | undefined;
    evAllele3?: string | undefined;
    evAllele4?: string | undefined;
    evAllele5?: string | undefined;
    evAllele6?: string | undefined;
    evAllele7?: string | undefined;
    evAllele8?: string | undefined;
    evAllele9?: string | undefined;
    evAllele10?: string | undefined;
    evAllele11?: string | undefined;
    evAllele12?: string | undefined;
    evAllele13?: string | undefined;
    evAllele14?: string | undefined;
    evAllele15?: string | undefined;
    evAllele16?: string | undefined;
    evAllele17?: string | undefined;
    evAllele18?: string | undefined;
    evAllele19?: string | undefined;
    evAllele20?: string | undefined;
    isCommon: boolean;
    hasMatch: boolean;
    hasFullMatch: boolean;
    logHp: number;
    logHd: number;
    lr: number;
    lr2P: number;
    hpPenalty: number;
}

export interface DataTableResultOfSentryCaseRunModel {
    items?: SentryCaseRunModel[] | undefined;
    totalRows: number;
}

export interface SentryCaseRunModel extends CaseRunModelBase {
    evidenceList?: string | undefined;
    referenceList?: string | undefined;
    searchBetweenStains: boolean;
    hitsCount: number;
}

export interface EmailSettingsModel {
    fromName?: string | undefined;
    fromEmail?: string | undefined;
    host?: string | undefined;
    port?: number | undefined;
    username?: string | undefined;
    password?: string | undefined;
    useSsl: boolean;
    sendGridApiKey?: string | undefined;
    emailProvider?: string | undefined;
    populationFrequencyMaxError: number;
    requestAccessUrl?: string | undefined;
    searchInAllLabs: boolean;
    runTypes?: RunTypeReadModel[] | undefined;
    secondaryParametersCollapsed: boolean;
    azureCommServiceEndpoint?: string | undefined;
    openAiApiKey?: string | undefined;
    openAiModel?: string | undefined;
    openAiEpgPrompt?: string | undefined;
    locales?: LocaleModel[] | undefined;
    autoscaleFormula?: string | undefined;
}

export interface RunTypeReadModel {
    runTypeId: number;
    runType?: string | undefined;
    fullName?: string | undefined;
    isEnabled: boolean;
}

export interface SupportedLocale {
    code?: string | undefined;
    name?: string | undefined;
    localizedName?: string | undefined;
    siteDefault: boolean;
}

export interface LocaleModel extends SupportedLocale {
    isEnabled: boolean;
}

export interface DataTableResultOfAuditLogDto {
    items?: AuditLogDto[] | undefined;
    totalRows: number;
}

export interface AuditLogDto {
    username?: string | undefined;
    action?: string | undefined;
    tableName?: string | undefined;
    tablePk?: string | undefined;
    entityName?: string | undefined;
    entityPk?: { [key: string]: any; } | undefined;
    changes?: { [key: string]: any; } | undefined;
    auditTime: Date;
    columnValues?: { [key: string]: any; } | undefined;
}

export interface EdnaResult2 {
    redirectUrl?: string | undefined;
    hasCaseRun: boolean;
}

export interface BrutusCaseRunCreateFromEdnaModel {
    email?: string | undefined;
    returnUrl?: string | undefined;
    ednaSiteId?: string | undefined;
    ednaCaseNumber?: string | undefined;
    ednaCaseId: number;
    ednaTestId: number;
    ednaRaceId: number;
    labId: number;
    references?: SampleWithSystems[] | undefined;
    systems: KitPopulationSystemModel[];
}

export interface SampleWithSystems {
    sampleId: number;
    name?: string | undefined;
    sex?: string | undefined;
    dateOfBirth?: Date | undefined;
    systems?: SampleSystem[] | undefined;
    kitName?: string | undefined;
}

export interface SampleSystem {
    name?: string | undefined;
    selected: boolean;
    alleles?: string[] | undefined;
    heights?: number[] | undefined;
}

export interface EdnaPayload {
    userGuid: string;
    parameters: EdnaParameters;
    result: EdnaResult;
}

export interface EdnaParameters {
    mode: string;
    mutationRateMale: number;
    mutationRateFemale: number;
    silentFrequency: number;
    theta: number;
    useSubStructure: boolean;
    raceId: number;
    diagramDataSet: string;
    diagramImg: string;
    diagramSvg: string;
    panelId: number;
    selectedSamples: number[];
}

export interface EdnaResult {
    sampleResults: EdnaSampleResult[];
    systemResults: EdnaSystemResult[];
    summary: EdnaSummary;
}

export interface EdnaSampleResult {
    sampId: number;
    systemAlleles: EdnaSystemAllele[];
}

export interface EdnaSystemAllele {
    systemId: number;
    alleles: string[];
}

export interface EdnaSystemResult {
    systemId: number;
    system: string;
    h1: number;
    h2: number;
    total: number;
    h1Formula: string;
    h2Formula: string;
    totalFormula: string;
    vars: { [key: string]: string; };
    frequencies: { [key: string]: number; };
}

export interface EdnaSummary {
    probability: number;
}

export interface EvidenceGetAllResponse {
    evidence?: EvidenceReadModel2[] | undefined;
}

export interface EvidenceReadModel2 {
    id: number;
    name?: string | undefined;
    kitId: number;
    kitName?: string | undefined;
    cases?: IdNameModel[] | undefined;
    labId?: number | undefined;
    labName?: string | undefined;
    degradationUrl?: string | undefined;
    epgOverlayUrl?: string | undefined;
    warning?: string | undefined;
    error?: string | undefined;
    createdAt?: Date | undefined;
}

export interface EvidenceGetByIdResponse {
    evidence?: EvidenceReadModel2 | undefined;
}

export interface EvidenceGetByIdResponseWithUrls extends EvidenceGetByIdResponse {
    caseUrl?: string | undefined;
}

export interface EvidenceUpdatedModel {
    success: boolean;
    url?: string | undefined;
}

export interface EvidenceUpdateModel {
    kitId: number;
    name: string;
    genGraph: boolean;
}

export interface EvidenceCreateResponse {
    newEvidence?: EvidenceReadModel2[] | undefined;
    successful: boolean;
    errors?: LocalizedString[] | undefined;
    messages?: LocalizedString[] | undefined;
    isUAS: boolean;
}

export interface EvidenceCreateResponseModel extends EvidenceCreateResponse {
    url?: string | undefined;
}

export interface LocalizedString {
    name: string;
    value: string;
    resourceNotFound: boolean;
    searchedLocation?: string | undefined;
}

export interface EvidenceCreateModel {
    kitId: number;
    evidenceFile: string;
    format?: AlleleFormat | undefined;
}

export interface EvidenceCreateFromExistingModel {
    name?: string | undefined;
    normalizeLSAE: boolean;
    markers?: EvidenceSystemModel[] | undefined;
}

export interface EvidenceSystemModel {
    name?: string | undefined;
    isSelected: boolean;
    lsae: number;
}

export interface EvidenceDetailsResponse {
    evidence?: EvidenceDetailModel | undefined;
}

export interface EvidenceDetailsResponseWithUrls extends EvidenceDetailsResponse {
    createDeconvolutionUrl?: string | undefined;
    detailsUrl?: string | undefined;
    editUrl?: string | undefined;
    caseUrl?: string | undefined;
}

export interface EvidenceDetailModel {
    id: number;
    active: boolean;
    name?: string | undefined;
    canDelete: boolean;
    maxAlleles: number;
    hasDegradation: boolean;
    hasEpg: boolean;
    hasPlotlyEpg: boolean;
    degradation?: string | undefined;
    epg?: string | undefined;
    degradationUrl?: string | undefined;
    epgOverlayUrl?: string | undefined;
    epgPlotlyUrl?: string | undefined;
    markers?: EvidenceMarkerModel[] | undefined;
    created?: Date | undefined;
    createdBy?: string | undefined;
    kitName?: string | undefined;
    kitId: number;
    alleleFormat: AlleleFormat;
    cases?: IdNameModel[] | undefined;
}

export interface EvidenceMarkerModel {
    name?: string | undefined;
    alleles?: EvidenceMarkerAlleleModel[] | undefined;
    color?: string | undefined;
}

export interface EvidenceMarkerAlleleModel {
    order: number;
    allele?: string | undefined;
    height: number;
}

export interface EvidenceUploadModel {
    caseName?: string | undefined;
    caseUrl?: string | undefined;
    labName?: string | undefined;
}

export interface EvidenceImportRequest {
    labId: number;
    caseId: number;
    evidenceIds?: number[] | undefined;
}

export interface DataTableResultOfKitModel {
    items?: KitModel[] | undefined;
    totalRows: number;
}

export interface KitDetailModel {
    fullName?: string | undefined;
    shortName?: string | undefined;
    systems?: KitSystemModel[] | undefined;
}

export interface KitSystemModel {
    id: number;
    kitId: number;
    name?: string | undefined;
    genderMarker?: boolean | undefined;
    qualitySensor?: boolean | undefined;
    color?: string | undefined;
    repeat?: number | undefined;
    offset?: number | undefined;
    markerMin?: number | undefined;
    markerMax?: number | undefined;
    active: boolean;
    order: number;
    alleles?: KitSystemAlleleModel[] | undefined;
    defaultFemaleMu: number;
    defaultMaleMu: number;
}

export interface KitSystemAlleleModel {
    id: number;
    allele?: string | undefined;
    size: number;
    sizeMin?: number | undefined;
    sizeMax?: number | undefined;
    virtual?: boolean | undefined;
    active: boolean;
}

export interface KitEditModel {
    fullName: string;
}

export interface KitPopulationModel2 {
    id: number;
    name?: string | undefined;
    order: number;
    ownerCaseId?: number | undefined;
    ownerCaseName?: string | undefined;
}

export interface PopulationGetByIdResponse {
    success: boolean;
    error?: string | undefined;
    population?: PopulationReadModel | undefined;
}

export interface PopulationReadModel {
    id: number;
    active: boolean;
    name?: string | undefined;
    url?: string | undefined;
    canDelete: boolean;
    alleleFormat: AlleleFormat;
    sampledProfilesCount?: number | undefined;
    systems?: PopulationSystemReadModel[] | undefined;
    weights?: KitPopulationWeightReadModel[] | undefined;
}

export interface PopulationSystemReadModel {
    system?: string | undefined;
    order: number;
    alleleFrequencies?: PopulationAlleleReadModel[] | undefined;
}

export interface PopulationAlleleReadModel {
    allele?: string | undefined;
    frequency: number;
}

export interface KitPopulationWeightReadModel {
    populationName?: string | undefined;
    weight: number;
}

export interface GetPopulationDetailsResponse {
    name?: string | undefined;
    allAlleles?: string[] | undefined;
    systemFrequencies?: PopulationSystemReadModel[] | undefined;
    canDelete: boolean;
    weights?: KitPopulationWeightReadModel[] | undefined;
}

export interface KitPopulationCreateResponseModel extends ResponseModel {
}

export interface KitPopulationCreateModel {
    name: string;
    labId: number;
    fileContents: string;
    sampledProfilesCount?: number | undefined;
}

export interface PopulationUpdateResponse {
    success: boolean;
    error?: string | undefined;
}

export interface KitPopulationEditModel {
    id: number;
    name: string;
    fileContents?: string | undefined;
    sampledProfilesCount?: number | undefined;
}

export interface PopulationCreateLocalRequest {
    name: string;
    labId: number;
    populations: KitPopulationWeightModel[];
    useMinForRare?: boolean | undefined;
}

export interface KitPopulationWeightModel {
    id: number;
    proportion: number;
}

export interface DataTableResultOfPopulationSearchResultModel {
    items?: PopulationSearchResultModel[] | undefined;
    totalRows: number;
}

export interface PopulationSearchResultModel {
    id: number;
    active: boolean;
    name?: string | undefined;
    url?: string | undefined;
    canDelete: boolean;
    labName?: string | undefined;
}

export interface LabUsageModel {
    startDate: Date;
    endDate: Date;
    labUsageByDay?: LabUsageByDay[] | undefined;
    labUsageDetail?: LabUsageDetail[] | undefined;
}

export interface LabUsageByDay {
    date: Date;
    runCount: number;
    totalRunSeconds: number;
    totalRunMinutes: number;
}

export interface LabUsageDetail {
    created: Date;
    claimed?: Date | undefined;
    completedTime?: Date | undefined;
    failed: boolean;
    completed: boolean;
    jobType?: string | undefined;
    caseId: number;
    runId: number;
    caseUrl?: string | undefined;
    runUrl?: string | undefined;
    caseName?: string | undefined;
    timeTakenSeconds: number;
    timeTakenMinutes: number;
}

export enum NamedDateRange {
    Last30 = 0,
    Last60 = 1,
    Last90 = 2,
    Thismonth = 3,
    Lastmonth = 4,
    Custom = 5,
}

export interface LabEditResponseModel extends ResponseModel {
}

export interface LabEditFullModel {
    name?: string | undefined;
    country?: string | undefined;
    timeZone?: string | undefined;
    defaultPopulationId?: number | undefined;
    isDemo: boolean;
    lowPriorityWorkers: number;
    dedicatedWorkers: number;
    taskSlotsPerNode?: number | undefined;
    isReadOnly: boolean;
    canEditProvisioning: boolean;
    locale?: string | undefined;
    fullLocaleName?: string | undefined;
    kits?: LabKitModel[] | undefined;
    populations?: LabPopulationModel[] | undefined;
    runTypes?: RunTypeModel[] | undefined;
    caseRunPrintingOptions?: LabCaseRunPrintOptionsModel | undefined;
    active: boolean;
    reportTextTemplate?: { [key in keyof typeof LabReportsTextsType]?: string; } | undefined;
    defaultAlleleFormats?: AlleleFormat[] | undefined;
    vmSize?: string | undefined;
    autoscaleFormula?: string | undefined;
    sharedSampleTypes?: SharingSampleType[] | undefined;
}

export interface LabKitModel {
    kitId: number;
    enabled: boolean;
    fullName?: string | undefined;
    shortName?: string | undefined;
    panelName?: string | undefined;
}

export interface LabPopulationModel {
    enabled: boolean;
    populationId: number;
    populationName?: string | undefined;
    order: number;
}

export interface RunTypeModel {
    runType?: string | undefined;
    fullName?: string | undefined;
    parameters?: RunParameterModel[] | undefined;
}

export enum SharingSampleType {
    None = 0,
    All = 1,
    Reference = 2,
    Evidence = 3,
    QualityCases = 4,
    ForensicEnrollments = 5,
}

export interface LabCreateResponseModel {
    labId: number;
    url?: string | undefined;
    success: boolean;
    errors?: string[] | undefined;
}

export interface LabCreateModel {
    name: string;
    country: string;
    timeZone?: string | undefined;
    copyFromLab?: number | undefined;
    existingUserEmail?: string | undefined;
    newUserName?: string | undefined;
    newUserEmail?: string | undefined;
    locale?: string | undefined;
}

export interface LabGetAllResponse {
    labs?: LabReadModel[] | undefined;
}

export interface LabReadModel {
    id: number;
    active: boolean;
    name?: string | undefined;
    url?: string | undefined;
    isReadOnly: boolean;
    lowPriorityWorkers: number;
    dedicatedWorkers: number;
    autoscaleFormula?: string | undefined;
    isDemo: boolean;
    taskSlotsPerNode?: number | undefined;
    vmSize?: string | undefined;
}

export interface AgenciesGetAllResponse {
    agencies?: AgencyReadModel[] | undefined;
}

export interface AgencyReadModel {
    id: number;
    name: string;
    isActive: boolean;
}

export interface LabAgencyCreateResponse {
    success: boolean;
    error?: string | undefined;
    agencyId?: number | undefined;
}

export interface AgencyCreateModel {
    name: string;
    address?: string | undefined;
}

export interface AgencyGetByIdResponse {
    agency?: AgencyDetailsModel | undefined;
}

export interface AgencyDetailsModel {
    id: number;
    name?: string | undefined;
    address?: string | undefined;
    isActive: boolean;
}

export interface FileModel {
    contents: string;
    fileName?: string | undefined;
}

export interface DropInDataViewModel {
    peaks?: number[] | undefined;
    totalNumberOfSystems: number;
}

export interface CalculateLambdaResponse {
    lambda: number;
    dropInProbability: number;
}

export interface ReportTemplateResponse {
    filename?: string | undefined;
    downloadUrl?: string | undefined;
}

export interface GetLabReportTextsTemplateResponse {
    reportTypes?: { [key in keyof typeof LabReportsTextsType]?: LabReportTextsTemplateEditModel; } | undefined;
}

export interface LabReportTextsTemplateEditModel {
    reportType: LabReportsTextsType;
    template?: string | undefined;
    tags?: ReportTagModel[] | undefined;
    functions?: { [key: string]: string; } | undefined;
}

export interface ReportTagModel {
    tag?: string | undefined;
    description?: string | undefined;
    valueType?: string | undefined;
}

export interface GetLabReportTextsTemplatePreviewResponse {
    preview?: string | undefined;
}

export interface DataTableResultOfLabModel {
    items?: LabModel[] | undefined;
    totalRows: number;
}

export interface LabModel {
    id: number;
    active: boolean;
    name?: string | undefined;
    url?: string | undefined;
}

export interface LabMarkerSettingsModel {
    markerName?: string | undefined;
    detectionThreshold: number;
    dropInProbability: number;
    dropInHyperParam: number;
    color?: string | undefined;
    femaleMu: number;
    maleMu: number;
    lsae: number;
}

export interface LabMarkerSettingsSaveModel {
    markerName?: string | undefined;
    detectionThreshold: number;
    dropInProbability: number;
    dropInHyperParam: number;
    femaleMu: number;
    maleMu: number;
    lsae: number;
}

export interface DataTableResultOfSampleReadModel {
    items?: SampleReadModel[] | undefined;
    totalRows: number;
}

export interface DataTableResultOfEvidenceReadModel {
    items?: EvidenceReadModel2[] | undefined;
    totalRows: number;
}

export interface LabJobReadModel {
    id: string;
    runTypeId?: string | undefined;
    payloadUrl?: string | undefined;
    caseRunId?: number | undefined;
    labId: number;
    caseId: number;
    calculationId?: number | undefined;
    evidenceId?: number | undefined;
    tasks?: LabJobTaskReadModel[] | undefined;
    lab?: LabReadModel | undefined;
    started?: Date | undefined;
    completed?: Date | undefined;
    failed?: Date | undefined;
    parameters?: ParameterReadModel[] | undefined;
}

export interface LabJobTaskReadModel {
    id: string;
    phase?: string | undefined;
}

export interface JobStatus {
    endTime: number;
    startTime: number;
    jobId: string;
    success: boolean;
    worker?: string | undefined;
    phase?: string | undefined;
    cancelled?: boolean | undefined;
    error?: string | undefined;
}

export interface LabJobDownloadModel {
    id: string;
    created: Date;
    runTypeId?: string | undefined;
    queued?: Date | undefined;
    completed?: Date | undefined;
    cancelled?: Date | undefined;
    failed?: Date | undefined;
    tasks?: LabJobTaskDownloadModel[] | undefined;
    payloadUrl?: string | undefined;
    resultsUrl?: string | undefined;
    payload?: string | undefined;
    results?: string | undefined;
}

export interface LabJobTaskDownloadModel {
    id: string;
    phase?: string | undefined;
    started?: Date | undefined;
    completed?: Date | undefined;
    failed?: Date | undefined;
    cancelled?: Date | undefined;
    displayName?: string | undefined;
    displayOrder: number;
    log?: string | undefined;
    stdErr?: string | undefined;
    stdOut?: string | undefined;
}

export interface TaskStartedRequestModel {
    started: Date;
}

export interface TaskFailedRequestModel {
    failed: Date;
}

export interface LabJobTaskCompletedRequestModel {
    started: Date;
    completed: Date;
}

export interface LabJobTaskAddLogsRequestModel {
    stdErr?: string | undefined;
    stdOut?: string | undefined;
}

export interface KitCreateModel {
    fullName: string;
    shortName: string;
}

export interface KitSystemsModel {
    kitId: number;
    shortName?: string | undefined;
    systems?: KitSystemModel[] | undefined;
}

export interface RunTypeParametersModel {
    maxLrParameters?: MaxLrParameters | undefined;
    maxLrAicParameters?: MaxLrAicParameters | undefined;
    dnaMatchParameters?: DnaMatchParameters | undefined;
    deconvMainParameters?: DeconvMainParameters | undefined;
    nonContributorAnalysisParameters?: NonContributorAnalysisParameters | undefined;
    brutusParameters?: BrutusParameters | undefined;
    familialSearchParameters?: FamilialSearchParameters | undefined;
    integralParameters?: IntegralParameters | undefined;
    generateSampleParameters?: GenerateSampleParameters | undefined;
}

export interface MaxLrParameters {
    allowVariableNoC: boolean;
    useMarkerSpecificSettings: boolean;
    detectionThreshold: number;
    detectionThresholds?: { [key: string]: number; } | undefined;
    dropInProbability: number;
    dropInProbabilities?: { [key: string]: number; } | undefined;
    dropInHyperParam: number;
    dropInHyperParams?: { [key: string]: number; } | undefined;
    fstCorrection: number;
    nDone: number;
    delta: number;
    seed?: number | undefined;
    rareAlleleFreqType?: RareAlleleType | undefined;
    rareAlleleFreq?: number | undefined;
    populationN?: number | undefined;
    maxIterations: number;
    difftol: number;
    useResttol: boolean;
    resttol: number;
    maxThreads: number;
    steptol: number;
    useDegradation: boolean;
    adjQbp: boolean;
    useStutter: boolean;
    useFwStutter: boolean;
    stutterProp?: string | undefined;
    fwStutterProp?: string | undefined;
    hdUnknowns: number;
    hpUnknowns: number;
    runDeconvolution: boolean;
    maxListSize: number;
    alphaProb: number;
    runMCMC: boolean;
    mcMcSamples: number;
    mcMcVariance: number;
    runIntegral: boolean;
    limitEvaluations: boolean;
    maxEval: number;
    relTol: number;
    scale: number;
}

export enum RareAlleleType {
    MinFreq = 0,
    PopN = 1,
    PopLocN = 2,
}

export interface MaxLrAicParameters {
    outNoc?: string | undefined;
    calcAicIndependently: boolean;
    useMarkerSpecificSettings: boolean;
    detectionThreshold: number;
    detectionThresholds?: { [key: string]: number; } | undefined;
    dropInProbability: number;
    dropInProbabilities?: { [key: string]: number; } | undefined;
    dropInHyperParam: number;
    dropInHyperParams?: { [key: string]: number; } | undefined;
    fstCorrection: number;
    nDone: number;
    delta: number;
    seed?: number | undefined;
    rareAlleleFreqType?: RareAlleleType | undefined;
    rareAlleleFreq?: number | undefined;
    populationN?: number | undefined;
    maxIterations: number;
    difftol: number;
    useResttol: boolean;
    resttol: number;
    maxThreads: number;
    steptol: number;
    outDegYes: boolean;
    adjQbp: boolean;
    outDegNo: boolean;
    outBwStutYes: boolean;
    outBwStutNo: boolean;
    outFwStutYes: boolean;
    outFwStutNo: boolean;
    stutterProp?: string | undefined;
    fwStutterProp?: string | undefined;
    hdUnknowns?: string | undefined;
    hpUnknowns?: string | undefined;
    useDegradation: boolean;
    useStutter: boolean;
    useFwStutter: boolean;
    nocPenalty: number;
    degPenalty: number;
    bwStutPenalty: number;
    fwStutPenalty: number;
}

export interface DnaMatchParameters {
    threshMac: number;
    threshLr: number;
    detectionThreshold: number;
    dropInProbability: number;
    fstCorrection: number;
    minFreq: number;
    maxNoc: number;
    searchBetweenStains: boolean;
    majorRate: number;
    majorMinLoci: number;
    searchBetweenDeconvoluted: boolean;
    deconvProbThresh: number;
    deconvMinLoci: number;
    useExtendedSearch: boolean;
    uploadStartDate?: Date | undefined;
    uploadEndDate?: Date | undefined;
    limitToAgency: boolean;
    kitId?: number | undefined;
}

export interface DeconvMainParameters {
    isAIC: boolean;
    noc?: string | undefined;
    alphaProb: number;
    maxListSize: number;
    highlighProbAbove: number;
    useMarkerSpecificSettings: boolean;
    detectionThreshold: number;
    detectionThresholds?: { [key: string]: number; } | undefined;
    dropInProbability: number;
    dropInProbabilities?: { [key: string]: number; } | undefined;
    dropInHyperParam: number;
    dropInHyperParams?: { [key: string]: number; } | undefined;
    fstCorrection: number;
    nDone: number;
    delta: number;
    seed?: number | undefined;
    rareAlleleFreqType?: RareAlleleType | undefined;
    rareAlleleFreq?: number | undefined;
    populationN?: number | undefined;
    maxIterations: number;
    difftol: number;
    useResttol: boolean;
    resttol: number;
    maxThreads: number;
    steptol: number;
    useDegradation: boolean;
    adjQbp: boolean;
    useStutter: boolean;
    useFwStutter: boolean;
    stutterProp?: string | undefined;
    fwStutterProp?: string | undefined;
    hpUnknowns: number;
    nocPenalty: number;
    degPenalty: number;
    bwStutPenalty: number;
    fwStutPenalty: number;
}

export interface NonContributorAnalysisParameters {
    ntippets: number;
    refIndex: number;
    refSampleId: number;
    useResttol: boolean;
    resttol: number;
    seed?: number | undefined;
}

export interface RareAlleleParametersBase {
    rareAlleleFreqType?: RareAlleleType | undefined;
    rareAlleleFreq?: number | undefined;
    populationN?: number | undefined;
}

export interface BrutusParameters extends RareAlleleParametersBase {
    brutusFeatureToUse?: BrutusFeature | undefined;
    brutusSilentAlleleFreq: number;
    brutusUsePopulationSubstructure: boolean;
    brutusTheta: number;
    brutusUseMarkerSpecificSettingsMu: boolean;
    brutusFemaleMu: number;
    brutusFemaleMus?: { [key: string]: number; } | undefined;
    brutusMaleMu: number;
    brutusMaleMus?: { [key: string]: number; } | undefined;
    brutusPriorProbability: number;
}

export interface FamilialSearchParameters {
    kinMac: number;
    kinParentChildEnabled: boolean;
    kinStrParentChild: number;
    kinCRIThreshParentChild: number;
    kinSiblingsEnabled: boolean;
    kinStrSibling: number;
    kinCRIThreshSibling: number;
    kinExtFamilyEnabled: boolean;
    kinStrExtFamily: number;
    kinCRIThreshExtFamily: number;
    kinMinFreq: number;
    kinBayesPriorProbability: number;
    kinUseExtendedSearch: boolean;
    kinUploadStartDate?: Date | undefined;
    kinUploadEndDate?: Date | undefined;
    kitId?: number | undefined;
    kinUseMutations: boolean;
    brutusFemaleMu: number;
    brutusMaleMu: number;
    brutusAvgAgeFatherhood: number;
    brutusAvgAgeMotherhood: number;
    searchBetweenDeconvoluted: boolean;
    deconvProbThresh: number;
    deconvMinLoci: number;
}

export interface IntegralParameters {
    limitEvaluations: boolean;
    maxEval: number;
    relTol: number;
    intCustomScaling: boolean;
    maxMu: number;
    maxSigma: number;
    maxXi: number;
    maxXiFw: number;
    scale: number;
    intDev: number;
    intCustomScalingHpBounds?: CustomScalingBound | undefined;
    intCustomScalingHdBounds?: CustomScalingBound | undefined;
    /** Not used for calculation. Only for UI client needs. */
    useStutter: boolean;
    stutterProp?: string | undefined;
    /** Not used for calculation. Only for UI client needs. */
    useFwStutter: boolean;
    fwStutterProp?: string | undefined;
    /** Not used for calculation. Only for UI client needs. */
    useDegradation: boolean;
    dropInProbability: number;
    dropInHyperParam: number;
    detectionThreshold: number;
    fstCorrection: number;
}

export interface CustomScalingBound {
    mx?: ScalingLimits[] | undefined;
    mu?: ScalingLimits | undefined;
    sigma?: ScalingLimits | undefined;
    beta?: ScalingLimits | undefined;
    xi?: ScalingLimits | undefined;
    xiFw?: ScalingLimits | undefined;
    scale: number;
}

export interface ScalingLimits {
    lower: number;
    upper: number;
}

export interface GenerateSampleParameters {
    genEvidenceName?: string | undefined;
    kitId?: number | undefined;
    useMarkerSpecificSettings: boolean;
    detectionThreshold: number;
    detectionThresholds?: { [key: string]: number; } | undefined;
    dropInProbability: number;
    dropInProbabilities?: { [key: string]: number; } | undefined;
    dropInHyperParam: number;
    dropInHyperParams?: { [key: string]: number; } | undefined;
    genMu: number;
    genSigma: number;
    genDegSlope: number;
    genBwStutter: number;
    genFwStutter: number;
    genMixProps?: number[] | undefined;
    hdUnknowns: number;
    hpUnknowns: number;
}

export interface ConstantsModel {
}

export interface DataTableResultOfProfileReadModel {
    items?: ProfileReadModel[] | undefined;
    totalRows: number;
}

export interface ProfileReadModel {
    id: number;
    isEvidence: boolean;
    name?: string | undefined;
    kitId: number;
    createdAt?: Date | undefined;
    labId: number;
    labName?: string | undefined;
    cases?: IdNameModel[] | undefined;
}

export interface SampleCreateResponse {
    newSample?: SampleReadModel[] | undefined;
    successful: boolean;
    errors?: LocalizedString[] | undefined;
    isUAS: boolean;
}

export interface SampleCreateResponseModel extends SampleCreateResponse {
    url?: string | undefined;
}

export interface SampleCreateModel {
    kitId: number;
    sampleFile: string;
    format?: AlleleFormat | undefined;
}

export interface SampleParseResponse {
    newSample?: ParsedSampleDto[] | undefined;
    successful: boolean;
    errors?: LocalizedString[] | undefined;
    isUAS: boolean;
}

export interface ParsedSampleDto {
    name?: string | undefined;
    systems?: SampleMarkerModel[] | undefined;
}

export interface SampleMarkerModel {
    markerName?: string | undefined;
    alleles?: SampleMarkerAlleleModel[] | undefined;
    color?: string | undefined;
}

export interface SampleMarkerAlleleModel {
    allele?: string | undefined;
    order: number;
}

export interface CalcRMPResponse {
    rmpModel?: SampleRandomMatchProbabilityModel | undefined;
}

export interface SampleRandomMatchProbabilityModel {
    id: number;
    fst: number;
    populationId: number;
    populationName?: string | undefined;
    rmp: number;
    oneDivRMP: number;
    rareAlleleType: RareAlleleType;
    createdAt?: Date | undefined;
    skippedSystems?: string[] | undefined;
    reportText?: string | undefined;
}

export interface CalcRMPRequest {
    sampleId: number;
    populationId: number;
    fst: number;
    rareAlleleType: RareAlleleType;
}

export interface DataTableResultOfCaseModel {
    items?: CaseModel[] | undefined;
    totalRows: number;
}

export interface CaseModel {
    id: number;
    active: boolean;
    labId: number;
    labName?: string | undefined;
    name?: string | undefined;
    url?: string | undefined;
    agencyName?: string | undefined;
}

export interface GetUserRecentCasesAndRunsResponse {
    model?: HomeModel | undefined;
}

export interface HomeModel {
    recentCases?: RecentCaseModel[] | undefined;
    recentRuns?: RecentRunModel[] | undefined;
}

export interface RecentCaseModel {
    labId: number;
    caseId: number;
    caseName?: string | undefined;
    labName?: string | undefined;
}

export interface RecentRunModel {
    labId: number;
    caseId: number;
    caseRunId: number;
    caseName?: string | undefined;
    labName?: string | undefined;
    runStatus: CaseRunStatus;
}

export interface SettingsModel {
    secondaryParametersCollapsed: boolean;
    agenciesEnabled: boolean;
}

export interface DistinctMarkersModel {
    systems?: SystemModel[] | undefined;
}

export interface SystemModel {
    name?: string | undefined;
}

export interface MeModel {
    isSiteAdmin: boolean;
    labs?: IdNameModel[] | undefined;
    hasSingleLab: boolean;
    lab?: IdNameModel | undefined;
    details?: UserDetailModel | undefined;
    roles?: string[] | undefined;
    policies?: string[] | undefined;
    canAccessCases: boolean;
    canCreateCase: boolean;
    canDeleteCase: boolean;
    canCreateUser: boolean;
    canDeleteUser: boolean;
    canCreateLab: boolean;
    canManagePopulations: boolean;
    canEditLab: boolean;
    changePasswordUrl?: string | undefined;
    canCreateEnrollments: boolean;
    canDeleteLab: boolean;
}

export interface UserDetailModel {
    id: string;
    email?: string | undefined;
    name?: string | undefined;
    isSelf: boolean;
    active: boolean;
    timeZone?: string | undefined;
    canResendInitialEmail: boolean;
    created?: Date | undefined;
    createdBy?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: string | undefined;
    labs?: UserDetailLabModel[] | undefined;
    roles?: string[] | undefined;
    locale?: string | undefined;
    twoFactorEnabled: boolean;
}

export interface RoleModel {
    id: string;
    name?: string | undefined;
    permissions?: string[] | undefined;
}

export interface RolePermissionModel {
    code?: string | undefined;
    name?: string | undefined;
}

export interface RoleCreateModel {
    name: string;
    permissions?: string[] | undefined;
}

export interface RunTypeGetAllResponse {
    runTypes?: RunTypeReadModel[] | undefined;
}

export interface RunTypeGetChildrenResponse {
    runTypes?: RunTypeReadModel[] | undefined;
}

export interface SampleGetByIdResponse {
    sample?: SampleReadModel | undefined;
}

export interface SampleUpdatedModel {
    success: boolean;
    url?: string | undefined;
}

export interface SampleUpdateRequest {
    labId: number;
    sampleId: number;
    name?: string | undefined;
    kitId: number;
    sex?: SampleSex | undefined;
    dateOfBirth?: Date | undefined;
    birthYear?: number | undefined;
    birthMonth?: number | undefined;
    birthDay?: number | undefined;
    ageYears?: number | undefined;
    ageMonths?: number | undefined;
}

export interface SampleCreateKeyboardModel {
    kitId: number;
    name: string;
    systems: SampleSystemModel[];
    dateOfBirth?: Date | undefined;
}

export interface SampleSystemModel {
    name?: string | undefined;
    allele1?: string | undefined;
    allele2?: string | undefined;
}

export interface SampleCreateFromExistingModel {
    name?: string | undefined;
    markers?: string[] | undefined;
}

export interface SampleGetDetailsResponse {
    sample?: SampleModel | undefined;
}

export interface SampleDetailsResponseWithUrls extends SampleGetDetailsResponse {
    editUrl?: string | undefined;
    detailsUrl?: string | undefined;
    caseUrl?: string | undefined;
}

export interface SampleModel {
    id: number;
    name?: string | undefined;
    canDelete: boolean;
    active: boolean;
    markers?: SampleMarkerModel[] | undefined;
    created?: Date | undefined;
    createdBy?: string | undefined;
    kitName?: string | undefined;
    alleleFormat: AlleleFormat;
    sex?: SampleSex | undefined;
    dateOfBirth?: Date | undefined;
    birthYear?: number | undefined;
    birthMonth?: number | undefined;
    birthDay?: number | undefined;
    ageYears?: number | undefined;
    ageMonths?: number | undefined;
    randomMatchProbabilities?: SampleRandomMatchProbabilityModel[] | undefined;
    cases?: IdNameModel[] | undefined;
}

export interface SampleImportRequest {
    labId: number;
    caseId: number;
    sampleIds?: number[] | undefined;
}

export interface TimeZoneGroup {
    countryCode?: string | undefined;
    country?: string | undefined;
    timeZones?: TimeZone[] | undefined;
}

export interface TimeZone {
    offsetSeconds: number;
    offset?: string | undefined;
    zone?: string | undefined;
}

export interface CurrentLocale {
    localeName?: string | undefined;
}

export interface ClientResources {
    dataTable: DataTableResources;
    common: CommonResources;
    lab: LabResources;
    case: CaseResources;
    population: PopulationResources;
    yup: YupResources;
    user: UserResources;
    parameter: ParameterResources;
    jobPhase: JobPhaseResources;
    evidence: EvidenceResources;
    sample: SampleResources;
    caseRun: CaseRunResources;
    kit: KitResources;
    likelihoodType: LikelihoodTypeResources;
    workQueue: WorkQueueResources;
    runType: RunTypeResources;
    relations: RelationsResources;
    caseRunView: CaseRunResources2;
    kitView: KitResources2;
    evidenceView: EvidenceResources2;
    caseView: CaseResources2;
    userView: UserResources2;
    labView: LabResources2;
    populationView: PopulationResources2;
    reportTexts: ReportTextsResources;
    reportTextTags: ReportTextTagsResources;
    sampleView: SampleResources2;
    appSettings: AppSettingsResources;
    brutus: BrutusResources;
    caseRunStatus: CaseRunStatusResources;
    home: HomeResources;
    customPanel: CustomPanelResources;
    metadata: MetadataResources;
    auth: AuthResources;
    account: AccountResources;
}

export interface DataTableResources {
    processing: string;
    search: string;
    lengthMenu: string;
    info: string;
    infoEmpty: string;
    infoFiltered: string;
    infoPostFix: string;
    infoThousands: string;
    loadingRecords: string;
    zeroRecords: string;
    emptyTable: string;
    paginate: Paginate;
    aria: Aria;
    dataTableComponent: DataTableComponentResources;
}

export interface Paginate {
    first: string;
    previous: string;
    next: string;
    last: string;
}

export interface Aria {
    sortAscending: string;
    sortDescending: string;
}

export interface DataTableComponentResources {
    rowsPerPage: string;
    rangeSeparator: string;
}

export interface CommonResources {
    emailAddress: string;
    password: string;
    lab: string;
    labs: string;
    case: string;
    cases: string;
    qualityControlCases: string;
    kit: string;
    kits: string;
    population: string;
    populations: string;
    user: string;
    users: string;
    run: string;
    runs: string;
    caseRun: string;
    caseRuns: string;
    status: string;
    update: string;
    edit: string;
    delete: string;
    confirmDelete: string;
    cancel: string;
    save: string;
    system: string;
    allele: string;
    height: string;
    parameter: string;
    parameters: string;
    value: string;
    values: string;
    result: string;
    results: string;
    logOut: string;
    workQueue: string;
    profiles: string;
    samples: string;
    disable: string;
    enable: string;
    confirmDisable: string;
    confirmEnable: string;
    evidence: string;
    evidencePlural: string;
    referenceProfile: string;
    referenceProfiles: string;
    referenceProfileKeyboard: string;
    contributor: string;
    contributors: string;
    default: string;
    name: string;
    enabledQuestion: string;
    created: string;
    completed: string;
    upload: string;
    epg: string;
    degradationPlot: string;
    download: string;
    errorsOnForm: string;
    id: string;
    yes: string;
    no: string;
    language: string;
    languages: string;
    hpContributors: string;
    hdContributors: string;
    unknowns: string;
    runType: string;
    runTypePlural: string;
    referencePlural: string;
    reference: string;
    hits: string;
    agency: string;
    createNew: string;
    close: string;
    information: string;
    hpDeconvolutionContributors: string;
    owner: string;
    startDate: string;
    endDate: string;
    active: string;
    generate: string;
    alleleFormat: string;
    locus: string;
    copyToClipboard: string;
    appSettings: string;
    frequency: string;
    symbol: string;
    formula: string;
    import: string;
    search: string;
    searches: string;
    roles: string;
    permissions: string;
    loading: string;
}

export interface LabResources {
    allLabs: string;
    name: string;
    last30Days: string;
    last60Days: string;
    last90Days: string;
    thisMonth: string;
    lastMonth: string;
    custom: string;
    usageMinutes: string;
    totalRuns: string;
    dateRange: string;
    totalJobs: string;
    totalTime: string;
    timeZone: string;
    timeTaken: string;
    readOnlyLab: string;
    demoLab: string;
    maximumLowPriority: string;
    maximumDedicated: string;
    taskSlotsPerNode: string;
    vmSize: string;
    autoscaleFormula: string;
    labInformation: string;
    usage: string;
    showingDataFromTo: string;
    jobType: string;
    serverErrorUpdating: string;
    editLabTitle: string;
    createNewAdmin: string;
    useExistingAdmin: string;
    copyDefaultsFrom: string;
    newUserName: string;
    newUserEmail: string;
    existingUser: string;
    errorCreatingLab: string;
    agencies: string;
    addAgency: string;
    editAgency: string;
    dropInData: string;
    uploadDropInDataFile: string;
    dropInDataFile: string;
    dropInPeakCount: string;
    dropInTotalNumberOfSystems: string;
    noDropInData: string;
    pleaseSelectFile: string;
    reporting: string;
    noReportTemplates: string;
    uploadReportTemplateFile: string;
    reportTemplateFile: string;
    deleteDropInConfirm: string;
    deleteAgencyConfirm: string;
    deleteReportConfirm: string;
    casePrintOptions: string;
    removeAgencyData: string;
    removeAgencyDataConfirm: string;
    showDisabledAgencies: string;
}

export interface CaseResources {
    name: string;
    errorCreatingCase: string;
    hasQualityCheckProfiles: string;
    searchInSampleName: string;
}

export interface PopulationResources {
    name: string;
    populationFile: string;
    errorCreating: string;
    errorUpdating: string;
    noUploadUnchanged: string;
    sampledProfilesCount: string;
}

export interface YupResources {
    mixed: YupMixed;
    number: YupNumber;
    string: YupString;
}

export interface YupMixed {
    default: string;
    required: string;
}

export interface YupNumber {
    min: string;
    max: string;
    lessThan: string;
    moreThan: string;
    positive: string;
    negative: string;
    integer: string;
}

export interface YupString {
    email: string;
}

export interface UserResources {
    name: string;
    errorCreating: string;
    role: string;
}

export interface ParameterResources {
    names: ParameterNameResources;
    descriptions: ParameterDescriptionResources;
}

export interface ParameterNameResources {
    detectionThreshold: string;
    detectionThresholds: string;
    dropInHyperParam: string;
    dropInHyperParams: string;
    dropInProbability: string;
    dropInProbabilities: string;
    fstCorrection: string;
    limitEvaluations: string;
    maxEval: string;
    maxMu: string;
    maxSigma: string;
    maxXi: string;
    maxXiFw: string;
    relTol: string;
    scale: string;
    stutterProp: string;
    useStutter: string;
    fwStutterProp: string;
    useFwStutter: string;
    bwStutterProp: string;
    useBwStutter: string;
    alphaProb: string;
    delta: string;
    deltaHd: string;
    maxListSize: string;
    mcMcSamples: string;
    mcMcVariance: string;
    nDone: string;
    runIntegral: string;
    runMCMC: string;
    useDegradation: string;
    adjQbp: string;
    runDeconvolution: string;
    steptol: string;
    useResttol: string;
    resttol: string;
    allowVariableNoC: string;
    outNoc: string;
    outDegYes: string;
    outDegNo: string;
    outBwStutYes: string;
    outBwStutNo: string;
    outFwStutYes: string;
    outFwStutNo: string;
    seed: string;
    maxIterations: string;
    maxThreads: string;
    difftol: string;
    calcAicIndependently: string;
    nC: string;
    niter: string;
    doBurnIn: string;
    mcmcQuantile: string;
    mcmcNiterBurnIn: string;
    runHp: string;
    runHd: string;
    mfRunHp: string;
    mfRunHd: string;
    ntippets: string;
    refSampleId: string;
    signifLevel: string;
    threshMac: string;
    threshLr: string;
    minFreq: string;
    maxNoc: string;
    searchBetweenStains: string;
    majorRate: string;
    majorMinLoci: string;
    deconvProbThresh: string;
    deconvMinLoci: string;
    searchBetweenDeconvoluted: string;
    useExtendedSearch: string;
    uploadStartDate: string;
    uploadEndDate: string;
    limitToAgency: string;
    kitId: string;
    isAIC: string;
    noc: string;
    highlighProbAbove: string;
    useMarkerSpecificSettings: string;
    rareAlleleFreq: string;
    rareAlleleFreqType: string;
    populationN: string;
    brutusFeatureToUse: string;
    brutusUsePopulationSubstructure: string;
    brutusTheta: string;
    brutusSilentAlleleFreq: string;
    brutusFemaleMu: string;
    brutusMaleMu: string;
    brutusMaleMus: string;
    brutusFemaleMus: string;
    brutusUseMarkerSpecificSettingsMu: string;
    brutusPriorProbability: string;
    brutusAvgAgeFatherhood: string;
    brutusAvgAgeMotherhood: string;
    kinMac: string;
    kinParentChildEnabled: string;
    kinSiblingsEnabled: string;
    kinExtFamilyEnabled: string;
    kinStrParentChild: string;
    kinStrSibling: string;
    kinStrExtFamily: string;
    kinCRIThreshParentChild: string;
    kinCRIThreshSibling: string;
    kinCRIThreshExtFamily: string;
    kinMinFreq: string;
    kinBayesPriorProbability: string;
    kinUseExtendedSearch: string;
    kinUploadStartDate: string;
    kinUploadEndDate: string;
    kinUseMutations: string;
    intDev: string;
    intCustomScaling: string;
    intCustomScalingHpBounds: string;
    intCustomScalingHdBounds: string;
    nocPenalty: string;
    degPenalty: string;
    bwStutPenalty: string;
    fwStutPenalty: string;
    genMu: string;
    genSigma: string;
    genDegSlope: string;
    genBwStutter: string;
    genFwStutter: string;
    genMixProps: string;
    genEvidenceName: string;
}

export interface ParameterDescriptionResources {
    detectionThreshold: string;
    dropInHyperParam: string;
    dropInProbability: string;
    fstCorrection: string;
    limitEvaluations: string;
    maxEval: string;
    maxMu: string;
    maxSigma: string;
    maxXi: string;
    relTol: string;
    scale: string;
    stutterProp: string;
    useStutter: string;
    fwStutterProp: string;
    useFwStutter: string;
    alphaProb: string;
    delta: string;
    maxListSize: string;
    mcMcSamples: string;
    mcMcVariance: string;
    nDone: string;
    runIntegral: string;
    runMCMC: string;
    useDegradation: string;
}

export interface JobPhaseResources {
    maxlr_calculate_hp: string;
    maxlr_calculate_hd: string;
    maxlr_epg: string;
    maxlr_deconvolve_hp: string;
    maxlr_deconvolve_hd: string;
    maxlr_plot_mle_hp: string;
    maxlr_plot_mle_hd: string;
    maxlr_system_lr: string;
    maxlr_mcmc_hp: string;
    maxlr_mcmc_hd: string;
    maxlr_mcmc_hp_plot: string;
    maxlr_mcmc_hd_plot: string;
    maxlr_mcmc_sensitivity: string;
    maxlr_mcmc_quantile: string;
    maxlr_integral_hp: string;
    maxlr_integral_hd: string;
    maxlr_fitted_epg_hd: string;
    maxlr_fitted_epg_hp: string;
    maxlr_results: string;
    evidencegraph_render: string;
    integral_calculate_hp: string;
    integral_calculate_hd: string;
    integral_results: string;
    maxlr_aic_calculate_aic: string;
    maxlr_aic_calculate_deconv: string;
    maxlr_aic_epg: string;
    maxlr_aic_results: string;
    maxlr_aic_system_lr: string;
    model_fitted_epg_hd: string;
    model_fitted_epg_hp: string;
    model_fitted_results: string;
    model_validation_mle_hp: string;
    model_validation_mle_hd: string;
    model_validation_results: string;
    deconvolution_deconvolve_hp: string;
    deconvolution_deconvolve_hd: string;
    deconvolution_results: string;
    mcmc_maxlr_calculate_hp: string;
    mcmc_maxlr_calculate_hd: string;
    mcmc_hp: string;
    mcmc_hd: string;
    mcmc_burn_in: string;
    mcmc_burn_in_hd: string;
    mcmc_hp_plot: string;
    mcmc_hd_plot: string;
    mcmc_sensitivity: string;
    mcmc_quantile: string;
    mcmc_sensitivity_results: string;
    nc_analysis_calculation: string;
    nc_analysis_results: string;
    dnamatch_lrqual_calc: string;
    dnamatch_results: string;
    deconv_main_calculate_hp: string;
    deconv_main_epg: string;
    deconv_main_deconvolve_hp: string;
    deconv_main_results: string;
    deconv_main_calculate_aic: string;
    brutus_calc: string;
    brutus_results: string;
    brutus_calc_h1: string;
    brutus_calc_h2: string;
    familial_search_calc: string;
    familial_search_results: string;
    gen_sample_generate: string;
}

export interface EvidenceResources {
    name: string;
    fileCannotBeProcessed: string;
    fileErrors: string;
    evidenceFile: string;
    evidenceNames: string;
    createFromExistingTitle: string;
    originalName: string;
    selectMarkersForInclude: string;
    normalizeForLSAE: string;
}

export interface SampleResources {
    name: string;
    fileCannotBeProcessed: string;
    fileErrors: string;
    sampleFile: string;
    sampleNames: string;
    sampleInUAS: string;
    unsupportedKit: string;
    invalidAlleleFormat: string;
    dateOfBirth: string;
    createFromExistingTitle: string;
    originalName: string;
    age: string;
    ageYears: string;
    ageMonths: string;
    birthDay: string;
    birthMonth: string;
    birthYear: string;
}

export interface CaseRunResources {
    runInformation: string;
    review: string;
    hpContributors: string;
    hdContributors: string;
    hpUnknowns: string;
    hdUnknowns: string;
    general: string;
    contributorsInHp: string;
    contributorsInHd: string;
    unknowns: string;
    queueRun: string;
    loadingData: string;
    runDescription: string;
    errorsOnForm: string;
    next: string;
    runType: string;
    step: string;
    numberOfContributors: string;
    rangeOfContributors: string;
    firstUnknownRelation: string;
    numberOfContributorsError: string;
    onlyOnePoiCanBeSelectedError: string;
    commonLoci: string;
    totalAlleleCount: string;
    mac: string;
    noc: string;
    notes: string;
    hideInterSampleDeductionMatches: string;
    use2pMACforHomozygousDeductions: string;
    twoPMAC: string;
    intraCaseHitsOnly: string;
    use2pforHomozygousDeductions: string;
    calculationDeleteConfirm: string;
    showInactiveCalculations: string;
    customDataSelection: string;
    allowVariableNoc: string;
}

export interface KitResources {
    name: string;
    fullName: string;
    marker: string;
    allele: string;
    repeat: string;
    markerMin: string;
    markerMax: string;
    genderMarker: string;
    qualitySensor: string;
    color: string;
    offset: string;
    markers: string;
    kitDetails: string;
    kitEdit: string;
    size: string;
    sizeMin: string;
    sizeMax: string;
    virtual: string;
}

export interface LikelihoodTypeResources {
    maximum: string;
    bayes_unrestricted: string;
    sensitivity: string;
    integral: string;
    mcmc_sensitivity: string;
    deconvolution: string;
    model_validation: string;
    model_fitted: string;
    nc_analysis: string;
    brutus: string;
    gen_sample: string;
}

export interface WorkQueueResources {
    completed: string;
    checkData: string;
    queued: string;
    created: string;
    jobType: string;
    workers: string;
    workerTaskId: string;
    workerName: string;
}

export interface RunTypeResources {
    evidencegraph: string;
    integral: string;
    maxlr: string;
    maxlr_aic: string;
    mcmc_sensitivity: string;
    deconvolution: string;
    model_validation: string;
    nc_analysis: string;
    model_fitted: string;
    dnamatch: string;
    deconv_main: string;
    brutus: string;
    familial_search: string;
    evidencegraph_short: string;
    integral_short: string;
    maxlr_short: string;
    maxlr_varnoc_short: string;
    maxlr_aic_short: string;
    maxlr_aic_varnoc_short: string;
    mcmc_sensitivity_short: string;
    deconvolution_short: string;
    deconvolution_aic_short: string;
    model_validation_short: string;
    nc_analysis_short: string;
    model_fitted_short: string;
    dnamatch_short: string;
    deconv_main_short: string;
    deconv_main_aic_short: string;
    brutus_short: string;
    familial_search_short: string;
    gen_sample: string;
    gen_sample_short: string;
}

export interface RelationsResources {
    unrelated: string;
    parent: string;
    child: string;
    sibling: string;
    uncle: string;
    nephew: string;
    grandparent: string;
    grandchild: string;
    halfSibling: string;
    cousin: string;
    twinIdent: string;
}

export interface CaseRunResources2 {
    caseRunDetails2: string;
    caseRunDetails: string;
    runDetails: string;
    runDetailsWithLink: string;
    newRun: string;
    newRunWithLink: string;
    newAicRun: string;
    copyRun: string;
    newAicRunWithLink: string;
    copyRunWithLink: string;
    calculate: string;
    calculateWithLink: string;
    clone: string;
    print: string;
    export: string;
    aicComparison: string;
    deleteConfirm: string;
    deletedMessage: string;
    copiedFrom: string;
    timeUsed: string;
    timeUsedMinutes: string;
    aicRuns: string;
    hpUnknowns: string;
    hdUnknowns: string;
    hpUnknownsShort: string;
    hdUnknownsShort: string;
    stutter: string;
    degradation: string;
    phExpectation: string;
    phVariability: string;
    aicScore: string;
    additionalCalculations: string;
    calculationType: string;
    calculationTime: string;
    step: string;
    calculationTasks: string;
    parameterEstimates: string;
    mle: string;
    stdError: string;
    mixPropNumber: string;
    degradationSlope: string;
    stutterProp: string;
    fwStutterProp: string;
    maximumLikelihood: string;
    logLikelihood: string;
    likelihood: string;
    modelValidation: string;
    fittedModel: string;
    deconvolution: string;
    topMarginal: string;
    allJoint: string;
    allMarginalGenotypes: string;
    allMarginalAlleles: string;
    genotype: string;
    probability: string;
    ratioToNext: string;
    noDeconvolution: string;
    rank: string;
    overview: string;
    hp: string;
    hd: string;
    weightOfEvidence: string;
    mlSystemRatio: string;
    epgOverlay: string;
    sensitivity: string;
    likelihoodRatio: string;
    likelihoodRatioLog10: string;
    likelihoodRatioLog10Short: string;
    noResults: string;
    evaluations: string;
    useDegradation: string;
    useStutter: string;
    useFwStutter: string;
    likelihoodRatioShort: string;
    calculations: string;
    copyRunMenu: string;
    bayesianNumerical: string;
    information: string;
    notes: string;
    samplingAcceptanceRate: string;
    hpDetails: string;
    hdDetails: string;
    hpTopMarginal: string;
    hdTopMarginal: string;
    pageNumber: string;
    hpFittedModel: string;
    hdFittedModel: string;
    graphs: string;
    noGraphs: string;
    mcmcParameters: string;
    aicCalcUseBwStutter: string;
    aicCalcUseFwStutter: string;
    aicCalcUseDegradation: string;
    aicCalcNumberOfContributors: string;
    aicCalcLogLik: string;
    aicCalcAdjLogLik: string;
    aicCalcLog10LR: string;
    aicCalcMxPOI: string;
    aicCalcSignifHp: string;
    aicCalcSignifHd: string;
    mcmcSensitivity: string;
    mcmcTracePlot: string;
    mcmcBurnIn: string;
    mcmcBurnInHd: string;
    mcmcNiter: string;
    mcmcDelta: string;
    ncAnalysis: string;
    ncAnalysisMax: string;
    ncAnalysisLogMax: string;
    ncAnalysisMeanLR: string;
    firstUnknownRelation: string;
    commonLoci: string;
    matchingLoci: string;
    totalAlleleCount: string;
    mac: string;
    noc: string;
    calculationDetails: string;
    hpResults: string;
    hdResults: string;
    resultsOverview: string;
    marginalGenotypesSummaryTable: string;
    marginalAllelesSummaryTable: string;
}

export interface KitResources2 {
    name: string;
    fullName: string;
    shortName: string;
}

export interface EvidenceResources2 {
    name: string;
    details: string;
    detailsWithLink: string;
    deleteConfirm: string;
    deletedHeader: string;
    deletedMessage: string;
    alleleWithNumber: string;
    heightWithNumber: string;
    degradationPending: string;
    epgPending: string;
    fileErrors: string;
    evidenceFile: string;
    editTitleWithLink: string;
    editTitle: string;
    editTitleWoCase: string;
    uploadTitleWithLink: string;
    uploadTitle: string;
    uploadTitleWoCase: string;
    importTitle: string;
}

export interface CaseResources2 {
    create: string;
    name: string;
    edit: string;
    createRun: string;
    deleteCaseConfirm: string;
    caseDetailHeader: string;
    hasQualityCheckProfiles: string;
}

export interface UserResources2 {
    name: string;
    showInactive: string;
    create: string;
    details: string;
    edit: string;
    roles: string;
    disableConfirm: string;
    enableConfirm: string;
    resendEmail: string;
    emailResent: string;
    emailProblem: string;
    accountCreatedSubject: string;
    accountCreatedBody: string;
    changePassword: string;
    inactiveUser: string;
}

export interface LabResources2 {
    allLabs: string;
    create: string;
    name: string;
    showInactiveLabs: string;
    labDetail: string;
    disable: string;
    enable: string;
    edit: string;
    serverErrorWhileCreating: string;
    unknownDateRange: string;
}

export interface PopulationResources2 {
    detail: string;
    deleteConfirm: string;
    edit: string;
    inUse: string;
    upload: string;
    showInactive: string;
    createLocalPopulation: string;
    weight: string;
    sourcePopulations: string;
}

export interface ReportTextsResources {
    reportTexts: string;
    firstUnknownRelation: string;
    unrelatedIndividual: string;
    unrelatedIndividuals: string;
    unknownCount: string;
    reportTextTemplate: string;
    tags: string;
    help: string;
    preview: string;
}

export interface ReportTextTagsResources {
    singleSource: string;
    noc: string;
    nocText: string;
    runId: string;
    evidenceName: string;
    hp: string;
    hd: string;
    moreLikelyTimes: string;
    moreLikelyTimesText: string;
    likelihoodRatio: string;
    likelihoodRatioText: string;
    hypStronger: string;
    hypWeaker: string;
    systemCount: string;
    systemCountText: string;
    cri: string;
    criText: string;
    priorProbability: string;
    priorProbabilityPercent: string;
    probability: string;
    probabilityPercent: string;
    h1SupportText: string;
    population: string;
    rmp: string;
    rmpText: string;
    oneDivRmp: string;
    oneDivRmpText: string;
}

export interface SampleResources2 {
    name: string;
    details: string;
    detailsWoCase: string;
    detailsWithLink: string;
    editTitle: string;
    editTitleWithLink: string;
    uploadTitle: string;
    uploadWoCaseTitle: string;
    importTitle: string;
    uploadTitleWithLink: string;
    confirmDelete: string;
    deletedHeader: string;
    deletedMessage: string;
    allele1: string;
    allele2: string;
    sampleFile: string;
    fileErrors: string;
    alleleWithNumber: string;
}

export interface AppSettingsResources {
    emailSettings: string;
    emailProvider: string;
    emailFromEmail: string;
    emailFromName: string;
    emailSmtpHost: string;
    emailSmtpPort: string;
    emailSmtpUsername: string;
    emailSmtpPassword: string;
    emailSmtpUseSsl: string;
    emailSendGridApiKey: string;
    emailSendTestEmail: string;
    populationFrequencyMaxError: string;
    requestAccessUrl: string;
    generalSettings: string;
}

export interface BrutusResources {
    sex: string;
    unknown: string;
    male: string;
    female: string;
    parent: string;
    parents: string;
    child: string;
    children: string;
    untested: string;
    pedigree: string;
    pedigreeH1: string;
    pedigreeH2: string;
    questionRelation: string;
    testType: string;
    combRelIndex: string;
    undHumRem: string;
    freeform: string;
    kinship: string;
    uhr: string;
    expression: string;
    index: string;
    featureSilentAllele: string;
    featureNone: string;
    featureMutations: string;
    dnaProfileAvailable: string;
    dnaProfileUploadDate: string;
    progeny: string;
    certaintyOfRelation: string;
    assumedTrue: string;
    questioned: string;
    pedigreeDefined: string;
    relative1: string;
    relative2: string;
    cri: string;
    parentChildCRI: string;
    fullSibsCRI: string;
    extFamilyCRI: string;
    relationships: KinshipRelationshipsResources;
}

export interface KinshipRelationshipsResources {
    parentChild: string;
    fullSiblings: string;
    extFamily: string;
}

export interface CaseRunStatusResources {
    queued: string;
    pending: string;
    running: string;
    successful: string;
    failed: string;
}

export interface HomeResources {
    homePage: string;
    recentCases: string;
    recentRuns: string;
}

export interface CustomPanelResources {
    customPanel: string;
    customPanels: string;
    name: string;
    details: string;
    detailsWithLink: string;
    editTitle: string;
    editTitleWithLink: string;
    uploadTitle: string;
    uploadTitleWithLink: string;
    confirmDelete: string;
    deletedHeader: string;
    deletedMessage: string;
}

export interface MetadataResources {
    enrollments: string;
    enrollmentCreate: string;
    persons: string;
    personCreate: string;
    firstName: string;
    lastName: string;
    middleName: string;
    dateOfBirth: string;
    queryBuilderQuick: string;
    queryBuilderDeep: string;
    ethnicityLabel: string;
    placeOfBirthCityLabel: string;
    placeOfBirthStateLabel: string;
    placeOfBirthCountryLabel: string;
    fatherLastNameLabel: string;
    motherLastNameLabel: string;
    aliasNameLabel: string;
    aliasesLabel: string;
    enrollmentPurposeLabel: string;
    dateOfBirthFuture: string;
    sexLabel: string;
    secondLastNameLabel: string;
    agencyCaseNumberLabel: string;
    agencyOriLabel: string;
    fbiNumberLabel: string;
    sidNumberLabel: string;
    nationalityLabel: string;
    addressTypeLabel: string;
    addressLine1Label: string;
    addressLine2Label: string;
    cityLabel: string;
    stateLabel: string;
    countryLabel: string;
    postalCodeLabel: string;
    isPrimaryLabel: string;
    endDateLabel: string;
    startDateLabel: string;
    phoneTypeLabel: string;
    phoneNumberLabel: string;
    emailsLabel: string;
    emailAddressLabel: string;
    invalidEmail: string;
    phonesLabel: string;
    addressesLabel: string;
    alleleFormatLabel: string;
    idTypeLabel: string;
    idNumberLabel: string;
    idCountryLabel: string;
    idStateLabel: string;
    identificationsLabel: string;
    samplesLabel: string;
    collectorLabel: string;
    collectorNameLabel: string;
    collectionDateLabel: string;
    collectionDateFuture: string;
    kitLabel: string;
    sampleNameLabel: string;
    andeSwabIdLabel: string;
    dnaProfileLabel: string;
    onlyOneSampleAllowed: string;
    eyeColorLabel: string;
    hairColorLabel: string;
    heightLabel: string;
    weightLabel: string;
    picturesLabel: string;
    fileNameLabel: string;
    contentTypeLabel: string;
    contentLabel: string;
    maximumPicturesAllowed: string;
    physicalFeaturesLabel: string;
    featureTypeLabel: string;
    descriptionLabel: string;
    occupationLabel: string;
    employerNameLabel: string;
    employerAddressLine1Label: string;
    employerAddressLine2Label: string;
    employerStateNameLabel: string;
    employerStateLabel: string;
    employerPostalLabel: string;
    employerPhoneLabel: string;
    employerPostalCodeLabel: string;
    employerCityLabel: string;
    employerCountryLabel: string;
    employmentLabel: string;
    systemLabel: string;
    alleleLabel: string;
    systemsLabel: string;
    atLeastOneSystemRequired: string;
}

export interface AuthResources {
    logIn: string;
    useLocalAccountToLogIn: string;
    email: string;
    password: string;
    rememberMe: string;
    forgotYourPassword: string;
    registerAsNewUser: string;
    resendEmailConfirmation: string;
    logInButton: string;
    useAnotherServiceToLogIn: string;
    noExternalAuthConfigured: string;
    logInUsingProviderAccount: string;
    invalidLoginAttempt: string;
    register: string;
    createNewAccount: string;
    confirmPassword: string;
    registerButton: string;
    useAnotherServiceToRegister: string;
    noExternalAuthConfiguredRegister: string;
    logInUsingProviderAccountRegister: string;
    passwordLengthError: string;
    passwordsDoNotMatch: string;
    forgotYourPasswordTitle: string;
    enterYourEmail: string;
    resetPasswordButton: string;
    resetPasswordEmailSubject: string;
    resetPasswordEmailBody: string;
    resendEmailConfirmationTitle: string;
    resendEmailConfirmationEnterEmail: string;
    resendButton: string;
    verificationEmailSent: string;
    confirmYourEmail: string;
    confirmEmailBody: string;
    confirmationEmailSentInbox: string;
    failedToSendConfirmationEmail: string;
    errorOccurredTryAgain: string;
    invalidEmailAddress: string;
    emailIsRequired: string;
    emailPlaceholder: string;
    twoFactorAuthentication: string;
    twoFactorAuthenticatorPrompt: string;
    authenticatorCode: string;
    rememberThisMachine: string;
    noAuthenticatorAccessPrompt: string;
    logInWithRecoveryCode: string;
    invalidAuthenticatorCode: string;
    unableToLoadTwoFactorUser: string;
    recoveryCodeVerification: string;
    recoveryCodeLoginInfo: string;
    recoveryCode: string;
    recoveryCodePlaceholder: string;
}

export interface AccountResources {
    login: string;
    forgotPassword: string;
    requestAccess: string;
    problemLoggingIn: string;
    changePassword: string;
    changePasswordFor: string;
    currentPassword: string;
    newPassword: string;
    confirmNewPassword: string;
    resetPassword: string;
    passwordResetEmailSent: string;
    passwordChanged: string;
    yourPasswordHasBeenChanged: string;
    clickToLoginWithNewPassword: string;
    problemSettingPassword: string;
    unknownUser: string;
    loginExpired: string;
    resetPasswordSubject: string;
    resetPasswordBody: string;
    credits: string;
}

export interface UserSearchResponse {
    foundUsers?: FoundUser[] | undefined;
}

export interface FoundUser {
    email?: string | undefined;
    name?: string | undefined;
}

export interface UserEditResponseModel extends ResponseModel {
}

export interface UserEditModel {
    id: string;
    name: string;
    email: string;
    country?: string | undefined;
    timeZone?: string | undefined;
    role: string;
    labs?: number[] | undefined;
    locale: string;
    isActive: boolean;
}

export interface CreateUserResponseModel {
    userId: string;
    url?: string | undefined;
    success: boolean;
    errors?: string[] | undefined;
}

export interface CreateUserModel {
    email: string;
    name: string;
    role: string;
    labs?: number[] | undefined;
    locale: string;
}

export interface DataTableResultOfUserGridModel {
    items?: UserGridModel[] | undefined;
    totalRows: number;
}

export interface UserGridModel {
    id: string;
    email?: string | undefined;
    name?: string | undefined;
    roleList?: string | undefined;
    labList?: string | undefined;
    url?: string | undefined;
    active: boolean;
}

export interface ChangePasswordResponseModel extends ResponseModel {
}

export interface ChangePasswordModel {
    currentPassword: string;
    password: string;
    confirmPassword?: string | undefined;
    changePasswordErrors?: string | undefined;
}

export interface TwoFactorSetupModel {
    sharedKey?: string | undefined;
    authenticatorUri?: string | undefined;
}

export interface JobResponse {
    jobId?: string | undefined;
    efmVersion?: string | undefined;
    rVersion?: string | undefined;
    successful: boolean;
    log?: string | undefined;
    startTime: number;
    endTime: number;
    labId: number;
    caseId: number;
    caseRunId: number;
    calculationId: number;
    jobType: JobType;
    evidenceGraphJobResponse?: EvidenceGraphJobResponse | undefined;
    maxLrJobResponse?: MaxLrJobResponse | undefined;
    integralJobResponse?: IntegralJobResponse | undefined;
    maxLrAicJobResponse?: MaxLrAicJobResponse | undefined;
    mcmcSensitivityJobResponse?: McmcSensitivityJobResponse | undefined;
    deconvolutionJobResponse?: MaxLrDeconvolutionJobResponse | undefined;
    modelValdationJobResponse?: MaxLrModelValidationJobResponse | undefined;
    modelFittedJobResponse?: MaxLrModelFittedJobResponse | undefined;
    nonContributorAnalysisJobResponse?: MaxLrNonContributorAnalysisJobResponse | undefined;
    dnaMatchJobResponse?: DnaMatchJobResponse | undefined;
    deconvMainJobResponse?: DeconvMainJobResponse | undefined;
    brutusJobResponse?: BrutusJobResponse | undefined;
    familialSearchJobResponse?: FamilialSearchJobResponse | undefined;
    generateSampleJobResponse?: GenerateSampleJobResponse | undefined;
    jobResponseDataCase: JobResponseDataOneofCase;
}

export enum JobType {
    EvidenceGraph = 0,
    MaxLr = 1,
    Integral = 2,
    MaxLrAic = 3,
    McmcSensitivity = 4,
    MaxLrDeconvolution = 5,
    MaxLrModelValidation = 6,
    MaxLrModelFitted = 7,
    MaxLrNonContributorAnalysis = 8,
    DnaMatch = 9,
    DeconvMain = 10,
    Brutus = 11,
    FamilialSearch = 12,
    GenerateSample = 13,
}

export interface EvidenceGraphJobResponse {
    epgSvg?: string | undefined;
    degradationSvg?: string | undefined;
    evidenceId: number;
    epgPlotlyJson?: string | undefined;
}

export interface MaxLrJobResponse {
    likelihoodRatio: number;
    likelihoodRatioLog10: number;
    sensitivity?: string | undefined;
    hd?: MaxLrResult | undefined;
    hp?: MaxLrResult | undefined;
    systems?: SystemLr[] | undefined;
    epg?: string | undefined;
    likelihoods?: MaxLrLikelihood[] | undefined;
    hdRawBase64?: string | undefined;
    hpRawBase64?: string | undefined;
    epgPlotlyJson?: string | undefined;
}

export interface SystemLr {
    system?: string | undefined;
    lr: number;
}

export interface MaxLrAicJobResponse {
    result?: MaxLrAicCalculation | undefined;
    calculations?: MaxLrAicCalculation[] | undefined;
    hdRawBase64?: string | undefined;
    hpRawBase64?: string | undefined;
    epg?: string | undefined;
    systems?: SystemLr[] | undefined;
    epgPlotlyJson?: string | undefined;
}

export interface MaxLrAicCalculation {
    logLik: number;
    adjLogLik: number;
    log10LR: number;
    mxPOI: number;
    signifHp: number;
    signifHd: number;
    noc: number;
    modelDegrad: boolean;
    modelBWstutt: boolean;
    modelFWstutt: boolean;
    hd?: MaxLrResult | undefined;
    hp?: MaxLrResult | undefined;
    likelihoods?: MaxLrLikelihood[] | undefined;
    likelihoodRatio: number;
    likelihoodRatioLog10: number;
    adjLogLikHp: number;
    adjLogLikHd: number;
    nocHd: number;
    modelDegradHd: boolean;
    modelBWstuttHd: boolean;
    modelFWstuttHd: boolean;
}

export interface MaxLrDeconvolutionJobResponse {
    calculationId: number;
    hd?: Deconvolution | undefined;
    hp?: Deconvolution | undefined;
}

export interface MaxLrModelValidationJobResponse {
    calculationId: number;
    hdSvg?: string | undefined;
    hpSvg?: string | undefined;
}

export interface MaxLrModelFittedJobResponse {
    calculationId: number;
    hdSvg?: string | undefined;
    hpSvg?: string | undefined;
    hdPlotly?: string | undefined;
    hpPlotly?: string | undefined;
}

export interface MaxLrNonContributorAnalysisJobResponse {
    calculationId: number;
    max: number;
    meanLR: number;
    logMax: number;
    graph?: string | undefined;
    lrmr?: number[] | undefined;
}

export interface DnaMatchJobResponse {
    matches?: DnaMatchResultItem[] | undefined;
    samplesFromStains?: DeducedSample[] | undefined;
}

export interface DnaMatchResultItem {
    referenceId: number;
    evidenceId: number;
    commonLoci: number;
    totalAlleleCount: number;
    mac: number;
    nContr: number;
    lrQualLog10: number;
    logHp: number;
    logHd: number;
    referenceName?: string | undefined;
    evidenceName?: string | undefined;
    resultId?: string | undefined;
    referenceUid?: string | undefined;
    evidenceUid?: string | undefined;
    referenceCaseId: number;
    evidenceCaseId: number;
    lrElapsedSeconds: number;
    systemLr?: SystemLr2[] | undefined;
    macHomozygOnce: number;
    lrQualLog102P: number;
}

export interface SystemLr2 {
    system?: string | undefined;
    lr: number;
    logHd: number;
    logHp: number;
    hpPenalty: number;
    lrWithPenalty: number;
}

export interface DeducedSample {
    name?: string | undefined;
    systems?: SystemAlleles[] | undefined;
    uid?: string | undefined;
    bpEvidenceId: number;
    bpLabId: number;
    bpCaseId: number;
    isFromDb: boolean;
}

export interface DeconvMainJobResponse {
    calculationId: number;
    hpDeconv?: Deconvolution | undefined;
    hpMaxLr?: MaxLrResult | undefined;
    hpRawBase64?: string | undefined;
    epg?: string | undefined;
    epgPlotlyJson?: string | undefined;
    result?: MaxLrAicCalculation | undefined;
    calculations?: MaxLrAicCalculation[] | undefined;
}

export enum JobResponseDataOneofCase {
    None = 0,
    EvidenceGraphJobResponse = 10,
    MaxLrJobResponse = 11,
    IntegralJobResponse = 12,
    MaxLrAicJobResponse = 13,
    McmcSensitivityJobResponse = 14,
    DeconvolutionJobResponse = 15,
    ModelValdationJobResponse = 16,
    ModelFittedJobResponse = 17,
    NonContributorAnalysisJobResponse = 18,
    DnaMatchJobResponse = 19,
    DeconvMainJobResponse = 20,
    BrutusJobResponse = 21,
    FamilialSearchJobResponse = 22,
    GenerateSampleJobResponse = 23,
}

export interface WorkQueueItemDetailModel {
    jobs?: WorkQueueJobModel[] | undefined;
}

export interface WorkQueueJobModel {
    id: string;
    completed?: Date | undefined;
    started?: Date | undefined;
    failed?: Date | undefined;
    phase?: string | undefined;
    displayName?: string | undefined;
    displayOrder: number;
    stdOut?: string | undefined;
}

export interface DataTableResultOfWorkQueueItemModel {
    items?: WorkQueueItemModel[] | undefined;
    totalRows: number;
}

export interface WorkQueueItemModel {
    id: string;
    labId: number;
    labName?: string | undefined;
    timeZone?: string | undefined;
    labUrl?: string | undefined;
    caseId?: number | undefined;
    caseName?: string | undefined;
    caseUrl?: string | undefined;
    caseRunId?: number | undefined;
    caseRunUrl?: string | undefined;
    runTypeId?: string | undefined;
    runTypeName?: string | undefined;
    created: Date;
    queued?: Date | undefined;
    completed?: Date | undefined;
    failed?: Date | undefined;
    jobCount: number;
    startedJobs: number;
    failedJobs: number;
    completedJobs: number;
    calculationId?: number | undefined;
    calculationUrl?: string | undefined;
    evidenceId?: number | undefined;
    isDeleted?: boolean | undefined;
}

export interface WorkersAndTasksModel {
    workers?: WorkerModel[] | undefined;
    activeTasks?: TaskModel[] | undefined;
    scheduledTasks?: TaskModel[] | undefined;
    reserverdTasks?: TaskModel[] | undefined;
    revokedTasks?: TaskModel[] | undefined;
}

export interface WorkerModel {
    name?: string | undefined;
}

export interface TaskModel {
    workerName?: string | undefined;
    taskId?: string | undefined;
    taskName?: string | undefined;
    startTime?: number | undefined;
    phase?: string | undefined;
    bpJobId?: string | undefined;
    caseRunId: number;
    calculationId?: number | undefined;
}

export interface NodeUsageSummary {
    nodeName?: string | undefined;
    cpuUsedRaw?: string | undefined;
    cpuUsedM: number;
    cpuUsedRatio: number;
    memoryUsedRaw?: string | undefined;
    memoryUsedBytes: number;
    memoryUsedRatio: number;
    cpuTotalCores?: string | undefined;
    memoryTotalRaw?: string | undefined;
    memoryTotalBytes: number;
    workers?: WorkerUsageSummary[] | undefined;
}

export interface WorkerUsageSummary {
    workerName?: string | undefined;
    cpuUsageRaw?: string | undefined;
    cpuUsageM: number;
    cpuUsageRatio: number;
    memoryUsageRaw?: string | undefined;
    memoryUsageBytes: number;
    memoryUsageRatio: number;
}

export interface SexDto {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
}

export interface EyeColorDto {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
}

export interface HairColorDto {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
}

export interface PhoneTypeDto {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
}

export interface IdTypeDto {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
}

export interface FeatureTypeDto {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
}

export interface EnrollmentPurposeDto {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
}

export interface EthnicityDto {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
}

export interface CityDto {
    id: number;
    isoCode?: string | undefined;
    name?: string | undefined;
}

export interface StateDto {
    id: number;
    isoCode?: string | undefined;
    name?: string | undefined;
}

export interface CountryDto {
    id: number;
    alpha3?: string | undefined;
    alpha2?: string | undefined;
    name?: string | undefined;
    phonePrefix?: string | undefined;
}

export interface AddressTypeDto {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
}

export interface PersonSampleCollectorDto {
    id: number;
    name?: string | undefined;
}

export interface PersonDto {
    id?: number | undefined;
    enrollmentPurposeId: number;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    dob: Date;
    sexId?: number | undefined;
    nationalityId?: number | undefined;
    agencyOri?: string | undefined;
    agencyCaseNumber?: string | undefined;
    fbiNumber?: string | undefined;
    sidNumber?: string | undefined;
    eyeColorId?: number | undefined;
    hairColorId?: number | undefined;
    heightInM?: number | undefined;
    weightInKg?: number | undefined;
    ethnicityId?: number | undefined;
    pobCityId?: number | undefined;
    pobCountryId?: number | undefined;
    pobStateId?: number | undefined;
    fatherLastName?: string | undefined;
    motherLastName?: string | undefined;
    addresses?: PersonAddressDto[] | undefined;
    aliases?: PersonAliasDto[] | undefined;
    emails?: PersonEmailDto[] | undefined;
    phones?: PersonPhoneDto[] | undefined;
    physicalFeatures?: PersonPhysicalFeatureDto[] | undefined;
    pictures?: PersonPictureDto[] | undefined;
    identifications?: PersonIdentificationDto[] | undefined;
    employmentHistory?: EmploymentDto[] | undefined;
    samples?: PersonSampleDto[] | undefined;
    labId: number;
    isEnrollmentCompleted: boolean;
}

export interface PersonAddressDto {
    id?: number | undefined;
    personId?: number | undefined;
    addressTypeId: number;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressCityId?: number | undefined;
    addressCityName?: string | undefined;
    addressStateId?: number | undefined;
    addressStateName?: string | undefined;
    addressCountryId: number;
    addressPostalCode?: string | undefined;
    addressIsPrimary: boolean;
    addressEndDate?: Date | undefined;
    addressStartDate?: Date | undefined;
}

export interface PersonAliasDto {
    id?: number | undefined;
    aliasName?: string | undefined;
}

export interface PersonEmailDto {
    id?: number | undefined;
    emailAddress?: string | undefined;
}

export interface PersonPhoneDto {
    id?: number | undefined;
    phoneNumber?: string | undefined;
    phoneTypeId: number;
}

export interface PersonPhysicalFeatureDto {
    id?: number | undefined;
    featureTypeId: number;
    description?: string | undefined;
}

export interface PersonPictureDto {
    id?: number | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    content?: string | undefined;
}

export interface PersonIdentificationDto {
    id?: number | undefined;
    idTypeId: number;
    idNumber?: string | undefined;
    idCountryId: number;
    idStateId?: number | undefined;
}

export interface EmploymentDto {
    id?: number | undefined;
    employerName?: string | undefined;
    occupation?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    employerPhone?: string | undefined;
    employerAddressLine1?: string | undefined;
    employerAddressLine2?: string | undefined;
    employerCityId?: number | undefined;
    employerCityName?: string | undefined;
    employerStateId?: number | undefined;
    employerPostalCode?: string | undefined;
    employerStateName?: string | undefined;
    employerCountryId: number;
}

export interface PersonSampleDto {
    id?: number | undefined;
    sampleId?: number | undefined;
    sampleName?: string | undefined;
    kitId?: number | undefined;
    alleleFormat?: AlleleFormat | undefined;
    collectionDate: Date;
    collectorId?: string | undefined;
    collectorName?: string | undefined;
    andeSwabId?: string | undefined;
    keyboardSample?: SampleCreateKeyboardModel | undefined;
}

export interface DataTableResultOfPersonListDto {
    items?: PersonListDto[] | undefined;
    totalRows: number;
}

export interface PersonListDto {
    id: number;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    dob?: Date | undefined;
    agencyOri?: string | undefined;
    createdAt: Date;
    enrollmentPurpose?: string | undefined;
}

export interface PersonSearchResponse {
    items?: PersonListDto[] | undefined;
    sql?: string | undefined;
    linq?: string | undefined;
}

export interface SearchByCriterasDto {
    criterias?: CriteriaBase[] | undefined;
}

export interface CriteriaBase {
    operator?: string | undefined;
    discriminator: string;
}

export interface BiographicalSearchDto extends CriteriaBase {
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
}

export interface PhysicalInfoSearchDto extends CriteriaBase {
    eyeColor?: number | undefined;
    hairColor?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
}

export interface PhysicalFeaturesSearchDto extends CriteriaBase {
    featureType: number;
    description?: string | undefined;
}

export interface AdditionalInfoSearchDto extends CriteriaBase {
    nationality: number;
    sex: number;
    fbiNumber?: string | undefined;
}

export interface ContactSearchDto extends CriteriaBase {
    addressLine1?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface DnaProfileSearchDto extends CriteriaBase {
    andeSwabId?: string | undefined;
    collectionDate?: Date | undefined;
    collectedBy?: string | undefined;
    kitId?: number | undefined;
    markers?: { [key: string]: MarkerAllelesSearchDto; } | undefined;
}

export interface MarkerAllelesSearchDto {
    markerName?: string | undefined;
    allele1?: string | undefined;
    allele2?: string | undefined;
}

export interface EmploymentSearchDto extends CriteriaBase {
    occupation?: string | undefined;
    employerName?: string | undefined;
    employerCity?: string | undefined;
}

export interface IdentificationDocSearchDto extends CriteriaBase {
    idNumber?: string | undefined;
    idType: number;
    country?: string | undefined;
    stateOfIssuance?: string | undefined;
}

export interface AliasSearchDto extends CriteriaBase {
    alias?: string | undefined;
}

export interface SearchByQueryBuilder {
    query?: RuleGroupType | undefined;
}

export interface RuleBase {
    path?: number[] | undefined;
    id?: string | undefined;
    disabled?: boolean | undefined;
}

export interface RuleGroupType extends RuleBase {
    combinator?: string | undefined;
    rules?: RuleBase[] | undefined;
    not?: boolean | undefined;
}

export interface CreateOrUpdateTranslationRequestModel {
    key: string;
    language: string;
    translation: string;
}

export interface AddResourceAndTranslationRequestModel {
    key: string;
    language: string;
    translation: string;
}

export interface DetectedImportChange {
    changeType: ChangeType;
    selected: boolean;
    importingResource: LocalizationResource;
    existingResource: LocalizationResource;
    changedLanguages: LanguageModel[];
}

export enum ChangeType {
    None = 0,
    Insert = 1,
    Update = 2,
    Delete = 3,
}

export interface LocalizationResource {
    id: number;
    resourceKey: string;
    modificationDate: Date;
    author: string;
    fromCode: boolean;
    isModified?: boolean | undefined;
    isHidden?: boolean | undefined;
    notes: string;
    translations: LocalizationResourceTranslation[];
}

export interface LocalizationResourceTranslation {
    id: number;
    resourceId: number;
    language: string;
    value: string;
    modificationDate: Date;
}

export interface LanguageModel {
    code: string;
    display: string;
    titleDisplay: string;
}

export interface RemoveTranslationRequestModel {
    key: string;
    language: string;
}

export interface DeleteResourceRequestModel {
    key: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}